export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: string; output: string; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: string; output: string; }
  /** A field whose value conforms with the standard mongodb object ID as described here: https://docs.mongodb.com/manual/reference/method/ObjectId/#ObjectId. Example: 5e5677d71bdc2ae76344968c */
  ObjectID: { input: string; output: string; }
  /** The `SafeInt` scalar type represents non-fractional signed whole numeric values that are considered safe as defined by the ECMAScript specification. */
  SafeInt: { input: number; output: number; }
  /** A time string at UTC, such as 10:15:30Z, compliant with the `full-time` format outlined in section 5.6 of the RFC 3339profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Time: { input: string; output: string; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: string; output: string; }
  /** 문자열 값을 URL 포맷으로 검증합니다. */
  URLString: { input: string; output: string; }
  /** 년월을 `YYYY-MM` 포맷의 스트링으로 받고 유효한 날짜인지 검증합니다. */
  YearMonth: { input: string; output: string; }
};

/** 내게 들어온 팔로우 신청 수락시 필요한 입력값 */
export type AcceptFollowRequestInput = {
  /** 내게 팔로우 신청한 유저의 idno */
  followerIdno: Scalars['String']['input'];
};

export type AcceptFollowRequestOutput = AcceptFollowRequestSuccess | AuthenticationError | DuplicateAcceptFollowRequest | FollowCommonRequestFailed | NotFoundOpponentUser | UnknownError;

/** 내게 들어온 팔로우 신청 수락 성공시 응답 */
export type AcceptFollowRequestSuccess = {
  __typename?: 'AcceptFollowRequestSuccess';
  me: User;
  /** 상대방 유저 */
  other: User;
};

/** 페이 접근 실패 이유 */
export enum AccessFailureReason {
  /** 제 3자 제공 약관 v2 를 동의하지 않은 경우 (v1만 동의) */
  AgreedDeprecatedTerms = 'AGREED_DEPRECATED_TERMS',
  /** 자산/현장결제 연동 가능한 최소 나이 미만인 경우 (만 14세 미만) */
  NotQualifiedMinAge = 'NOT_QUALIFIED_MIN_AGE',
  /**
   * 가맹점명 제공 약관 동의하지 않은 경우
   * @deprecated 현장결제 도입후 정상연동카드 없어도 진입가능 [link](https://wiki.navercorp.com/pages/viewpage.action?pageId=1489508554#id-현장결제추가-제3자정보제공동의팝업(ver2))
   */
  NoAgreeMerchantName = 'NO_AGREE_MERCHANT_NAME',
  /** 제 3자 제공 약관 v1,v2 모두 미동의한 경우 (정상 연동카드는 존재) */
  NoAgreeTerms = 'NO_AGREE_TERMS',
  /**
   * 정상 카드가 존재하지 않는 경우
   * @deprecated 현장결제 도입후 정상연동카드 없어도 진입가능 [link](https://wiki.navercorp.com/pages/viewpage.action?pageId=1489508554#id-현장결제추가-제3자정보제공동의팝업(ver2))
   */
  NoHasNormalCard = 'NO_HAS_NORMAL_CARD',
  /** 페이 회원이 아니거나 마이데이터 약관에 동의하지 않은 경우 */
  NoPayMember = 'NO_PAY_MEMBER',
  /** 페이에서 시스템 점검 중 */
  SystemMaintenance = 'SYSTEM_MAINTENANCE'
}

/** 업주 권한 */
export type AccessorAuth = {
  __typename?: 'AccessorAuth';
  /** 업주 권한 인증 성공 여부 */
  canAccess: Scalars['Boolean']['output'];
};

export type AccessorAuthOutput = AccessorAuth | AuthenticationError | ForbiddenError | UnknownError;

export type AddPlaceBookmarkInput = {
  /** 주소 */
  address: Scalars['String']['input'];
  /** 즐겨찾기 별명 / displayName */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** 좌표 */
  coordinate: CoordinateInput;
  /** 즐겨찾기를 추가할 폴더 ID들 / null 혹은 필드 없이 요청 하면 default인 내 폴더에 저장 */
  folderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** 실내 지도 여부 */
  isIndoor?: InputMaybe<Scalars['Boolean']['input']>;
  /** 즐겨찾기 메모 */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** 즐겨찾기에 추가할 이름 / 장소 이름 */
  name: Scalars['String']['input'];
  /** 즐겨찾기 추가 할 장소 아이디 / sid */
  placeId: Scalars['String']['input'];
  /** 사용자가 입력한 URL / 즐겨찾기 관한 URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type AddPlaceBookmarkOutput = AddPlaceBookmark_Succeed | AuthenticationError | UnknownError;

export type AddPlaceBookmark_Succeed = {
  __typename?: 'AddPlaceBookmark_Succeed';
  /** 생성된 북마크 */
  bookmark: PlaceBookmark;
};

export type Address = {
  __typename?: 'Address';
  /** 위경도 좌표 */
  coordinate: Maybe<Coordinate>;
  /** 장소 북마크 여부 */
  isBookmarked: Scalars['Boolean']['output'];
  /** polygon 주소 여부 */
  isDetailAddress: Scalars['Boolean']['output'];
  /** 새 장소 여부 */
  isNewAddress: Scalars['Boolean']['output'];
  /** 지번 주소 */
  jibunAddress: Maybe<Scalars['String']['output']>;
  /** 매핑된 주소값 */
  mappedAddress: Maybe<Scalars['String']['output']>;
  /** 장소 이름 */
  name: Scalars['String']['output'];
  /** 네이버 코드 */
  rcode: Maybe<Scalars['String']['output']>;
  /** 도로명 주소 */
  roadAddress: Maybe<Scalars['String']['output']>;
};

export type AddressBookmark = Bookmark & {
  __typename?: 'AddressBookmark';
  /** 북마크한 장소 */
  address: Address;
  /** 즐겨찾기 별명 / API에서는 displayName 필드 / 지도에서 보일 이름 */
  alias: Scalars['String']['output'];
  /** 최근 매칭된 혹은 요청한 폴더에 대한 정보 / 일전 버그로 2000개 이상 저장된 북마크의 경우 null */
  bestMatchingMappingFolder: Maybe<BestMatchingMappingFolderInfo>;
  /** 북마크 아이디 */
  id: Scalars['Int']['output'];
  /** 매핑된 폴더 id 리스트 */
  mappingFolderIds: Array<Scalars['Int']['output']>;
  /** 북마크 메모 */
  memo: Maybe<Scalars['String']['output']>;
  /** 즐겨찾기에 추가된 이름 / 장소 이름 / Folder Detail 페이지에서 확인되는 이름 */
  name: Scalars['String']['output'];
  /** 즐겨찾기 타입 / address */
  type: BookmarkType;
  /** 외부 링크 */
  url: Maybe<Scalars['String']['output']>;
};

export type AddressFromCoordInput = {
  /** 지도 중심 좌표 */
  coordinate: CoordinateInput;
};

export type AddressFromMapsSearch = {
  __typename?: 'AddressFromMapsSearch';
  /** 동,면 이름 */
  displayName: Maybe<Scalars['String']['output']>;
  /** 지역코드 */
  regionCode: Maybe<Scalars['String']['output']>;
};

export type AllMyBookmarksInput = {
  /** 정보가 없거나 폐점하였는 장소 북마크에 해당, 제외, 모두 여부 */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** 조회할 bbox 영역 */
  bbox?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** 조회할 북마크 아이디 */
  bookmarkIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** 북마크 카테고리 */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** sort가 distance 일 때만 사용되는 값 */
  coordinate?: InputMaybe<CoordinateInput>;
  /** 장소 상세 정보 포함 // thumbnail 등의 정보가 있지만 true로 설정하면 받을 수 있는 북마크 limit 20개 false면 5천개 */
  placeInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** 북마크 범위 */
  range?: InputMaybe<FolderRange>;
  /** 폴더 share id */
  shareId?: InputMaybe<Scalars['ID']['input']>;
  /** 폴더 내 북마크 정렬 순서 */
  sort?: InputMaybe<BookmarkSortType>;
};

export type AllMyBookmarksOutput = AllMyBookmarks_Failed | AllMyBookmarks_Succeed;

/** 내 모든 북마크 리스트 조회를 실패했습니다. */
export type AllMyBookmarks_Failed = BaseError & {
  __typename?: 'AllMyBookmarks_Failed';
  /** 내 모든 북마크 리스트 조회를 실패했습니다. */
  message: Scalars['String']['output'];
};

/** 내 모든 북마크 조회 성공시 리턴합니다 */
export type AllMyBookmarks_Succeed = {
  __typename?: 'AllMyBookmarks_Succeed';
  /** 내 모든 북마크 수 */
  allCount: Scalars['Int']['output'];
  /** 조회한 북마크 리스트 */
  bookmarkList: Array<Bookmark>;
  /** 내 모든 이통 타입 북마크 수 // 이동 타입은 마플에서 사용하지 않음 */
  movementCount: Scalars['Int']['output'];
  /** 내 모든 장소 타입 북마크 수 */
  placeCount: Scalars['Int']['output'];
  /** 내 모든 장소 타입 북마크 수 중에서 정보가 없거나 폐점한 장소에 관한 북마크 수 */
  unavailableCount: Scalars['Int']['output'];
};

/** 인증 오류가 발생했습니다 */
export type AuthenticationError = BaseError & {
  __typename?: 'AuthenticationError';
  /** 인증 오류 발생시 전달할 코드 */
  code: Scalars['Int']['output'];
  /** 인증 오류 발생시 전달할 메세지 */
  message: Scalars['String']['output'];
};

/** 헤더에 Idno가 없습니다. */
export type Authentication_Failed = BaseError & {
  __typename?: 'Authentication_Failed';
  message: Scalars['String']['output'];
};

export type Author = DeletedUser | User;

/** 필드 조회 권한 */
export enum Authority {
  /** 본인에게만 권한이 있음 */
  Me = 'ME',
  /** 타인에게도 권한이 있음 */
  Others = 'OTHERS'
}

export type AutoCompletedPlacesInput = {
  /** 검색 중심 좌표 */
  coordinate?: InputMaybe<CoordinateInput>;
  /** 검색어 */
  query: Scalars['String']['input'];
};

export type BaseError = {
  message: Scalars['String']['output'];
};

/** 이 주변 저장 장소에서 쓰이는 필드로 모든 북마크를 가져오는 경우에는 API에 담긴 folderMappings 중 첫 번째 폴더 정보를, 각각의 폴더를 가져오는 shares API의 경우에는 해당 폴더 정보를 이용해 필드 생성 */
export type BestMatchingMappingFolderInfo = {
  __typename?: 'BestMatchingMappingFolderInfo';
  /** 생성일시 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 폴더 아이디  / 본인 권한 API 용 */
  id: Scalars['Int']['output'];
  /** 기본 폴더 여부 */
  isDefaultFolder: Scalars['Boolean']['output'];
  /** 색코드 */
  markerColor: Scalars['String']['output'];
  /** 폴더 이름 */
  name: Scalars['String']['output'];
  /** 오버레이 여부 */
  shouldOverlay: Scalars['Boolean']['output'];
};

export type BizItem = {
  __typename?: 'BizItem';
  /** 예약 상품 id */
  id: Maybe<Scalars['ID']['output']>;
  /** 예약 상품명 */
  name: Maybe<Scalars['String']['output']>;
};

/** 사용자를 차단하기 위해 필요한 값 */
export type BlockUserInput = {
  /** 차단할 사용자의 idno */
  userIdno: Scalars['String']['input'];
};

export type BlockUserOutput = BlockUser_Duplicated | BlockUser_Limit | BlockUser_MySelf | BlockUser_Succeed | UnknownError;

/** 이미 차단된 사용자를 차단할경우 응답 */
export type BlockUser_Duplicated = BaseError & {
  __typename?: 'BlockUser_Duplicated';
  message: Scalars['String']['output'];
};

/** 사용자 최대 차단수를 넘어설 경우 응답 */
export type BlockUser_Limit = BaseError & {
  __typename?: 'BlockUser_Limit';
  message: Scalars['String']['output'];
};

/** 본인을 차단했을 경우 응답 */
export type BlockUser_MySelf = BaseError & {
  __typename?: 'BlockUser_MySelf';
  message: Scalars['String']['output'];
};

/** 사용자 차단 성공 응답 */
export type BlockUser_Succeed = {
  __typename?: 'BlockUser_Succeed';
  success: Scalars['Boolean']['output'];
};

/** 블로그 리뷰 */
export type BlogReview = {
  __typename?: 'BlogReview';
  /** 작성자 */
  author: BlogReviewAuthor;
  /** 블로그 아이디 (https://m.blog.naver.com/:blogId) */
  blogId: Scalars['String']['output'];
  /** 포스트 넘버 (https://m.blog.naver.com/:blogId/:postNumber) */
  postNumber: Scalars['String']['output'];
  /** 블로그 리뷰 섬네일 이미지 URL */
  thumbnailUrl: Maybe<Scalars['URLString']['output']>;
  /** 블로그 리뷰 주소 */
  url: Scalars['URLString']['output'];
};

/** 블로그 리뷰 작성자 */
export type BlogReviewAuthor = {
  __typename?: 'BlogReviewAuthor';
  /** 닉네임 */
  nickname: Scalars['String']['output'];
  /** 프로필 이미지 */
  profileImageUrl: Maybe<Scalars['URLString']['output']>;
};

/** 예약에서 제공하는 배너 */
export type BookingBanner = {
  __typename?: 'BookingBanner';
  /** 배너 배경색 HEX 코드 e.g. `#FF0011` */
  backgroundColor: Maybe<Scalars['String']['output']>;
  /** 배너 아이디 (bannerResourceId) */
  id: Scalars['Int']['output'];
  /** 배너 이미지 url */
  imageUrl: Scalars['String']['output'];
  /** 배너 클릭시 이동할 url */
  url: Scalars['String']['output'];
};

export type BookingProof = Proof & {
  __typename?: 'BookingProof';
  /** 예약/주문에 포함된 `business` 정보 */
  business: Business;
  /** 예약/주문 상세 페이지 */
  detailURL: Maybe<Scalars['URLString']['output']>;
  /** 예약/주문 아이디(bookingId) - 예약팀에서 관리 */
  id: Scalars['ID']['output'];
  /** 별점이 필요한 리뷰 여부 (비지니스 카테고리가 `DL05`, `DL19` 인 업종) */
  isStarReviewRequired: Scalars['Boolean']['output'];
  /** 예약/주문 상품명 bizItem.name */
  menuTitle: Maybe<Scalars['String']['output']>;
  /** 예약/주문 결제 내역(메뉴) 목록 */
  menus: Array<Menu>;
  /** 총 결제 금액 - 해당 예약/주문의 결제 합산 */
  totalPayment: Maybe<Scalars['SafeInt']['output']>;
  /** 방문 증거 = 예약/주문 */
  type: ProofType;
  /** 예약/주문 발생 시간 */
  visitedDateTime: Scalars['DateTime']['output'];
};

export type BookingStat = {
  __typename?: 'BookingStat';
  /** 진행중인 예약 개수 */
  bookingCount: Scalars['Int']['output'];
  /**
   * [취소] 예약 개수
   * @deprecated 홈탭 적용이후 미사용
   */
  cancelledCount: Scalars['Int']['output'];
  /**
   * [완료] 예약 개수
   * @deprecated 홈탭 적용이후 미사용
   */
  completedCount: Scalars['Int']['output'];
  /**
   * [확정] 예약 개수
   * @deprecated 홈탭 적용이후 미사용
   */
  confirmedCount: Scalars['Int']['output'];
  /**
   * [노쇼] 예약 개수
   * @deprecated 홈탭 적용이후 미사용
   */
  noshowCount: Scalars['Int']['output'];
  /**
   * [확정] 예약 개수 중 업체에서 [접수]하기 전 상태의 예약 개수
   * @deprecated 홈탭 적용이후 미사용
   */
  orderConfirmedCount: Scalars['Int']['output'];
  /** 진행중인 주문 개수 */
  orderCount: Scalars['Int']['output'];
  /**
   * 진행중인 줄서기 개수
   * @deprecated 줄서기 보류로 제거
   */
  queueCount: Scalars['Int']['output'];
  /**
   * [신청] 예약 개수
   * @deprecated 홈탭 적용이후 미사용
   */
  requestedCount: Scalars['Int']['output'];
  /**
   * [확정] 예약 개수 중 업체에서 [접수]한 상태의 예약 개수 - [관련 이슈](https://oss.navercorp.com/booking/booking-web/issues/52050#issuecomment-10415274)
   * @deprecated 홈탭 적용이후 미사용
   */
  shopConfirmedOrderCount: Scalars['Int']['output'];
  /**
   * 총 예약 개수
   * @deprecated 홈탭 적용이후 미사용
   */
  totalCount: Scalars['Int']['output'];
};

export type Bookmark = {
  /** 즐겨찾기 별명 / API에서는 displayName 필드 / 지도에서 보일 이름 */
  alias: Scalars['String']['output'];
  /** 최근 매칭된 혹은 요청한 폴더에 대한 정보 / 일전 버그로 2000개 이상 저장된 북마크의 경우 null */
  bestMatchingMappingFolder: Maybe<BestMatchingMappingFolderInfo>;
  /** 북마크 아이디 */
  id: Scalars['Int']['output'];
  /** 매핑된 폴더 id 리스트 */
  mappingFolderIds: Array<Scalars['Int']['output']>;
  /** 북마크 메모 */
  memo: Maybe<Scalars['String']['output']>;
  /** 즐겨찾기에 추가된 이름 / 장소 이름 / Folder Detail 페이지에서 확인되는 이름 */
  name: Scalars['String']['output'];
  /** 즐겨찾기 타입 / place, address, route, subway, subwayPath, station, bus, busStop, bustStopLane / MY플레이스에서 사용되는 것은 place, address */
  type: BookmarkType;
  /** 외부 링크 */
  url: Maybe<Scalars['String']['output']>;
};

/** 북마크 타입 */
export enum BookmarkSortType {
  /** 생성 시간 */
  CreateTime = 'CREATE_TIME',
  /** 별명 */
  DisplayName = 'DISPLAY_NAME',
  /** 거리 */
  Distance = 'DISTANCE',
  /** 최근 사용 시간 */
  LastUseTime = 'LAST_USE_TIME',
  /** 이름 */
  Name = 'NAME'
}

/** 북마크 타입 */
export enum BookmarkType {
  /** 주소 */
  Address = 'ADDRESS',
  /** 장소 */
  Place = 'PLACE'
}

export type Broadcast = {
  __typename?: 'Broadcast';
  /** 방영된 메뉴 이름 */
  menu: Maybe<Scalars['String']['output']>;
  /** 방영 프로그램 이름 */
  showName: Scalars['String']['output'];
};

export type Business = {
  __typename?: 'Business';
  /** 업체 카테고리 ex) DL05 */
  categoryCode: Maybe<BusinessCategory>;
  /** 업체 아이디 */
  id: Scalars['ID']['output'];
  /** 업체명 */
  name: Maybe<Scalars['String']['output']>;
};

/** 업체 카테고리 */
export enum BusinessCategory {
  /** 기타 */
  Dl00 = 'DL00',
  /** 캠핑장 */
  Dl01 = 'DL01',
  /** 펜션 */
  Dl02 = 'DL02',
  /** 호텔_리조트 */
  Dl03 = 'DL03',
  /** 게스트하우스 */
  Dl04 = 'DL04',
  /** 행사_축제 */
  Dl05 = 'DL05',
  /** 식당 */
  Dl06 = 'DL06',
  /** 헤어샵 */
  Dl07 = 'DL07',
  /** 피부_체형관리 */
  Dl08 = 'DL08',
  /** 네일샵 */
  Dl09 = 'DL09',
  /** 체험학습_프로그램 */
  Dl10 = 'DL10',
  /** 레슨 */
  Dl11 = 'DL11',
  /** 학원 */
  Dl12 = 'DL12',
  /** 사진_스튜디오 */
  Dl13 = 'DL13',
  /** 대여_렌트 */
  Dl14 = 'DL14',
  /** 스포츠_레저 */
  Dl15 = 'DL15',
  /** 부동산 */
  Dl16 = 'DL16',
  /** 고장수리_출장 */
  Dl17 = 'DL17',
  /** 법륩_회계 */
  Dl18 = 'DL18',
  /** 공연_전시 */
  Dl19 = 'DL19',
  /** 공간대여 */
  Dl20 = 'DL20',
  /** 뷔페 */
  Dl21 = 'DL21',
  /** 프랜차이즈_레스토랑 */
  Dl22 = 'DL22',
  /** 아쿠아리움 */
  Dl23 = 'DL23',
  /** 아이스링크 */
  Dl24 = 'DL24',
  /** 테마파크 */
  Dl25 = 'DL25',
  /** 키즈카페 */
  Dl26 = 'DL26',
  /** 병의원 */
  Dl28 = 'DL28',
  /** 이색카페 */
  Dl29 = 'DL29',
  /** 미쉐린가이드 */
  Dl30 = 'DL30',
  /** 인기식당 */
  Dl31 = 'DL31',
  /** 한옥숙박 */
  Dl32 = 'DL32',
  /** 여행 */
  Dl33 = 'DL33',
  /** 보험 */
  Dl34 = 'DL34',
  /** 수리_PC_스마트폰 */
  Dl35 = 'DL35',
  /** 자동차정비 */
  Dl36 = 'DL36',
  /** 픽업서비스 */
  Dl37 = 'DL37',
  /** 강연_강좌 */
  Dl38 = 'DL38',
  /** 물놀이_테마파크 */
  Dl39 = 'DL39',
  /** 눈썰매장 */
  Dl40 = 'DL40',
  /** 배달_픽업서비스 */
  Dl41 = 'DL41',
  /** 관광시설 */
  Dl42 = 'DL42',
  /** 골프장 */
  Dl43 = 'DL43',
  /** 모텔 */
  Dl44 = 'DL44',
  /** 스키장 */
  Dl45 = 'DL45',
  /** 공방 */
  Dl46 = 'DL46',
  /** 낚시 */
  Dl47 = 'DL47',
  /** 실내골프장 */
  Dl48 = 'DL48',
  /** 해외시설 */
  Dl49 = 'DL49'
}

/** 팔로우 취소시 필요한 입력값 */
export type CancelFollowInput = {
  /** 팔로우 했던 유저의 idno */
  followingIdno: Scalars['String']['input'];
};

export type CancelFollowOutput = AuthenticationError | CancelFollowSuccess | FollowCommonRequestFailed | NotFoundOpponentUser | UnknownError;

/** 팔로우 신청 취소시 필요한 입력값 */
export type CancelFollowRequestInput = {
  /** 팔로우 신청했던 유저의 idno */
  followingIdno: Scalars['String']['input'];
};

export type CancelFollowRequestOutput = AuthenticationError | CancelFollowRequestSuccess | DuplicateCancelFollowRequest | FollowCommonRequestFailed | NotFoundOpponentUser | UnknownError;

/** 팔로우 신청 취소 성공시 응답 */
export type CancelFollowRequestSuccess = {
  __typename?: 'CancelFollowRequestSuccess';
  me: User;
  /** 상대방 유저 */
  other: User;
};

/** 팔로우 취소 성공시 응답 */
export type CancelFollowSuccess = {
  __typename?: 'CancelFollowSuccess';
  me: User;
  /** 상대방 유저 */
  other: User;
};

/** 카드 정보 */
export type Card = {
  __typename?: 'Card';
  /**
   * 카드 id
   * @deprecated id 값 사용
   */
  _id: Scalars['ID']['output'];
  /** 마이데이터 전송 동의 여부 */
  consent: Maybe<Scalars['Boolean']['output']>;
  /** 카드 id */
  id: Scalars['ID']['output'];
  /** 카드 이미지 URL */
  imageUrl: Maybe<Scalars['URLString']['output']>;
  /** 카드명 */
  name: Scalars['String']['output'];
};

/** 결제내역 갱신상태 */
export type CardJob = {
  __typename?: 'CardJob';
  /** 갱신 fail인 경우 이유 */
  reason: Maybe<Scalars['String']['output']>;
  /** 전체 갱신 상태 - 하나라도 running/fail이면 모두 running/fail */
  status: CardJobStatus;
};

/** 갱신 가능 시간 안내 */
export type CardJobAvailableTime = {
  __typename?: 'CardJobAvailableTime';
  /** 마이데이터(금융기관) 점검시간 여부 */
  isMydataUnavailableTime: Scalars['Boolean']['output'];
  /**
   * 내자산 마이데이터 점검시간 여부
   * @deprecated isMyDataUnavailableTime 로 대체
   */
  isNPayUnavailableTime: Scalars['Boolean']['output'];
  /** 점검 시간 문구 노출 여부 */
  isNoticeTime: Scalars['Boolean']['output'];
};

export type CardJobOutput = AuthenticationError | CardJob | ConflictError | UnknownError;

/** 결제내역 갱신상태 */
export enum CardJobStatus {
  /** 실패 */
  Failed = 'FAILED',
  /** 진행중 */
  Running = 'RUNNING',
  /** 성공 */
  Success = 'SUCCESS'
}

/** 카드 상태 알림 */
export enum CardNotice {
  /** 연결 만료 후 알림. 카드 만료일 > 조회일자 */
  Expired = 'EXPIRED',
  /** 새로 발급한 카드 알림 */
  HasNewCard = 'HAS_NEW_CARD',
  /** 연결 만료 전 알림. 카드 만료일 - 30일 <= 조회일자 */
  WillExpire = 'WILL_EXPIRE'
}

export type CardOutput = AuthenticationError | Card_Succeed | PaySession_Failed | UnknownError;

/** 카드 내역 페이지 접근 가능 */
export type CardPaymentAccess = {
  __typename?: 'CardPaymentAccess';
  /** 접근 거부 이유 */
  accessFailureReason: Maybe<AccessFailureReason>;
  /** 카드 내역 페이지 접근 가능 여부 */
  canAccess: Scalars['Boolean']['output'];
  /** 마이데이터 사용 가능 여부 */
  canUseMyData: Scalars['Boolean']['output'];
  /**
   * 카드 보유 여부
   * @deprecated 선불카드 추가되면서 필드명 변경
   */
  hasAvailableCard: Scalars['Boolean']['output'];
  /** 마이데이터 카드 보유 여부 */
  hasAvailableMyDataCard: Scalars['Boolean']['output'];
  /**
   * 이벤트 대상자 여부 - 이벤트기간 지났을경우 false
   * @deprecated 이벤트 계획 없음
   */
  isEventTarget: Scalars['Boolean']['output'];
};

export type CardPaymentAccessOutput = AuthenticationError | CardPaymentAccess | UnknownError;

/** 카드 정보 조회 성공 */
export type Card_Succeed = {
  __typename?: 'Card_Succeed';
  /** 카드 목록 */
  cards: Array<Card>;
  /** 카드 수(마이데이터 카드 + 선불 카드) */
  cardsCount: Scalars['Int']['output'];
  /** 가맹점명 제공 미동의 카드 보유여부 */
  hasNoMerchantNameCard: Scalars['Boolean']['output'];
  /** 마이데이터(금융사 연동) 카드 수 */
  myDataCardsCount: Scalars['Int']['output'];
  /** 카드 상태 알림 - 신규, 연결만료 */
  notice: Maybe<CardNotice>;
};

/** 지역별 카테고리 쿼리에 필요한 인풋 */
export type CategoriesByLocationInput = {
  /** 카테고리를 가져올 지역 코드 배열 */
  regionCodes: Array<Scalars['String']['input']>;
};

export type CategoriesByLocationOutput = CategoriesByLocationSucceed | UnknownError;

/** 지역별 카테고리 성공 응답 */
export type CategoriesByLocationSucceed = {
  __typename?: 'CategoriesByLocationSucceed';
  /** 카테고리 배열 */
  categories: Array<Category>;
};

export type Category = {
  __typename?: 'Category';
  /** 카테고리 아이디 = cid */
  id: Scalars['String']['output'];
  /** 카테고리 이름 */
  name: Scalars['String']['output'];
};

export type CategoryCollectionReviewer = {
  __typename?: 'CategoryCollectionReviewer';
  /** 리뷰 작성 유저 */
  author: User;
  /** 해당 카테고리에 대한 사진 리뷰 개수 */
  categoryPhotoReviewCount: Scalars['Int']['output'];
  /** 리뷰 작성 유저 idno / 캐시관리용 */
  id: Scalars['ID']['output'];
  /** 리뷰 추천 표시 여부 */
  isHidden: Scalars['Boolean']['output'];
  /** Collection에 보여질 리뷰들 */
  reviews: Array<CollectionReview>;
};

export type CategoryMapping = {
  __typename?: 'CategoryMapping';
  /** 즐겨찾기 지도 카테고리 아이디 / mcid */
  categoryId: Scalars['String']['output'];
  /** 즐겨찾기 지도 카테고리 이름 / mcidName */
  categoryName: Scalars['String']['output'];
};

export type CheckIn = {
  /** 체크인 ID */
  id: Scalars['ID']['output'];
  /** 체크인한 장소 */
  place: Maybe<Place>;
  /** 체크인 타입 */
  type: CheckInType;
};

export type CheckInProof = Proof & {
  __typename?: 'CheckInProof';
  /** proof에 대한 상세 페이지 */
  detailURL: Maybe<Scalars['URLString']['output']>;
  /** 체크인 proof id */
  id: Scalars['ID']['output'];
  /** 체크인에 메뉴 없음 */
  menus: Array<Menu>;
  /** 총 결제 금액 - 해당 방문증거의 결제 합산 */
  totalPayment: Maybe<Scalars['SafeInt']['output']>;
  /** 체크인 타입 */
  type: ProofType;
  /** 체크인 일시 */
  visitedDateTime: Scalars['DateTime']['output'];
};

/** 체크인 타입 */
export enum CheckInType {
  /** 내 주변 장소 체크인 */
  Gps = 'GPS',
  /** 사진/동영상 체크인 */
  Media = 'MEDIA',
  /** 장소 직접 검색 체크인 */
  Search = 'SEARCH'
}

export type CheckNickNameDuplicateOutput = {
  __typename?: 'CheckNickNameDuplicateOutput';
  isDuplicate: Scalars['Boolean']['output'];
};

export type CheckNickNameHasPwordOutput = {
  __typename?: 'CheckNickNameHasPwordOutput';
  pwords: Array<Scalars['String']['output']>;
};

/** 클린봇에 의해 검열된 텍스트가 있습니다. */
export type CleanBotError = BaseError & {
  __typename?: 'CleanBotError';
  message: Scalars['String']['output'];
  /** 클린봇 검열 상태코드 */
  status: ContentInspectionStatus;
};

export type CollectionReview = {
  __typename?: 'CollectionReview';
  /** 리뷰에 해당하는 장소 */
  placeName: Scalars['String']['output'];
  /** 리뷰에 해당하는 장소의 지역 */
  regionName: Scalars['String']['output'];
  /** 리뷰(그룹)의 아이디 */
  reviewGroupId: Scalars['ID']['output'];
  /** 썸네일 url */
  thumbnail: Scalars['String']['output'];
  /** 썸네일 이미지 타입 */
  type: Scalars['String']['output'];
};

export type CollectionReviewer = {
  __typename?: 'CollectionReviewer';
  /** 리뷰 작성 유저 */
  author: User;
  /** 리뷰 작성 유저 idno / 캐시관리용 */
  id: Scalars['ID']['output'];
  /** 리뷰 추천 표시 여부 */
  isHidden: Scalars['Boolean']['output'];
  /** Collection에 보여질 리뷰들 */
  reviews: Array<CollectionReview>;
};

/** 공용 추천 장소 */
export type CommonRecommendedLocation = Location & {
  __typename?: 'CommonRecommendedLocation';
  /** 해당 장소 주소 */
  address: Scalars['String']['output'];
  /** 화면 표기 이미지 파일 */
  displayImage: Scalars['String']['output'];
  /** 화면 표기 지역 이름 */
  displayName: Scalars['String']['output'];
  /** 지역 코드 */
  regionCode: Scalars['String']['output'];
  /** 지역 타입 */
  type: LocationType;
};

export type ConfirmProfileResetOutput = {
  __typename?: 'ConfirmProfileResetOutput';
  success: Scalars['Boolean']['output'];
};

/** 30초 이내 중복 갱신요청할 수 없습니다 */
export type ConflictError = BaseError & {
  __typename?: 'ConflictError';
  /** 인증 오류 발생시 전달할 코드 */
  code: Scalars['Int']['output'];
  /** 30초 이내 중복 갱신요청시 전달할 메세지 */
  message: Scalars['String']['output'];
};

/** 커넥션 인자 에러가 발생했습니다. */
export type ConnectionArgsError = BaseError & {
  __typename?: 'ConnectionArgsError';
  /** 커넥션 인자 에러 발생시 전달할 메세지 */
  message: Scalars['String']['output'];
};

/** 텍스트 검수 정보 */
export enum ContentInspectionStatus {
  /** 허락됨 */
  Approved = 'APPROVED',
  /** 검열됨 */
  Censored = 'CENSORED',
  /** 실패상태 - 검열 플랫폼의 장애나 내부적인 문제로 검열 결과를 받지 못할 경우 */
  Faield = 'FAIELD',
  /** 경고상태 */
  Warning = 'WARNING'
}

export type Coordinate = {
  __typename?: 'Coordinate';
  /** 위도 */
  latitude: Scalars['Float']['output'];
  /** 경도 */
  longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  /** 위도 */
  latitude: Scalars['Float']['input'];
  /** 경도 */
  longitude: Scalars['Float']['input'];
};

export type Coupon = {
  __typename?: 'Coupon';
  /** 종료 유효일시 */
  endDateTime: Scalars['DateTime']['output'];
  /**
   * 발급일로부터의 만료기간 (일 단위)
   * - 사용자 쿠폰의 유효기간 설정이 발행일 기준인 경우 not null
   * - 사용자 쿠폰의 유효기간 설정이 특정기간인 경우 null
   */
  expirationDuration: Maybe<Scalars['Int']['output']>;
  /** 쿠폰 이름 */
  name: Scalars['String']['output'];
  /** 쿠폰 SEQ */
  seq: Scalars['ID']['output'];
  /** 시작 유효일시 */
  startDateTime: Scalars['DateTime']['output'];
  /** 쿠폰 유형 */
  type: CouponType;
  /** 쿠폰 사용 가능 업체 */
  useType: CouponUseType;
};

/**
 * CRM 프로모션
 * 기획문서 [참고](https://oss.navercorp.com/booking/booking-web/issues/44057)
 */
export type CouponPromotion = {
  __typename?: 'CouponPromotion';
  /** 해당 프로모션의 쿠폰 목록 */
  coupons: Maybe<Array<CouponWithMetadata>>;
  /** 삭제일시 */
  deletedDateTime: Maybe<Scalars['DateTime']['output']>;
  /** 수정일시 */
  editedDateTime: Scalars['DateTime']['output'];
  /** 프로모션 종료일시 */
  endDateTime: Scalars['DateTime']['output'];
  /** 유저당 참여 제한 여부 */
  hasLimitPerUser: Scalars['Boolean']['output'];
  /** 활성화 여부 */
  isActive: Scalars['Boolean']['output'];
  /** 유저당 참여 제한 여부 */
  isAlways: Scalars['Boolean']['output'];
  /** 프로모션 참여 조건 타입 */
  joinConditionType: PlaceJoinConditionType;
  /**
   * 유저당 참여 제한 횟수
   * hasLimitPerUser가 false인 경우 비활성
   */
  limitCountPerUser: Maybe<Scalars['Int']['output']>;
  /** 프로모션 SEQ */
  seq: Scalars['ID']['output'];
  /** 프로모션 시작일시 */
  startDateTime: Scalars['DateTime']['output'];
  /** 프로모션 상태 */
  status: PromotionStatus;
  /** 프로모션 명 */
  title: Scalars['String']['output'];
};

/** 쿠폰 유형 */
export enum CouponType {
  /** 전체 결제 금액에 대하여 **정액** 할인 */
  DiscountTotalAmountByAmount = 'DISCOUNT_TOTAL_AMOUNT_BY_AMOUNT',
  /** 전체 결제 금액에 대하여 **정률** 할인 */
  DiscountTotalAmountByRate = 'DISCOUNT_TOTAL_AMOUNT_BY_RATE',
  /** 상품 증정 */
  Gift = 'GIFT'
}

/** 쿠폰 사용 가능 업체 */
export enum CouponUseType {
  /** 모든 업체 */
  All = 'ALL',
  /** 예약상품 사용중인 업체만 가능 */
  Booking = 'BOOKING',
  /** 주문상품 사용중인 업체만 가능 */
  Order = 'ORDER'
}

export type CouponWithMetadata = {
  __typename?: 'CouponWithMetadata';
  /** 쿠폰 */
  coupon: Coupon;
  /** 하루 발행 제한 수량 */
  dailyIssuedStock: Scalars['Int']['output'];
  /**
   * 발행 제한 여부
   * false인 경우 **무제한**
   */
  hasLimit: Scalars['Boolean']['output'];
  /** 쿠폰 노출 순서 */
  order: Scalars['Int']['output'];
  /** 오늘 발급 횟수 */
  todayDownloadedCount: Scalars['Int']['output'];
  /** 총 발급 횟수 */
  totalDownloadedCount: Scalars['Int']['output'];
  /** 총 발행 제한 수량 */
  totalIssuedStock: Scalars['Int']['output'];
};

export type CreateFolderInput = {
  /** 색코드 */
  colorCode: Scalars['String']['input'];
  /** 외부 링크 */
  externalLink?: InputMaybe<Scalars['String']['input']>;
  /** 공개범위 */
  isPublic: Scalars['Boolean']['input'];
  /** 폴더 메모 */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** 폴더 이름 */
  name: Scalars['String']['input'];
  /** 오버레이 여부 */
  shouldOverlay: Scalars['Boolean']['input'];
};

export type CreateFolderOutput = Authentication_Failed | CreateFolder_Failed | CreateFolder_Succeed;

/** 폴더 생성을 실패했습니다. */
export type CreateFolder_Failed = BaseError & {
  __typename?: 'CreateFolder_Failed';
  message: Scalars['String']['output'];
};

/** 폴더 생성 성공시 리턴합니다 */
export type CreateFolder_Succeed = {
  __typename?: 'CreateFolder_Succeed';
  /** 생성한 폴더 정보 */
  folder: Folder;
};

export type CreateItemDto = {
  count: Scalars['Int']['input'];
  currencyCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['SafeInt']['input']>;
  unitPrice?: InputMaybe<Scalars['SafeInt']['input']>;
};

export type CreateLocationCheckInOutput = AuthenticationError | LocationCheckIn | MobileAppOnlyError | UnknownError;

export type CreateMediaCheckInOutput = AuthenticationError | MediaCheckIn | MobileAppOnlyError | UnknownError;

/** 리뷰 답글 등록/수정 input */
export type CreateOrUpdateReviewGroupReplyInput = {
  /** 답글을 등록할 리뷰그룹 아이디 */
  reviewGroupId: Scalars['ID']['input'];
  /** 답글 텍스트 */
  text: Scalars['String']['input'];
};

export type CreateOrUpdateReviewGroupReplyOutput = AuthenticationError | CreateOrUpdateReviewGroupReplySucced | ForbiddenError | UnknownError;

/** 리뷰 답글 등록/수정 ouput */
export type CreateOrUpdateReviewGroupReplySucced = {
  __typename?: 'CreateOrUpdateReviewGroupReplySucced';
  /** 성공 여부 */
  success: Scalars['Boolean']['output'];
};

export type CreateReceiptOutput = EnrichedPostReceipt | PostFaultReceipt;

/** 리뷰그룹 생성시 전달하는 input 타입입니다. */
export type CreateReviewGroupInput = {
  /** 작성한 리뷰 그룹 내용, 필드 중 하나는 있어야 함 */
  content: ReviewContentInput;
  /** 클린봇(텍스트 검열) 무시 여부 */
  ignoreCleanBot?: InputMaybe<Scalars['Boolean']['input']>;
  /** 리뷰 그룹의 검수 상태 */
  inspectionStatus?: InputMaybe<InspectionStatus>;
  /** 업체의 기본 정보 */
  place?: InputMaybe<SubPlaceInput>;
  /** 리뷰에게 평가한 별점 (예약 리뷰의 경우 DL05, DL19일 때만 사용), 있을 경우에만 업데이트합니다. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** 리뷰그룹의 대표 pov 정보 */
  selectedProof: ReviewGroupSelectedProofInput;
  /** 방문 정보 */
  visit: ReviewGroupVisitInput;
};

export type CreateReviewGroupOutput = AuthenticationError | CleanBotError | CreateReviewGroup_Duplicated | CreateReviewGroup_NoContent | CreateReviewGroup_SelectedProofNotFound | CreateReviewGroup_Succeed | MobileAppOnlyError | ReviewGroupKeywordNotValid | ReviewGroupOverflowMaxKeywordCount | ReviewGroupOverflowMaxTextLength | UnknownError;

/** 해당 방문에 리뷰그룹이 이미 존재합니다 */
export type CreateReviewGroup_Duplicated = BaseError & {
  __typename?: 'CreateReviewGroup_Duplicated';
  /** 동일한 방문에 생성된 리뷰 그룹을 리턴합니다. 조회 실패시 null로 리턴합니다. */
  existingReviewGroup: Maybe<ReviewGroup>;
  message: Scalars['String']['output'];
  /** 리뷰그룹의 내용이 동일할 시 이동할 리뷰작성완료 페이지 URL을 제공합니다. */
  redirectURL: Scalars['URLString']['output'];
};

/** 리뷰 내용이 존재하지 않습니다. */
export type CreateReviewGroup_NoContent = BaseError & {
  __typename?: 'CreateReviewGroup_NoContent';
  message: Scalars['String']['output'];
};

/** 선택한 pov를 찾지 못했습니다. */
export type CreateReviewGroup_SelectedProofNotFound = BaseError & {
  __typename?: 'CreateReviewGroup_SelectedProofNotFound';
  message: Scalars['String']['output'];
};

/** 리뷰그룹 생성 성공시 리턴합니다 */
export type CreateReviewGroup_Succeed = {
  __typename?: 'CreateReviewGroup_Succeed';
  /** 리뷰그룹 생성 이후 이동할 URL */
  redirectUrl: Scalars['String']['output'];
  /** 생성된 리뷰그룹 */
  reviewGroup: ReviewGroup;
  /**
   * 스탬프가 찍힌 미션그룹
   * @deprecated 클라이언트에서 사용하지 않는 필드
   */
  stampedMissionGroups: Array<MissionGroup>;
};

export type CreateSearchCheckInOutput = AuthenticationError | MobileAppOnlyError | SearchCheckIn | UnknownError;

/** 테마리스트 생성시 전달할 정보입니다. */
export type CreateThemelistInput = {
  /** 테마리스트 커버용 미디어 */
  coverMediaItem: MediaItemInput;
  /** 테마리스트 설명 */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 테마리스트 전체 공개 여부 */
  isPublic: Scalars['Boolean']['input'];
  /** 테마리스트에 추가할 리뷰그룹 아이디 목록 */
  reviewGroupIds: Array<Scalars['String']['input']>;
  /** 테마리스트 제목 */
  title: Scalars['String']['input'];
};

/** 테마리스트 생성시 리턴하는 유니언 타입입니다. */
export type CreateThemelistOutput = AuthenticationError | CreateThemelistSucceed | UnknownError;

/** 테마리스트 생성 성공시 리턴하는 타입입니다. */
export type CreateThemelistSucceed = {
  __typename?: 'CreateThemelistSucceed';
  /** 생성한 테마리스트 */
  themelist: Themelist;
};

export type CreateVisitInput = {
  items?: InputMaybe<Array<InputMaybe<CreateItemDto>>>;
  /** 자동매칭된 장소 개수 */
  matchedPlacesCount?: InputMaybe<Scalars['Int']['input']>;
  /** 방문 장소 */
  place: VisitSubPlaceInput;
  /** 방문생성에 사용된 pov */
  proof: VisitSubProofInput;
  /** 매칭장소 직접검색시 검색된 단어 */
  searchValue?: InputMaybe<Scalars['String']['input']>;
  totalPrice?: InputMaybe<Scalars['SafeInt']['input']>;
  visitDateTime: Scalars['DateTime']['input'];
};

/** 방문 생성시 리턴 타입입니다. */
export type CreateVisitOutput = AuthenticationError | CreateVisit_Succeed | DuplicatedError | EntityError | ForbiddenError | FutureDateError | InvalidDateTimeError | InvalidPastDateError | MaxProofError | MobileAppOnlyError | UnknownError;

/** 방문생성 성공 */
export type CreateVisit_Succeed = {
  __typename?: 'CreateVisit_Succeed';
  /** 생성된 방문 */
  visit: Visit;
};

/** 날짜 범위 필터 */
export type DateTimeRangeInput = {
  /** 시작 날짜 */
  from?: InputMaybe<Scalars['DateTime']['input']>;
  /** 끝나는 날짜 */
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/** 장식 */
export type Decoration = {
  __typename?: 'Decoration';
  /** 장식 생성 일시 */
  createdDateTime: Scalars['DateTime']['output'];
  /**
   * 노출 종료 일시
   * @deprecated 클라이언트에서 사용하지 않는 필드
   */
  expiredDateTime: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  /** 장식 asset url - 노출기간 지난 경우 null 반환 */
  imageUrl: Maybe<Scalars['URLString']['output']>;
  /** 장식 이름 */
  name: Scalars['String']['output'];
  /** 장식 타입 ex. "프로필 테두리" , ... */
  type: DecorationType;
  /** 장식 수정 일시 */
  updatedDateTime: Maybe<Scalars['DateTime']['output']>;
};

/** 장식 유형 */
export enum DecorationType {
  /** 프로필 테두리 유형, 테두리 asset의 image를 전달합니다. */
  ProfileBorder = 'PROFILE_BORDER'
}

export type DeleteFolderInput = {
  /** 폴더 아이디 */
  folderId: Scalars['Int']['input'];
};

export type DeleteFolderOutput = Authentication_Failed | DeleteFolder_Failed | DeleteFolder_Succeed;

/** 폴더 삭제를 실패했습니다. */
export type DeleteFolder_Failed = BaseError & {
  __typename?: 'DeleteFolder_Failed';
  message: Scalars['String']['output'];
};

/** 폴더 삭제 성공시 반환 */
export type DeleteFolder_Succeed = {
  __typename?: 'DeleteFolder_Succeed';
  id: Scalars['Int']['output'];
};

export type DeleteMediaInput = {
  /** 삭제할 미디어 정보 목록 */
  mediaItems: Array<DeleteMediaItemInput>;
};

export type DeleteMediaItem = {
  __typename?: 'DeleteMediaItem';
  /** 삭제할 미디어 아이디 */
  id: Scalars['ID']['output'];
  /** 삭제할 미디어의 타입 */
  type: MediaType;
};

export type DeleteMediaItemInput = {
  /** 삭제할 미디어 아이디 */
  id: Scalars['ID']['input'];
  /** 삭제할 미디어의 타입 */
  type?: InputMaybe<MediaType>;
};

/** 미디어 삭제시 리턴하는 타입입니다. */
export type DeleteMediaOutput = DeleteMediaSucceed | UnknownError;

/** 삭제 성공시 리턴합니다. */
export type DeleteMediaSucceed = {
  __typename?: 'DeleteMediaSucceed';
  /** 삭제된 미디어 목록 */
  mediaItems: Array<DeleteMediaItem>;
};

/** 리뷰그룹 삭제시 전달할 인자입니다 */
export type DeleteReviewGroupInput = {
  /** 삭제할 리뷰그룹의 아이디 */
  id: Scalars['ID']['input'];
};

/** 리뷰그룹 삭제시 리턴하는 타입입니다 */
export type DeleteReviewGroupOutput = AuthenticationError | DeleteReviewGroup_Succeed | ForbiddenError | UnknownError;

/** 리뷰 답글 삭제 input */
export type DeleteReviewGroupReplyInput = {
  /** 답글을 삭제할 리뷰그룹 아이디 */
  reviewGroupId: Scalars['ID']['input'];
};

export type DeleteReviewGroupReplyOutput = AuthenticationError | DeleteReviewGroupReplySucceed | ForbiddenError | UnknownError;

/** 리뷰 답글 삭제 ouput */
export type DeleteReviewGroupReplySucceed = {
  __typename?: 'DeleteReviewGroupReplySucceed';
  /** 성공 여부 */
  success: Scalars['Boolean']['output'];
};

/** 리뷰그룹 삭제 성공시 리턴합니다. */
export type DeleteReviewGroup_Succeed = {
  __typename?: 'DeleteReviewGroup_Succeed';
  /** 삭제한 리뷰그룹의 아이디 */
  id: Scalars['ID']['output'];
  /** 리뷰그룹 삭제 이후 이동할 URL [Spec Wiki](https://wiki.navercorp.com/pages/viewpage.action?pageId=987057827#:~:text=%EC%98%88%20%EC%84%A0%ED%83%9D%20%E2%86%92%20%ED%8C%9D%EC%97%85%20%EB%8B%AB%ED%9E%88%EA%B3%A0%20%ED%98%84%EC%9E%AC%20%EB%A6%AC%EB%B7%B0%20%EC%82%AD%EC%A0%9C%EB%90%98%EB%A9%B4%EC%84%9C%20MY%ED%94%8C%EB%A0%88%EC%9D%B4%EC%8A%A4%20%EB%A6%AC%EB%B7%B0%20%ED%83%AD%EC%9C%BC%EB%A1%9C%20%EC%9D%B4%EB%8F%99) */
  redirectUrl: Scalars['String']['output'];
  /**
   * 스탬프가 취소된 미션그룹 배열
   * @deprecated 사용하지 않는 필드
   */
  revertedMissionGroups: Array<MissionGroup>;
};

export type DeleteThemelistOutput = AuthenticationError | DeleteThemelist_Succeed | ForbiddenError | NotFoundError | UnknownError;

/** 테마리스트 삭제 성공 */
export type DeleteThemelist_Succeed = {
  __typename?: 'DeleteThemelist_Succeed';
  /** 삭제된 테마리스트 id */
  deletedId: Scalars['String']['output'];
};

/** 방문 삭제시 리턴 타입입니다. */
export type DeleteVisitOutput = AuthenticationError | DeleteVisit_Succeed | ForbiddenError | UnknownError | Visit_NotFound;

/** 방문삭제 성공 */
export type DeleteVisit_Succeed = {
  __typename?: 'DeleteVisit_Succeed';
  /** 삭제된 방문 ID */
  deletedId: Scalars['String']['output'];
  /** 스탬프가 취소된 미션그룹 배열 */
  revertedMissionGroups: Array<MissionGroup>;
};

export type DeletedFolder = {
  __typename?: 'DeletedFolder';
  /** 폴더 작성자 */
  author: Maybe<Author>;
  /** 색코드 / markerColor로 대체되었으나 지도 BE에서 deleted 폴더에 한해 markerColor는 null이며 colorCode 값만 내려줌 */
  colorCode: Scalars['String']['output'];
  /** 외부 링크 */
  externalLink: Scalars['String']['output'];
  /** 구독자 수 */
  followCount: Scalars['Int']['output'];
  /** 팔로잉 아이디 / 팔로잉 폴더가 아닌 경우 null */
  followId: Maybe<Scalars['Int']['output']>;
  /** 아이콘 아이디 */
  iconId: Scalars['String']['output'];
  /** 기본 폴더 여부 */
  isDefaultFolder: Scalars['Boolean']['output'];
  /** 내 폴더인지 여부 */
  isMine: Scalars['Boolean']['output'];
  /** 공개 여부 / S: 공개, N: 비공개, R: 사용하지 않음(fade out) / S와 R은 isPublic true, N은 isPublic false */
  isPublic: Scalars['Boolean']['output'];
  /** 삭제 여부 / false: 정상, true: 소유자가 리스트를 삭제하였으나 구독자가 존재하는 상태 */
  isRemoved: Scalars['Boolean']['output'];
  /** 폴더 메모 */
  memo: Scalars['String']['output'];
  /** 폴더 이름 */
  name: Scalars['String']['output'];
  /** 공유 아이디 / 권한 체크 로직 포함 조회 API 용 */
  shareId: Scalars['ID']['output'];
  /** 오버레이 여부 */
  shouldOverlay: Scalars['Boolean']['output'];
  /** 조회 수 */
  viewCount: Scalars['Int']['output'];
};

export type DeletedUser = {
  __typename?: 'DeletedUser';
  idno: Maybe<Scalars['String']['output']>;
  /** 마이플레이스 전용 프로필 */
  profile: Profile;
};

/** 유저에게 지역을 추천하는 이유 */
export enum DisplayRecommendedReason {
  /** 자주 검색한 */
  FrequentSeach = 'FREQUENT_SEACH',
  /** 자주 방문한 */
  FrequentVisit = 'FREQUENT_VISIT',
  /** 관심 지역 주변 인기 */
  PopularAroundInteters = 'POPULAR_AROUND_INTETERS',
  /** 최근 검색한 */
  RecentSearchContent = 'RECENT_SEARCH_CONTENT',
  /** 함께 추천하는 */
  RecommendedTogether = 'RECOMMENDED_TOGETHER',
  /** 곧 방문할 */
  WInAShortTimeVisit = 'W_IN_A_SHORT_TIME_VISIT'
}

/** 이미 수락한 팔로우 신청일시 응답 */
export type DuplicateAcceptFollowRequest = BaseError & {
  __typename?: 'DuplicateAcceptFollowRequest';
  message: Scalars['String']['output'];
};

/** 이미 팔로우 신청 취소한 유저일시 응답 */
export type DuplicateCancelFollowRequest = BaseError & {
  __typename?: 'DuplicateCancelFollowRequest';
  message: Scalars['String']['output'];
};

/** 이미 팔로우 신청시 응답 */
export type DuplicateFollowRequest = BaseError & {
  __typename?: 'DuplicateFollowRequest';
  message: Scalars['String']['output'];
};

/** 닉네임 중복시 에러를 리턴합니다. */
export type DuplicateNicknameError = BaseError & {
  __typename?: 'DuplicateNicknameError';
  duplicatedNickname: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** 중복된 요청입니다 */
export type DuplicatedError = BaseError & {
  __typename?: 'DuplicatedError';
  code: Scalars['Int']['output'];
  /** 중복된 요청일때 전달할 메세지 */
  message: Scalars['String']['output'];
  reason: Maybe<Scalars['String']['output']>;
};

/** connection에서 사용되는 edge 인터페이스 타입 */
export type Edge = {
  /** edge의 cursor */
  cursor: Scalars['String']['output'];
};

/** 아직 아무런 스탬프가 찍히지 않은 활동 내역 */
export type EmptyMissionActivity = MissionActivity & {
  __typename?: 'EmptyMissionActivity';
  id: Scalars['ObjectID']['output'];
  /** 미션 별 메타 정보(마지막 미션 완료 일시)를 담고 있는 배열 */
  missionStates: Array<MissionState>;
};

/** 업로드된 영수증 데이터 중 방문생성에 필요한 데이터만 후처리한 타입 - REST API 로 제공되는 타입, Graphql 레이어에서 사용되지 않음 */
export type EnrichedPostReceipt = {
  __typename?: 'EnrichedPostReceipt';
  frontendImageUrl: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** ocr 매칭장소를 Partial Place로 변환한 타입 */
  matchedPlaces: Array<MatchedPlace>;
  menus: Array<Menu>;
  /** ocr 방문일시 - 날짜값과 시간값을 각각 반환합니다 */
  ocrVisitDateTime: PostReceiptVisitDateTime;
  /**
   * ocr 방문일시를 현시점 이전, 유효한 방문일시로 보정해준 값 후처리 한 값 [link](https://oss.navercorp.com/place/local/packages/api/src/receipt/post-receipt/post-receipt.md)
   * @deprecated 방문일시가 유효하지 않을 경우 유저가 직접 입력하는 스펙으로 변경 [link](https://oss.navercorp.com/place/local/issues/14169)
   */
  processedVisitDateTime: Scalars['DateTime']['output'];
  /** 총 금액 - 메뉴별 가격 합산 [후처리](https://oss.navercorp.com/place/local/issues/9933#issuecomment-8772713) */
  totalPrice: Maybe<Scalars['SafeInt']['output']>;
  /** ocr 방문일시 */
  visitDateTime: Maybe<Scalars['DateTime']['output']>;
};

/** 적합하지 않은 데이터입니다 */
export type EntityError = BaseError & {
  __typename?: 'EntityError';
  code: Scalars['Int']['output'];
  /** 입력받은 데이터가 적합하지 않을 때 전달할 메세지 */
  message: Scalars['String']['output'];
};

export type Feed = {
  __typename?: 'Feed';
  /** 리뷰 작성자 */
  author: User;
  /** 리뷰(그룹)이 생성된 시간 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 피드 리뷰 타입 / 피드 리뷰 위의 메세지를 결정 짓기 위해 사용 / e.g. 팔로잉 리뷰어의 새 리뷰 */
  feedReviewType: FeedReviewType;
  /** 피드 아이디 / cursor로 next 지목시 필요 */
  id: Scalars['ID']['output'];
  /** 리뷰에 등록된 영상 및 사진 */
  mediaItems: Array<MediaItem>;
  /** 리뷰 대상 장소, 폐업하면 null */
  place: Maybe<Place>;
  /** 리뷰에게 평가한 별점 */
  rating: Maybe<Scalars['Float']['output']>;
  /** 리뷰그룹 */
  reviewGroup: ReviewGroup;
  /** 리뷰(그룹)의 아이디 */
  reviewGroupId: Scalars['String']['output'];
  /** 리뷰 내용 */
  text: Maybe<Scalars['String']['output']>;
  /** 총 미디어 수 */
  totalMediaCount: Scalars['Int']['output'];
  /** 방문 시간 */
  visitedDateTime: Scalars['DateTime']['output'];
  /** 리뷰에 선택된 키워드배열 */
  votedKeywords: Array<Keyword>;
};

/** 피드 리뷰 타입 */
export enum FeedReviewType {
  Friend = 'FRIEND',
  Location = 'LOCATION',
  Place = 'PLACE'
}

/** 피드 타입 */
export enum FeedType {
  /** 팔로잉 피드 */
  Following = 'FOLLOWING',
  /** 지역 관련 피드 */
  Location = 'LOCATION'
}

export type FeedsInput = {
  /** 피드를 가져올 categoryCode */
  categoryCode: Scalars['String']['input'];
  /** 가져올 피드 개수 */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** 피드 타입 / 팔로잉 or 지역 관련 */
  feedType: FeedType;
  /** 가져올 피드 이전의 피드 id */
  next?: InputMaybe<Scalars['String']['input']>;
  /** 피드를 가져올 regionCode */
  regionCode: Scalars['String']['input'];
  /** 피드를 가져올 regionCodes */
  regionCodes: Array<Scalars['String']['input']>;
  /** 피드에서 노출되는 지역탭 */
  tab: LocationTab;
};

export type FeedsOutput = Feeds_Succeed | UnknownError;

/** 피드 조회 성공시 리턴합니다 */
export type Feeds_Succeed = {
  __typename?: 'Feeds_Succeed';
  /** 피드 */
  feeds: Array<Feed>;
  /** 마지막 피드인지 여부 */
  isFinished: Scalars['Boolean']['output'];
};

/** 타인뷰에서 사용하는 카테고리 정보, deprecated */
export type FeverPlaceCategory = {
  __typename?: 'FeverPlaceCategory';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reviewGroupsCount: Scalars['Int']['output'];
};

export type Folder = {
  __typename?: 'Folder';
  /** 폴더 작성자 */
  author: Maybe<Author>;
  /** 즐겨찾기 수 */
  bookmarkCount: Scalars['Int']['output'];
  /** 북마크 리스트 */
  bookmarkList: Maybe<Array<Bookmark>>;
  /**
   * 색코드
   * @deprecated markerColor로 대체
   */
  colorCode: Scalars['String']['output'];
  /** 생성일시 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 외부 링크 */
  externalLink: Scalars['String']['output'];
  /** 구독자 수 */
  followCount: Scalars['Int']['output'];
  /** 팔로잉 아이디 / 팔로잉 폴더가 아닌 경우 null */
  followId: Maybe<Scalars['Int']['output']>;
  /** 아이콘 아이디 */
  iconId: Scalars['String']['output'];
  /** 폴더 아이디 / 본인 권한 API 용 */
  id: Scalars['Int']['output'];
  /** 기본 폴더 여부 */
  isDefaultFolder: Scalars['Boolean']['output'];
  /** 내 폴더인지 여부 */
  isMine: Scalars['Boolean']['output'];
  /** 공개 여부 / S: 공개, N: 비공개, R: 사용하지 않음(fade out) / S와 R은 isPublic true, N은 isPublic false */
  isPublic: Scalars['Boolean']['output'];
  /** 삭제 여부 / false: 정상, true: 소유자가 리스트를 삭제하였으나 구독자가 존재하는 상태 */
  isRemoved: Scalars['Boolean']['output'];
  /** 최근 사용 / 변경일시 */
  lastUsedDateTime: Scalars['DateTime']['output'];
  /** 색코드 */
  markerColor: Scalars['String']['output'];
  /** 폴더 메모 */
  memo: Scalars['String']['output'];
  /** 폴더 이름 */
  name: Scalars['String']['output'];
  /** 공유 아이디 / 권한 체크 로직 포함 조회 API 용 */
  shareId: Scalars['ID']['output'];
  /** 오버레이 여부 */
  shouldOverlay: Scalars['Boolean']['output'];
  /** 장소에 대한 정보를 찾을 수 없거나 폐업된 즐겨찾기 수 */
  unavailableBookmarkCount: Scalars['Int']['output'];
  /** 조회 수 */
  viewCount: Scalars['Int']['output'];
};

export type FolderCategoriesOutput = Authentication_Failed | FolderCategories_Failed | FolderCategories_Succeed;

/** 폴더 카테고리 조회를 실패했습니다. */
export type FolderCategories_Failed = BaseError & {
  __typename?: 'FolderCategories_Failed';
  message: Scalars['String']['output'];
};

/** 폴더가 가지고 있는 카테고리들 조회 성공시 반환 */
export type FolderCategories_Succeed = {
  __typename?: 'FolderCategories_Succeed';
  categories: Array<CategoryMapping>;
};

export type FolderDeletedOrNot = DeletedFolder | Folder;

/** 폴더 리스트 타입 */
export enum FolderList {
  /** 전체 폴더 / 내 폴더 + 팔로우 폴더 */
  All = 'ALL',
  /** 팔로우 폴더 */
  Follow = 'FOLLOW',
  /** 내 폴더 */
  My = 'MY'
}

export type FolderRange = {
  /** 폴더 or 북마크 개수 */
  limit: Scalars['Int']['input'];
  /** 시작 위치 / 현재 소트는 항상 최신 등록순이기에 최근 저장한 것을 0으로 시작하여 카운트 */
  start: Scalars['Int']['input'];
};

/** 팔로우 관련 요청 공통 실패 응답 */
export type FollowCommonRequestFailed = BaseError & {
  __typename?: 'FollowCommonRequestFailed';
  message: Scalars['String']['output'];
};

export type FollowFolderInput = {
  /** 폴더 공유 아이디 */
  shareId: Scalars['String']['input'];
};

export type FollowFolderOutput = Authentication_Failed | FollowFolder_Failed | FollowFolder_Succeed;

/** 폴더 팔로우를 실패했습니다. */
export type FollowFolder_Failed = BaseError & {
  __typename?: 'FollowFolder_Failed';
  message: Scalars['String']['output'];
};

/** 폴더 팔로우(즐겨찾기 추가) 성공시 리턴합니다 */
export type FollowFolder_Succeed = {
  __typename?: 'FollowFolder_Succeed';
  /** 폴더 및 해당 폴더 팔로잉 아이디 */
  followingFolderMapping: FollowingFolderMapping;
};

/** 팔로우 신청시 필요한 입력값 */
export type FollowRequestInput = {
  /** 팔로우 신청을 받는 유저의 idno */
  followingIdno: Scalars['String']['input'];
};

export type FollowRequestOutput = AuthenticationError | DuplicateFollowRequest | FollowCommonRequestFailed | FollowRequestSuccess | NotFoundOpponentUser | UnknownError;

/** 팔로우 신청 성공시 응답 */
export type FollowRequestSuccess = {
  __typename?: 'FollowRequestSuccess';
  /** 상대방의 팔로우 자동 수락 여부 */
  isAutoAccept: Scalars['Boolean']['output'];
  me: User;
  /** 상대방 유저 */
  other: User;
};

export type FollowingFolderMapping = {
  __typename?: 'FollowingFolderMapping';
  /** 폴더 아이디 */
  folderId: Scalars['Int']['output'];
  /** 해당 폴더 팔로잉 아이디 */
  followId: Scalars['Int']['output'];
};

export type FollowingUsersFeedsOnOtherLocationsOutput = FollowingUsersFeedsOnOtherLocationsSucceed | UnknownError;

/** 팔로잉 리뷰어가 간 다른 지역 피드 */
export type FollowingUsersFeedsOnOtherLocationsSucceed = {
  __typename?: 'FollowingUsersFeedsOnOtherLocationsSucceed';
  /** 피드 */
  feeds: Array<Feed>;
};

/** 접근 권한이 없습니다 */
export type ForbiddenError = BaseError & {
  __typename?: 'ForbiddenError';
  /** 권한 오류 발생시 전달할 코드 */
  code: Scalars['Int']['output'];
  /** 권한 오류 발생시 전달할 메세지 */
  message: Scalars['String']['output'];
};

/** 방문 생성 시점보다 미래 날짜로 방문일시 설정시 리턴합니다. */
export type FutureDateError = BaseError & {
  __typename?: 'FutureDateError';
  message: Scalars['String']['output'];
};

export type GradeHistory = {
  __typename?: 'GradeHistory';
  /** 리뷰어활동 제한 여부 */
  isUnavailable: Scalars['Boolean']['output'];
  /** grey 유저인경우 리뷰어활동 제한 종료일시 */
  unavailableUntil: Maybe<Scalars['DateTime']['output']>;
};

/** 리뷰어 추천 제외 응답 */
export type HideReviewerFromRecommendationOutput = {
  __typename?: 'HideReviewerFromRecommendationOutput';
  /** 뮤테이션 성공 여부 */
  success: Scalars['Boolean']['output'];
};

export type HideVisitInput = {
  /** 숨김처리할 방문의 id */
  visitId: Scalars['String']['input'];
};

export type HideVisitOutput = AuthenticationError | ForbiddenError | HideVisitSucceed | MaxCacheCountError | NotFoundError | UnknownError;

/** 방문 숨김 성공 */
export type HideVisitSucceed = {
  __typename?: 'HideVisitSucceed';
  /** 숨김처리된 방문 id */
  visitId: Scalars['String']['output'];
};

export type Holiday = {
  __typename?: 'Holiday';
  /** 공휴일 이름 */
  name: Scalars['String']['output'];
};

/** 동영상이 불법촬영물일 경우 리턴합니다. */
export type IllegalVideo = BaseError & {
  __typename?: 'IllegalVideo';
  message: Scalars['String']['output'];
};

/** 이미지 아이템입니다. */
export type ImageItem = MediaItem & {
  __typename?: 'ImageItem';
  /** 미디어 파일 형식 */
  format: Maybe<Scalars['String']['output']>;
  /** 미디어 이미지 세로 길이 */
  height: Maybe<Scalars['Int']['output']>;
  /** 이미지 아이디 */
  id: Scalars['ID']['output'];
  /** 대표 이미지 여부 */
  isCover: Maybe<Scalars['Boolean']['output']>;
  /** 미디어 파일크기 */
  size: Maybe<Scalars['Int']['output']>;
  /** 미디어의 타입 (`IMAGE`) */
  type: MediaType;
  /** 이미지의 URL */
  url: Scalars['URLString']['output'];
  /** 미디어 이미지 가로 길이 */
  width: Maybe<Scalars['Int']['output']>;
};

/** 리뷰 조회수 증가 input */
export type IncreaseReviewGroupsViewInput = {
  /** 리뷰그룹 아이디 배열 */
  ids: Array<Scalars['ID']['input']>;
};

export type IncreaseReviewGroupsViewOutput = IncreaseReviewGroupsViewsSucced | UnknownError;

/** 리뷰 그룹 조회 성공시 리턴 타입 */
export type IncreaseReviewGroupsViewsSucced = {
  __typename?: 'IncreaseReviewGroupsViewsSucced';
  /** 성공 여부 */
  success: Scalars['Boolean']['output'];
};

/** 테마리스트 조회수 증가 input */
export type IncreaseThemelistViewInput = {
  /** 테마리스트 아이디 */
  id: Scalars['ID']['input'];
};

export type IncreaseThemelistViewOutput = IncreaseThemelistViewSucceed | UnknownError;

/** 테마리스트 조회수 증가 성공시 리턴 타입 */
export type IncreaseThemelistViewSucceed = {
  __typename?: 'IncreaseThemelistViewSucceed';
  /** 성공 여부 */
  success: Scalars['Boolean']['output'];
};

/** 이미지가 선정적일시 에러를 리턴합니다 */
export type InspectedImageError = BaseError & {
  __typename?: 'InspectedImageError';
  inspectedImageUrl: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** 검수 정보 */
export enum InspectionStatus {
  /** 운영자가 검수를 안해도 통과 상태, 리뷰상태는 Showable이 될 수 있다. */
  Approved = 'APPROVED',
  /** 운영자가 검수를 안해도 반려 상태, 리뷰상태는 InspectReject가 된다. */
  Rejected = 'REJECTED',
  /** 운영자가 검수 전 상태, 리뷰상태는 Showable이 될 수 있다. */
  WaitingForReview = 'WAITING_FOR_REVIEW',
  /** SYSTEM이 validation 전 상태, 리뷰상태는 Hide가 된다. */
  WaitingForValidation = 'WAITING_FOR_VALIDATION'
}

/** 관심 장소 */
export type InterestingLocation = Location & {
  __typename?: 'InterestingLocation';
  /** 좌표 */
  coordinate: Coordinate;
  /** 화면 표기 지역 이름 */
  displayName: Scalars['String']['output'];
  /** 지역 전체 이름 */
  fullName: Maybe<Scalars['String']['output']>;
  /** 지역 코드 */
  regionCode: Scalars['String']['output'];
  /** 지역 타입 */
  type: LocationType;
};

/** 유효하지 않은 DateTime 일경우 리턴합니다. */
export type InvalidDateTimeError = BaseError & {
  __typename?: 'InvalidDateTimeError';
  message: Scalars['String']['output'];
};

/** 비정상적인 소개글일시 에러를 리턴합니다. */
export type InvalidIntroductionError = BaseError & {
  __typename?: 'InvalidIntroductionError';
  invalidIntroduction: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** 비정상적인 닉네임일시 에러를 리턴합니다. */
export type InvalidNicknameError = BaseError & {
  __typename?: 'InvalidNicknameError';
  invalidNickname: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** 방문 생성 시점이 2019년 미만일 경우 리턴합니다. */
export type InvalidPastDateError = BaseError & {
  __typename?: 'InvalidPastDateError';
  message: Scalars['String']['output'];
};

export type Keyword = {
  __typename?: 'Keyword';
  /** 키워드 코드 */
  code: Scalars['String']['output'];
  /** 아이콘 URL, NonNull을 보장해주기 위해 기본값으로 손가락 이모지 ![](https://ssl.pstatic.net/static/pup/emoji/index_pointing_up20220119224230.png)를 사용합니다. */
  icon: Scalars['URLString']['output'];
  /** 키워드 ex. 인테리어가 멋져요 */
  text: LocaleText;
};

export type KeywordCategory = {
  __typename?: 'KeywordCategory';
  /** 카테고리 코드 ex) food-price */
  code: Scalars['String']['output'];
  /** 기본 키워드를 제외한 추가 키워드 */
  extraKeywords: Array<Keyword>;
  /**
   * 기본 키워드 모음
   * 사업주 커스텀 키워드가 **있는** 경우 👉 사업주 커스텀 키워드
   * 사업주 커스텀 키워드가 **없는** 경우 👉 `Basic + Required + Optional`에 해당하는 키워드 [참고](https://pages.oss.navercorp.com/pup/api/docs/api/pup-keyword-voting#enum-keywordoptiontype)
   */
  keywords: Array<Keyword>;
  /** 카테고리 이름 ex) 음식/가격 */
  name: LocaleText;
};

/** Line 앱 공지사항 *팝업/배너 용도로 쓰임 */
export type LineAppNotification = {
  __typename?: 'LineAppNotification';
  /** 배경색 */
  bgColor: Rgb;
  /** 팝업 종료 일시 */
  closeDateTime: Scalars['DateTime']['output'];
  /** 보여지는 컨텐츠 주소, 보통 png 파일 */
  contentUrl: Scalars['URLString']['output'];
  /** 설명 */
  description: Scalars['String']['output'];
  /** 노출 위치 */
  exposureArea: Scalars['String']['output'];
  /** 고유 아이디 */
  id: Scalars['Int']['output'];
  /** 누르면 이동할 주소 */
  linkUrl: Maybe<Scalars['URLString']['output']>;
  /** 팝업 시작 일시 */
  openDateTime: Scalars['DateTime']['output'];
  /** 제목 */
  title: Scalars['String']['output'];
};

export type LineAppNotificationsOutput = LineAppNotificationsSuccess | UnknownError;

export type LineAppNotificationsSuccess = {
  __typename?: 'LineAppNotificationsSuccess';
  /** Line 공지 사항 배열 */
  lineAppNotifications: Array<LineAppNotification>;
};

export type LocaleText = {
  __typename?: 'LocaleText';
  /** 영어 */
  english: Maybe<Scalars['String']['output']>;
  /** 일본어 */
  japan: Maybe<Scalars['String']['output']>;
  /** 한글 */
  korean: Maybe<Scalars['String']['output']>;
};

export type Location = {
  /** 화면 표기 지역 이름 */
  displayName: Scalars['String']['output'];
  /** 지역 코드 */
  regionCode: Scalars['String']['output'];
  /** 지역 타입 */
  type: LocationType;
};

export type LocationByCoordinateInput = {
  /** 지도 중심 좌표 */
  coordinate: CoordinateInput;
  /** m_loc 쿠키 설정 여부 */
  isMyCurrentLocation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationCheckIn = CheckIn & {
  __typename?: 'LocationCheckIn';
  /** 위치 좌표 */
  coordinate: Coordinate;
  /** 체크인 ID */
  id: Scalars['ID']['output'];
  /** 체크인한 장소 */
  place: Maybe<Place>;
  /** 내 주변 장소 체크인 */
  type: CheckInType;
};

/** 내 주변 장소 체크인 생성 input */
export type LocationCheckInInput = {
  /** 인증할 장소 좌표 정보 */
  coordinate: CoordinateInput;
  /** 방문한 장소 id */
  placeId: Scalars['String']['input'];
};

/** 피드탭 타입 */
export enum LocationTab {
  /** 전체 */
  All = 'ALL',
  /** 현재 위치 */
  Current = 'CURRENT',
  /** 팔로잉 */
  Following = 'FOLLOWING',
  /** 지역별 */
  Location = 'LOCATION'
}

/** 장소 타입 */
export enum LocationType {
  /** 공통 추천 */
  CommonRecommended = 'COMMON_RECOMMENDED',
  /** 관심 장소 */
  Interesting = 'INTERESTING',
  /** 일반 장소 (좌표로 찾을 때 리턴 타입 등) */
  Normal = 'NORMAL',
  /** 개인화 추천 */
  PersonalRecommended = 'PERSONAL_RECOMMENDED'
}

/** 스태틱 맵에 표시하는 마커에 필요한 정보입니다. */
export type Marker = {
  __typename?: 'Marker';
  /** 사전 정의 색상 또는 0xFFFFFF(24 비트 색상값) */
  color: Maybe<Scalars['String']['output']>;
  /** 마커 크기: tiny, small, mid */
  size: Maybe<Scalars['String']['output']>;
  /** 마커 유형: d(default), n(number), a(alphabet), t(tooltip), c(category) */
  type: Maybe<Scalars['String']['output']>;
  /**
   * 마커 유형(type)과 크기(size)별 기본 디자인 기반으로 마커의 크기 조절
   *  소수점 1자리만 지원
   * 0.1보다 작으면 0.1, 2.0보다 크면 2.0으로 설정
   */
  viewSizeRatio: Maybe<Scalars['Float']['output']>;
};

/** 영수증 매칭장소를 Partial Place로 변환한 타입 */
export type MatchedPlace = {
  __typename?: 'MatchedPlace';
  /** 카테고리 path - ex. "쇼핑,유통>반찬가게" */
  categoryNamePath: Maybe<Scalars['String']['output']>;
  /** 위경도 좌표 */
  coordinate: Maybe<Coordinate>;
  /** 장소 아이디 */
  id: Scalars['ID']['output'];
  /** 지번 주소 */
  jibunAddress: Maybe<Scalars['String']['output']>;
  /** 장소 이름 */
  name: Maybe<Scalars['String']['output']>;
  /** 도로명 주소 */
  roadAddress: Maybe<Scalars['String']['output']>;
  /** 썸네일 URL 리스트 */
  thumbnails: Array<Scalars['String']['output']>;
};

/** [방문 생성 과정에서 장소가 매칭](https://wiki.navercorp.com/pages/viewpage.action?pageId=1562086392)되었을 때, 노출하는 스태틱 맵에 필요한 정보입니다. */
export type MatchedPlaceStaticMap = {
  __typename?: 'MatchedPlaceStaticMap';
  /** 줌 레벨. markers 파라미터 설정 시 생략할 수 있습니다. */
  level: Maybe<Scalars['Int']['output']>;
  /** 지도 위에 마커를 표시합니다. */
  marker: Maybe<Marker>;
  /**
   * 고해상도 디스플레이 지원을 위한 옵션. 입력 가능한 값은 다음과 같습니다.
   * 1: 저해상도(기본값)
   * 2: 고해상도
   */
  scale: Maybe<Scalars['Int']['output']>;
};

/** 캐싱할 수 있는 개수를 초과했을때 전달하는 오류 */
export type MaxCacheCountError = BaseError & {
  __typename?: 'MaxCacheCountError';
  maxCount: Scalars['Int']['output'];
  /** 캐싱할 수 있는 개수를 초과했을때 전달할 메세지 */
  message: Scalars['String']['output'];
};

/** POV 30개 초과시 에러 */
export type MaxProofError = BaseError & {
  __typename?: 'MaxProofError';
  message: Scalars['String']['output'];
  /** POV 30개 초과시 이동할 방문 상세 페이지 URL입니다. */
  redirectURL: Scalars['URLString']['output'];
  /** POV 추가 시도 했던 방문 아이디 */
  visitId: Scalars['String']['output'];
};

export type MeError = BaseError & {
  __typename?: 'MeError';
  code: UserError;
  message: Scalars['String']['output'];
};

export type MeOutput = MeError | MeSucceed;

export type MeSucceed = {
  __typename?: 'MeSucceed';
  naverId: Maybe<Scalars['String']['output']>;
  user: User;
};

export type MediaCheckIn = CheckIn & {
  __typename?: 'MediaCheckIn';
  /** 체크인 ID */
  id: Scalars['ID']['output'];
  /** 사진/동영상 */
  mediaItems: Array<MediaItem>;
  /** 체크인한 장소 */
  place: Maybe<Place>;
  /** 사진/영상 체크인 */
  type: CheckInType;
};

/** 사진/동영상 체크인 생성 input */
export type MediaCheckInInput = {
  /** 인증할 사진/동영상 리스트 */
  mediaItems: Array<MediaItemInput>;
  /** 방문한 장소 id */
  placeId: Scalars['String']['input'];
};

/** 미디어 정보입니다. */
export type MediaItem = {
  /** 미디어 파일 형식 */
  format: Maybe<Scalars['String']['output']>;
  /** 미디어 이미지 세로 길이 */
  height: Maybe<Scalars['Int']['output']>;
  /** 미디어의 아이디 (일부 fever기반 리뷰그룹에서 미디어아이템 id가 누락된 경우 thumbnail url로 대체) */
  id: Scalars['ID']['output'];
  /** 대표 이미지 여부 */
  isCover: Maybe<Scalars['Boolean']['output']>;
  /** 미디어 파일 크기 */
  size: Maybe<Scalars['Int']['output']>;
  /** 미디어의 타입 (`IMAGE` or `VIDEO`) */
  type: MediaType;
  /** 미디어 이미지 가로 길이 */
  width: Maybe<Scalars['Int']['output']>;
};

/** input으로 전달하는 미디어 정보입니다. */
export type MediaItemInput = {
  /** 미디어 생성 시 발급받은 id */
  id: Scalars['ID']['input'];
  /** 대표 이미지 여부 */
  isCover?: InputMaybe<Scalars['Boolean']['input']>;
  /** 미디어의 타입 (`IMAGE` or `VIDEO`) */
  type: MediaType;
  /** 미디어의 이미지 및 썸네일 URL */
  url: Scalars['URLString']['input'];
};

/** 미디어 타입 (`IMAGE` or `VIDEO`) */
export enum MediaType {
  /** 이미지 */
  Image = 'IMAGE',
  /** 영상 */
  Video = 'VIDEO'
}

export type Menu = {
  __typename?: 'Menu';
  /** 통화 코드 */
  currencyCode: Maybe<Scalars['String']['output']>;
  /** 메뉴명 ex. 감자 */
  name: Maybe<Scalars['String']['output']>;
  /** 메뉴별 옵션목록 (ex. 예약상품/주문메뉴별 옵션목록) */
  options: Array<MenuOption>;
  /** 메뉴 개수 ex. 3개 */
  quantity: Maybe<Scalars['Int']['output']>;
  /** 메뉴 총 가격 ex. 3개 * 10원 = 30원 */
  totalPrice: Maybe<Scalars['SafeInt']['output']>;
  /** 메뉴 단위 가격 ex. 10원 */
  unitPrice: Maybe<Scalars['SafeInt']['output']>;
};

export type MenuOption = {
  __typename?: 'MenuOption';
  /** 메뉴옵션명 ex. 감자 추가 */
  name: Maybe<Scalars['String']['output']>;
  /** 옵션 개수 ex. 3개 */
  quantity: Maybe<Scalars['Int']['output']>;
  /** 옵션 총 가격 ex. 3개 * 10원 = 30원 */
  totalPrice: Maybe<Scalars['SafeInt']['output']>;
  /** 옵션 단위 가격 ex. 10원 */
  unitPrice: Maybe<Scalars['SafeInt']['output']>;
};

export type MichelinGuide = {
  __typename?: 'MichelinGuide';
  /** 미쉐린 별 개수 */
  starCount: Scalars['Int']['output'];
  /** 미쉐린 타입 / "bib", "new", "star" */
  type: Scalars['String']['output'];
  /** 미쉐린 년도 */
  year: Scalars['Int']['output'];
};

/** 미션 스탬프 증거 유형 */
export enum MisisonStampProofType {
  /** 미션 스탬프 증거가 리뷰 그룹인 경우 */
  ReviewGroup = 'REVIEW_GROUP'
}

/** 미션 */
export type Mission = {
  __typename?: 'Mission';
  /** 미션 설명 ex. "같은 지역에서 리뷰 5번 쓰면 완료!" */
  description: Maybe<Scalars['String']['output']>;
  /** 미션 이름 옆에 붙는 아이콘 URL */
  iconUrl: Maybe<Scalars['URLString']['output']>;
  id: Scalars['ObjectID']['output'];
  /**
   * 스탬프가 찍히기위한 아이템 갯수
   * ex. 업종별 리뷰, 각 업종별 5개 리뷰 된것 먼저 달성 -> 5
   */
  itemCountToStamp: Scalars['Int']['output'];
  /**
   * 미션 레이블 ex. "1단계", "뽀나스 스테이지"
   * @deprecated missionLabel로 이관
   */
  label: Maybe<Scalars['String']['output']>;
  /** 미션 레이블 */
  missionLabel: Maybe<MissionLabel>;
  /** 미션 이름 */
  name: Scalars['String']['output'];
  /** 미션 다음 단계 미리 보기 정보 */
  nextStepPreview: Maybe<MissionNextStepPreview>;
  /** 해당 미션이 이전 단계의 미리보기에서 보일 때 노출될 텍스트 ex. "계속해서 지역 도장 깨고 모을 수 있어요!" */
  previewText: Maybe<Scalars['String']['output']>;
  /** 롤백 가능 여부 */
  revertible: Scalars['Boolean']['output'];
  /** 미션 보상 */
  reward: MissionReward;
  /** 미션 완료하기 위한 도장 갯수 ex. 영수증 3회 달성 -> 3 */
  stampCountToComplete: Scalars['Int']['output'];
  /** 미션 카드에서 스탬프를 노출할 때 특정 위치 스탬프들의 데코레이션 정보를 담고 있습니다. */
  stampDecorations: Maybe<Array<MissionStampDecoration>>;
  /** 미션 설명 툴팁 문구 ex. "서울은 'oo구', 그 외 지역은 'oo시' 단위로 카운팅 돼요." */
  tooltip: Maybe<Scalars['String']['output']>;
};

/** 미션 활동 */
export type MissionActivity = {
  id: Scalars['ObjectID']['output'];
  /** 미션 별 메타 정보(마지막 미션 완료 일시)를 담고 있는 배열 */
  missionStates: Array<MissionState>;
};

/** 미션 활동 */
export type MissionGroup = {
  /** 미션 종료일 */
  endDateTime: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  /** 요청한 유저의 미션 활동, 비로그인 시 null */
  missionActivity: Maybe<MissionActivity>;
  /**
   * 미션 이름
   * @deprecated 미션별로 이름을 가지게 변경되었습니다. `mission.name` 을 써주세요.
   */
  name: Scalars['String']['output'];
  /** 스탬프가 찍히는 조건 */
  stampCondition: StampCondition;
  /** 미션 시작일 */
  startDateTime: Scalars['DateTime']['output'];
  /** 미션 그룹 타입 */
  type: MissionGroupType;
  /** 미션 페이지에서 노출 우선 순위를 위한 weight, 기본 내림차순으로 정렬 */
  weight: Scalars['Int']['output'];
};

/** 미션 그룹 정렬 방식 */
export enum MissionGroupSortOrder {
  /** 입력된 가중치를 바탕으로 가중치 정렬 */
  WeightFirst = 'WEIGHT_FIRST'
}

/** 미션 그룹 유형 */
export enum MissionGroupType {
  /** 자연, 지역명소 리뷰 */
  NatureCategoryReview = 'NATURE_CATEGORY_REVIEW',
  /** 이달의 리뷰어 */
  PhotoReview = 'PHOTO_REVIEW',
  /** 음식점 업종 리뷰 */
  PlaceCategoryReview = 'PLACE_CATEGORY_REVIEW',
  /** 프로필 띠 지급 미션 */
  ProfileBorder = 'PROFILE_BORDER',
  /** 한 지역 도장 깨기 */
  RegionReview = 'REGION_REVIEW',
  /** 영수증 리뷰 복권 */
  ReviewLottery = 'REVIEW_LOTTERY',
  /** 영수증 리뷰 달인 */
  ReviewMaster = 'REVIEW_MASTER',
  /** 조회수 핫한 리뷰어 */
  ReviewViews = 'REVIEW_VIEWS',
  /** 동영상 리뷰 */
  VideoReview = 'VIDEO_REVIEW'
}

export type MissionGroupsOutput = MissionGroupsSucceed | UnknownError;

/** 이달의 미션 그룹 */
export type MissionGroupsSucceed = {
  __typename?: 'MissionGroupsSucceed';
  /** 미션 그룹 배열 */
  missionGroups: Array<MissionGroup>;
};

/** 미션 레이블 */
export type MissionLabel = {
  __typename?: 'MissionLabel';
  /** 레이블 텍스트 ex. "1단계", "뽀나스" */
  text: Scalars['String']['output'];
  /** 레이블 타입 ex. 일반, 보너스 */
  type: MissionLabelType;
};

/** 미션 레이블 유형 */
export enum MissionLabelType {
  /** 보너스 미션 레이블 */
  Bonus = 'BONUS',
  /** NEW 미션 레이블 */
  New = 'NEW',
  /** 일반 미션 레이블 */
  Normal = 'NORMAL'
}

/** 미션 다음 단계 미리보기 정보 */
export type MissionNextStepPreview = {
  __typename?: 'MissionNextStepPreview';
  /** 다음 단계 미리보기 텍스트 앞에 붙는 아이콘 */
  iconUrl: Maybe<Scalars['URLString']['output']>;
  /** 다음 단계 미리보기 텍스트 */
  text: Scalars['String']['output'];
};

/** 미션 */
export type MissionReward = {
  /** 보상 지급 시기 ex. 즉시 / 추후 */
  rewardingTime: MissionRewardingTime;
  /** 당첨자 선정 방식 ex. 랜덤 / 직접 선정 */
  selectMethod: MissionRewardSelectMethodType;
  /** 미션 보상 타입 */
  type: MissionRewardType;
};

/** 미션 보상 선정 방식 */
export enum MissionRewardSelectMethodType {
  /** 미션 완료자 전원 지급. */
  All = 'ALL',
  /** 직접 선정하여 당첨자를 뽑습니다. */
  Pick = 'PICK',
  /** 랜덤 추첨으로 당첨자를 뽑습니다. */
  Random = 'RANDOM',
  /** 미션 조건을 더 많이 충족한 사람들에게 베네핏을 적용하여 랜덤 추첨으로 당첨자를 뽑습니다.. */
  RandomWithBenefit = 'RANDOM_WITH_BENEFIT'
}

/** 미션 보상 타입 */
export enum MissionRewardType {
  /** 네이버 페이 포인트 */
  NPay = 'N_PAY',
  /** 프로필 테두리 */
  ProfileBorder = 'PROFILE_BORDER'
}

/** 미션 보상 지급 시점 */
export enum MissionRewardingTime {
  /** 즉시 지급 */
  Instant = 'INSTANT',
  /** 추후 지급 (현재는 익월 지급) */
  Later = 'LATER'
}

/** 미션 스탬프 */
export type MissionStamp = {
  __typename?: 'MissionStamp';
  /** 스탬프를 획득한 시간 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 미션 스탬프의 증거 */
  proof: MissionStampProof;
  /** 스탬프 모달 노출 여부 */
  shouldNotification: Scalars['Boolean']['output'];
};

/** 미션 카드에서 스탬프를 노출할 때 특정 위치 스탬프들의 데코레이션 정보를 담고 있습니다. */
export type MissionStampDecoration = {
  __typename?: 'MissionStampDecoration';
  /** 해당 데코레이션에 들어가는 이미지의 주소 */
  imageUrl: Scalars['URLString']['output'];
  /** 해당 데코레이션이 노출되는 위치 */
  position: Scalars['Int']['output'];
  /** 데코레이션 타입 */
  type: MissionStampDecorationType;
};

/** 스탬프 데코레이션 유형 */
export enum MissionStampDecorationType {
  /** 이미지 유형, 이미지로 렌더링될 asset의 image url을 전달합니다. */
  Image = 'IMAGE',
  /** 프로필 테두리 유형, 테두리 asset의 image를 전달합니다. */
  ProfileBorder = 'PROFILE_BORDER'
}

/** 스탬프를 여러개 가지고 있는 스탬프 그룹 */
export type MissionStampGroup = {
  __typename?: 'MissionStampGroup';
  /** 스탬프 그룹 카테고리 */
  category: MissionStampGroupCategory;
  /** 스탬프 그룹 아이디 */
  id: Scalars['ObjectID']['output'];
  /** 해당 카테고리의 스탬프 */
  stamps: Array<MissionStamp>;
};

/** 미션 스탬프 그룹 카테고리. 카테고리가 있으면 그룹 미션 스탬프 그룹, 없으면 단일 미션 스탬프 그룹 */
export type MissionStampGroupCategory = {
  __typename?: 'MissionStampGroupCategory';
  /**
   * 스탬프 그룹 카테고리의 코드 ex.
   * 업종 타입일 경우 missionPlaceCategoryCode ex. "220036>220037..."(한식) => "1"
   * 지역 타입일 경우 missionPlaceRegionCode, ex. "전남 완도군" => "1289"
   */
  code: Scalars['String']['output'];
  /** 카테고리의 이모지 아이콘 URL */
  emojiUrl: Maybe<Scalars['URLString']['output']>;
  /** 스탬프 그룹 카테고리 타입 */
  name: Scalars['String']['output'];
  /** 스탬프 그룹 카테고리 타입 */
  type: MissionStampGroupCategoryType;
};

/** 미션 스탬프 그룹 카테고리 유형 */
export enum MissionStampGroupCategoryType {
  /** 업종 카테고리 타입. 이 타입의 스탬프는 업종별 하위 n개의 증거를 가짐 */
  PlaceCategory = 'PLACE_CATEGORY',
  /** 지역 코드 타입. 이 타입의 스탬프는 지역코드별 하위 n개의 증거를 가짐 */
  PlaceRegion = 'PLACE_REGION'
}

/** 미션 스탬프 그룹 정렬 방식 */
export enum MissionStampGroupOrder {
  /** 입력된 순서 그대로 */
  Created = 'CREATED',
  /** 스탬프 갯수 내림차순, 이후 최신 스탬프 순으로 정렬합니다. */
  StampCount = 'STAMP_COUNT'
}

/** 미션 스탬프 증거 */
export type MissionStampProof = {
  /** 미션 스탬프 증거의 고유 아이디 ex. 리뷰 그룹일 경우 리뷰그룹 아이디 */
  id: Scalars['String']['output'];
  /** 미션 스탬프 증거 유형 ex. 리뷰그룹 => "REVIEW_GROUP" */
  type: MisisonStampProofType;
};

/** 해당 미션의 완료 상태등 메타 정보를 담고 있습니다. */
export type MissionState = {
  __typename?: 'MissionState';
  /** 미션 완료 정보 */
  complete: Maybe<MissionStateComplete>;
  /** 당첨 여부 */
  isRewarded: Maybe<Scalars['Boolean']['output']>;
  /** 미션 */
  mission: Mission;
};

/** 미션 완료 정보 */
export type MissionStateComplete = {
  __typename?: 'MissionStateComplete';
  /** 미션 완료 시각 */
  dateTime: Scalars['DateTime']['output'];
  /** 미션 완료 당시 스탬프 그룹의 스냅샷 */
  stampGroup: Maybe<MissionStampGroup>;
};

/** 모바일 앱에서 발생하는 오류입니다. */
export type MobileAppOnlyError = BaseError & {
  __typename?: 'MobileAppOnlyError';
  /** 모바일 앱에서 노출할 에러 메세지입니다. */
  displayMessage: LocaleText;
  /** 모바일 앱에서만 에러 발생시 전달할 메세지입니다. */
  message: Scalars['String']['output'];
};

export type MoveBookmarksInFolderInput = {
  /** 폴더를 이동할 북마크 아이디들로 isAllSelected이 true일 경우 무시됨 */
  bookmarkIds: Array<Scalars['Int']['input']>;
  /** 북마크를 복사할 것인지 이동시킬 것인지 여부 */
  copy: Scalars['Boolean']['input'];
  /** 이동하려는 북마크들이 있는 기존 폴더 ID */
  folderId: Scalars['Int']['input'];
  /** 폴더 내의 전체 북마크를 이동시킬지 여부 */
  isAllSelected: Scalars['Boolean']['input'];
  /** 북마크를 이동시킬 폴더 아이디 */
  targetFolderId: Scalars['Int']['input'];
};

export type MoveBookmarksInFolderOutput = AuthenticationError | MoveBookmarksInFolder_Failed | MoveBookmarksInFolder_Succeed | UnknownError;

/** 폴더 내부의 북마크들의 이동에 실패했습니다. */
export type MoveBookmarksInFolder_Failed = BaseError & {
  __typename?: 'MoveBookmarksInFolder_Failed';
  /** 폴더 내부의 북마크들의 이동에 실패했습니다. */
  message: Scalars['String']['output'];
};

export type MoveBookmarksInFolder_Succeed = {
  __typename?: 'MoveBookmarksInFolder_Succeed';
  /** 이동에 실패한 북마크 ID들 */
  failedBookmarkIds: Array<Scalars['Int']['output']>;
  /** 이동에 성공한 북마크 ID들 */
  succeedBookmarkIds: Array<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** 내게 들어온 팔로우 신청 수락하기 */
  acceptFollowRequest: AcceptFollowRequestOutput;
  /** 장소 북마크 생성 */
  addPlaceBookmark: AddPlaceBookmarkOutput;
  agreeNPayThirdPartyInfoProvisionTerms: CardPaymentAccessOutput;
  /** 사용자 차단하기 */
  blockUser: BlockUserOutput;
  /** 팔로우 취소하기 */
  cancelFollow: CancelFollowOutput;
  /** 팔로우 신청 취소하기 */
  cancelFollowRequest: CancelFollowRequestOutput;
  /** 추천 리뷰어에서 숨기기 취소 */
  cancelHidingReviewerFromRecommendation: HideReviewerFromRecommendationOutput;
  /** 내 위치로 체크인 생성 */
  checkInByLocation: CreateLocationCheckInOutput;
  /** 사진/동영상으로 체크인 생성 */
  checkInByMedia: CreateMediaCheckInOutput;
  /** 장소 직접 검색으로 체크인 생성 */
  checkInBySearch: CreateSearchCheckInOutput;
  /** 프로필 초기화 알림 확인 완료 */
  confirmResetProfile: ConfirmProfileResetOutput;
  createFolder: CreateFolderOutput;
  createOrUpdateReviewGroupReply: CreateOrUpdateReviewGroupReplyOutput;
  /** 리뷰그룹을 생성합니다. */
  createReviewGroup: CreateReviewGroupOutput;
  /** 테마리스트를 생성합니다. */
  createThemelist: CreateThemelistOutput;
  createVisit: CreateVisitOutput;
  deleteFolder: DeleteFolderOutput;
  /** 팔로워 삭제하기 */
  deleteFollower: CancelFollowOutput;
  /** 미디어를 삭제합니다. */
  deleteMedia: DeleteMediaOutput;
  /** 카드 결제 내역 삭제 */
  deletePayment: PaymentDeleteOutput;
  /** 리뷰그룹을 삭제합니다 */
  deleteReviewGroup: DeleteReviewGroupOutput;
  deleteReviewGroupReply: DeleteReviewGroupReplyOutput;
  /** 테마리스트 삭제 */
  deleteThemelist: DeleteThemelistOutput;
  /** 방문 삭제 */
  deleteVisit: DeleteVisitOutput;
  dummy: Scalars['String']['output'];
  followFolder: FollowFolderOutput;
  /** 팔로우 신청하기 */
  followRequest: FollowRequestOutput;
  /** 추천 리뷰어에서 숨기기 */
  hideReviewerFromRecommendation: HideReviewerFromRecommendationOutput;
  hideVisit: HideVisitOutput;
  /** 입력받은 리뷰그룹의 조회수를 증가시킵니다. */
  increaseReviewGroupsView: IncreaseReviewGroupsViewOutput;
  /** 입력받은 테마리스트의 조회수를 증가시킵니다. */
  increaseThemelistView: IncreaseThemelistViewOutput;
  /** 한 폴더 내의 여러 북마크들을 다른 폴더로 복사 및 이동 */
  moveBookmarksInFolder: MoveBookmarksInFolderOutput;
  /** 리뷰그룹에 대한 리액션 남기기 */
  reactToReviewGroup: ReactReviewGroupOutput;
  /** 내게 들어온 팔로우 신청 거절하기 */
  rejectFollowRequest: RejectFollowRequestOutput;
  /** 받은 북마크 id들을 모든 폴더에서 제거 */
  removeBookmarksFromAllFolders: RemoveBookmarksFromAllFoldersOutput;
  removeBookmarksInFolder: RemoveBookmarksInFolderOutput;
  reportProof: ReportProofOutput;
  /** 리뷰어 참여 */
  signup: SignUpOutput;
  /** AB-test 실험 참여 이벤트 전송 */
  trackEvent: TrackEventOutput;
  /** 사용자 차단해제하기 */
  unblockUser: UnblockUserOutput;
  unfollowFolder: UnfollowFolderOutput;
  /** 팔로우 자동 수락 여부 업데이트 */
  updateAutoAcceptFollow: UpdateAutoAcceptFollowOutput;
  /** 장소 북마크 수정 / 기존 북마크를 폴더에 추가 삭제 함으로써 북마크 삭제도 가능 */
  updateBookmark: UpdateBookmarkOutput;
  updateFolder: UpdateFolderOutput;
  /** 경고 팝업 클릭히스토리 저장 */
  updateGreyPopupHistory: Scalars['Boolean']['output'];
  /** 유저 활동 제한 시작날짜 설정. [#13543](https://oss.navercorp.com/place/local/issues/13543) 참고 */
  updateGreyUserUnavailable: Maybe<UpdateGreyUserUnavailableOutput>;
  /** 프로필 페이지용 */
  updateMyProfile: UpdateMyProfileOutput;
  /** 세션유저의 결제내역을 갱신합니다. */
  updatePaymentsJob: CardJobOutput;
  /** 리뷰그룹을 업데이트합니다. */
  updateReviewGroup: UpdateReviewGroupOutput;
  /** 나의 관심 지역리스트를 업데이트합니다. */
  updateSubscribedLocations: UpdateSubscribedLocationsOutput;
  /** 기존 태그 목록에서 변경합니다. (추가는 지원하지 않습니다.) */
  updateTags: OverwriteTagsOutput;
  /** 테마리스트 수정 */
  updateThemelist: ThemelistOutput;
};


export type MutationAcceptFollowRequestArgs = {
  input: AcceptFollowRequestInput;
};


export type MutationAddPlaceBookmarkArgs = {
  addPlaceBookmarkInput: AddPlaceBookmarkInput;
};


export type MutationAgreeNPayThirdPartyInfoProvisionTermsArgs = {
  isV2?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationBlockUserArgs = {
  input: BlockUserInput;
};


export type MutationCancelFollowArgs = {
  input: CancelFollowInput;
};


export type MutationCancelFollowRequestArgs = {
  input: CancelFollowRequestInput;
};


export type MutationCancelHidingReviewerFromRecommendationArgs = {
  targetIdno: Scalars['String']['input'];
};


export type MutationCheckInByLocationArgs = {
  input: LocationCheckInInput;
};


export type MutationCheckInByMediaArgs = {
  input: MediaCheckInInput;
};


export type MutationCheckInBySearchArgs = {
  input: SearchCheckInInput;
};


export type MutationCreateFolderArgs = {
  input: CreateFolderInput;
};


export type MutationCreateOrUpdateReviewGroupReplyArgs = {
  input: CreateOrUpdateReviewGroupReplyInput;
};


export type MutationCreateReviewGroupArgs = {
  createReviewGroupInput: CreateReviewGroupInput;
};


export type MutationCreateThemelistArgs = {
  input: CreateThemelistInput;
};


export type MutationCreateVisitArgs = {
  input: CreateVisitInput;
};


export type MutationDeleteFolderArgs = {
  input: DeleteFolderInput;
};


export type MutationDeleteFollowerArgs = {
  input: CancelFollowInput;
};


export type MutationDeleteMediaArgs = {
  input: DeleteMediaInput;
};


export type MutationDeletePaymentArgs = {
  paymentId: Scalars['String']['input'];
};


export type MutationDeleteReviewGroupArgs = {
  input: DeleteReviewGroupInput;
};


export type MutationDeleteReviewGroupReplyArgs = {
  input: DeleteReviewGroupReplyInput;
};


export type MutationDeleteThemelistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteVisitArgs = {
  id: Scalars['String']['input'];
};


export type MutationFollowFolderArgs = {
  input: FollowFolderInput;
};


export type MutationFollowRequestArgs = {
  input: FollowRequestInput;
};


export type MutationHideReviewerFromRecommendationArgs = {
  targetIdno: Scalars['String']['input'];
};


export type MutationHideVisitArgs = {
  input: HideVisitInput;
};


export type MutationIncreaseReviewGroupsViewArgs = {
  input: IncreaseReviewGroupsViewInput;
};


export type MutationIncreaseThemelistViewArgs = {
  input: IncreaseThemelistViewInput;
};


export type MutationMoveBookmarksInFolderArgs = {
  input: MoveBookmarksInFolderInput;
};


export type MutationReactToReviewGroupArgs = {
  input: ReactReviewGroupInput;
};


export type MutationRejectFollowRequestArgs = {
  input: RejectFollowRequestInput;
};


export type MutationRemoveBookmarksFromAllFoldersArgs = {
  removeBookmarksFromAllFoldersInput: RemoveBookmarksFromAllFoldersInput;
};


export type MutationRemoveBookmarksInFolderArgs = {
  input: RemoveBookmarksInFolderInput;
};


export type MutationReportProofArgs = {
  input: ReportProofInput;
};


export type MutationSignupArgs = {
  isReceiptParticipant: Scalars['Boolean']['input'];
};


export type MutationTrackEventArgs = {
  input: TrackEventInput;
};


export type MutationUnblockUserArgs = {
  input: UnblockUserInput;
};


export type MutationUnfollowFolderArgs = {
  input: UnfollowFolderInput;
};


export type MutationUpdateAutoAcceptFollowArgs = {
  autoFollow: Scalars['Boolean']['input'];
};


export type MutationUpdateBookmarkArgs = {
  updateBookmarkInput: UpdateBookmarkInput;
};


export type MutationUpdateFolderArgs = {
  input: UpdateFolderInput;
};


export type MutationUpdateGreyPopupHistoryArgs = {
  clickType: Scalars['String']['input'];
};


export type MutationUpdateMyProfileArgs = {
  updateMyProfileInput: UpdateMyProfileInput;
};


export type MutationUpdateReviewGroupArgs = {
  input: UpdateReviewGroupInput;
};


export type MutationUpdateSubscribedLocationsArgs = {
  input: UpdateSubscribedLocationsInput;
};


export type MutationUpdateTagsArgs = {
  input: UpdateTagsInput;
};


export type MutationUpdateThemelistArgs = {
  id: Scalars['ID']['input'];
  input: UpdateThemelistInput;
};

export type MyFoldersOutput = MyFolders_Failed | MyFolders_Succeed;

/** 폴더 리스트 조회에 실패했습니다. */
export type MyFolders_Failed = BaseError & {
  __typename?: 'MyFolders_Failed';
  /** 폴더 리스트 조회에 실패했습니다. */
  message: Scalars['String']['output'];
};

/** 공유 폴더 조회 성공시 리턴합니다 */
export type MyFolders_Succeed = {
  __typename?: 'MyFolders_Succeed';
  /** 조회한 폴더 리스트 */
  folders: Array<FolderDeletedOrNot>;
  /** 구독 리스트 수 */
  followFolderCount: Scalars['Int']['output'];
  /** 내 리스트 수 */
  myFolderCount: Scalars['Int']['output'];
  /** 전체 리스트 수 */
  totalFolderCount: Scalars['Int']['output'];
};

/** 방문 리스트를 위한 커넥션 */
export type MyVisitsConnection = {
  __typename?: 'MyVisitsConnection';
  /** 방문 리스트 */
  edges: Array<VisitEdge>;
  /** 방문 리스트의 pagination 정보 */
  pageInfo: MyVisitsPageInfo;
};

/** 로그인 유저의 방문을 불러올 때 필요한 입력값 */
export type MyVisitsInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** 앞에서부터 최대 `first` 갯수만큼 가져옵니다. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

export type MyVisitsOutput = ForbiddenError | MyVisitsSucceed | UnknownError;

/** 방문 리스트의 마지막 커서정보를 담고 있습니다. */
export type MyVisitsPageInfo = {
  __typename?: 'MyVisitsPageInfo';
  /** edges들의 마지막 커서 정보 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** 총 방문 수 */
  totalCount: Scalars['Int']['output'];
};

/** 방문 리스트 조회 성공시 리턴 타입 */
export type MyVisitsSucceed = {
  __typename?: 'MyVisitsSucceed';
  /** 방문 리스트 커넥션 */
  connection: MyVisitsConnection;
};

/** 네이버 페이 포인트 보상 리워드 */
export type NPayMissionReward = MissionReward & {
  __typename?: 'NPayMissionReward';
  /** 미션 보상 금액 ex. 1000원 -> 1000 */
  amount: Scalars['Int']['output'];
  /** 보상 지급 시기 ex. 즉시 / 추후 */
  rewardingTime: MissionRewardingTime;
  /** 당첨자 선정 방식 ex. 랜덤 / 직접 선정 */
  selectMethod: MissionRewardSelectMethodType;
  /** 미션 보상 타입 */
  type: MissionRewardType;
  /** 추첨자 수 ex. 100명 -> 100  */
  winnerCount: Maybe<Scalars['Int']['output']>;
};

/** 페이 결제내역 종류 */
export enum NPaymentType {
  /** 네이버페이 선불카드 */
  MyassetPrepaid = 'MYASSET_PREPAID',
  /** 네이버페이 선불카드 & 현장결제 - 네이버페이 선불카드로 현장결제한 경우 */
  MyassetPrepaidNpayCard = 'MYASSET_PREPAID_NPAY_CARD',
  /** 마이데이터 연동된 카드 */
  MydataCard = 'MYDATA_CARD',
  /** 마이데이터 연동 카드 & 현장결제 - 마이데이터 연동카드로 현장결제한 경우 */
  MydataOnsiteNpayCard = 'MYDATA_ONSITE_NPAY_CARD',
  /** 현장결제 - 페이 간편결제수단으로 등록된 카드 */
  OnsiteNpayCard = 'ONSITE_NPAY_CARD',
  /** 현장결제 - 페이 포인트/머니 */
  OnsiteNpayPoint = 'ONSITE_NPAY_POINT'
}

export type NearbyPlacesInput = {
  /** 현재 좌표 */
  coordinate: CoordinateInput;
  /** 반환할 문서 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** 일반 장소 */
export type NormalLocation = Location & {
  __typename?: 'NormalLocation';
  /** 화면 표기 지역 이름 */
  displayName: Scalars['String']['output'];
  /** 지역 코드 */
  regionCode: Scalars['String']['output'];
  /** 지역 타입 */
  type: LocationType;
};

/** 존재하지 않는 데이터입니다 */
export type NotFoundError = BaseError & {
  __typename?: 'NotFoundError';
  code: Scalars['Int']['output'];
  /** 존재하지 않는 데이터일때 전달할 메세지 */
  message: Scalars['String']['output'];
};

/** 팔로잉 하려는 유저를 찾을 수 없을 때 응답 */
export type NotFoundOpponentUser = BaseError & {
  __typename?: 'NotFoundOpponentUser';
  message: Scalars['String']['output'];
};

/** 특정 지역의 다른 유저 리뷰 인풋 */
export type OtherUsersFeedsOnLocationInput = {
  /** 최신순으로 가져올 리뷰 개수 */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** 리뷰어들을 가지고 올 지역 코드 (읍면동 레벨의 8자리 rcode) */
  regionCode: Scalars['String']['input'];
};

export type OtherUsersFeedsOnLocationOutput = OtherUsersFeedsOnLocationSucceed | UnknownError;

/** 다른 리뷰어가 간 특정 지역 피드 */
export type OtherUsersFeedsOnLocationSucceed = {
  __typename?: 'OtherUsersFeedsOnLocationSucceed';
  /** 피드 */
  feeds: Array<Feed>;
};

export type OverwriteTagsOutput = AuthenticationError | UnknownError | UpdateTagsSucceed;

export type Panorama = {
  __typename?: 'Panorama';
  coordinate: Coordinate;
  /** 시야각 */
  fov: Scalars['String']['output'];
  /** 파노라마 이미지 ID */
  id: Scalars['String']['output'];
  /** 좌우 경사각 */
  pan: Scalars['String']['output'];
  /** 상하 경사각 / min: -90, max: 90 */
  tilt: Scalars['String']['output'];
};

/** mfa 인증 안 된 경우 */
export type PaySession_Failed = {
  __typename?: 'PaySession_Failed';
  /** sessionKey를 가지고 비밀번호 화면으로 이동 */
  sessionKey: Scalars['String']['output'];
  /** 페이 비밀번호 인증 URL */
  url: Scalars['URLString']['output'];
};

/** 결제내역 */
export type Payment = {
  __typename?: 'Payment';
  /** 결제처 사업자번호 */
  businessNumber: Maybe<Scalars['String']['output']>;
  /** 생성(최초갱신)시각 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 카드결제인 경우 화면에 표시할 카드 정보 */
  displayCardName: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 결제취소된 경우 `true` */
  isCanceled: Scalars['Boolean']['output'];
  /**
   * 이미 방문인증한 결제내역인 경우
   * @deprecated 중복 결제내역 검사 fadeout [link](https://oss.navercorp.com/place/my_plan/issues/4546#issuecomment-11885105)
   */
  isDuplicated: Scalars['Boolean']['output'];
  /** 리뷰대상 여부 */
  isReviewTarget: Scalars['Boolean']['output'];
  /** 방문 매칭장소 */
  matchedPlaces: Array<Maybe<Place>>;
  /** 결제처 */
  merchantName: Maybe<Scalars['String']['output']>;
  /** 최종 결제금액 */
  totalPrice: Scalars['Float']['output'];
  type: NPaymentType;
  /** 수정시각 */
  updatedDateTime: Scalars['DateTime']['output'];
  user: User;
  /** 방문 정보 */
  visit: Maybe<Visit>;
  /** 결제일시 */
  visitDateTime: Scalars['DateTime']['output'];
};

export type PaymentDeleteOutput = AuthenticationError | PaymentDelete_Succeed | UnknownError;

/** 결제 내역 삭제 성공 */
export type PaymentDelete_Succeed = {
  __typename?: 'PaymentDelete_Succeed';
  /** 삭제된 키드 결제내역 id */
  deletedId: Scalars['String']['output'];
};

/** 결제내역 조회 */
export type PaymentEdge = {
  __typename?: 'PaymentEdge';
  /** 결제내역 */
  payment: Payment;
};

export type PaymentOutput = AuthenticationError | ForbiddenError | PaymentEdge | UnknownError;

export type PaymentProof = Proof & {
  __typename?: 'PaymentProof';
  detailURL: Maybe<Scalars['URLString']['output']>;
  /** 결제내역 id */
  id: Scalars['ID']['output'];
  menus: Array<Menu>;
  /** 결제내역 상세정보 - 타인뷰일 경우 null 반환 */
  payment: Maybe<Payment>;
  /** 개인정보 제외한 결제내역 상세정보 - 결제처 관련 정보 등 */
  paymentPublicInfo: Maybe<PaymentPublicInfo>;
  /** 오매칭신고 상태 */
  reportStatus: Maybe<ProofReportStatus>;
  /** 총 결제 승인금액 */
  totalPayment: Maybe<Scalars['SafeInt']['output']>;
  /** 방문 증거 = 결재내역 (카드, 페이포인트 등) */
  type: ProofType;
  /** 결제 승인 일시 */
  visitedDateTime: Scalars['DateTime']['output'];
};

/** 결제내역 결제처 관련 정보 */
export type PaymentPublicInfo = {
  __typename?: 'PaymentPublicInfo';
  /** 결제처 사업자번호 */
  businessNumber: Maybe<Scalars['String']['output']>;
  /** 결제처 */
  merchantName: Maybe<Scalars['String']['output']>;
  /** 결제일시 */
  visitDateTime: Scalars['DateTime']['output'];
};

/** 카드결제/현장결제 내역을 조회하기 위한 input */
export type PaymentsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** 마이데이터 카드 결제내역 조회할경우 - 정상연결된 카드 id 목록 */
  cardIds?: Array<Scalars['ID']['input']>;
  /** 현장결제 카드내역 포함여부 - false일 경우 마데카드내역에 매핑되지 않는 현장결제 카드내역 미포함 */
  includeOnSiteCard?: Scalars['Boolean']['input'];
  /** 현장결제 포인트머니 결제 포함 */
  includeOnSitePointMoney?: Scalars['Boolean']['input'];
  /** 리뷰 대상 필터링 여부 */
  isReviewTargetFilter?: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<PaymentsSort>;
  /** 마이데이터 카드 결제내역 조회할경우 - 정상연결된 카드 id 목록 */
  stringCardIds?: Array<Scalars['ID']['input']>;
  /** 조회할 결제내역 타입 - 마이데이터 카드, 현장결제 카드, 현장결제 페이포인트 */
  types?: InputMaybe<Array<NPaymentType>>;
  /** 갱신일시 범위 */
  updatedDateTime?: InputMaybe<DateTimeRangeInput>;
  /** 결제일시 범위 */
  visitDateTime?: InputMaybe<DateTimeRangeInput>;
};

export type PaymentsOutput = AuthenticationError | PaySession_Failed | Payments_Succeed | UnknownError;

/** 결제내역 목록의 페이지 정보 */
export type PaymentsPageInfo = {
  __typename?: 'PaymentsPageInfo';
  /** 마지막 cursor */
  cursor: Maybe<Scalars['String']['output']>;
  /** 더 조회할 내역이 있는지 여부 */
  hasMore: Scalars['Boolean']['output'];
};

/** 결제내역 정렬 */
export enum PaymentsSort {
  /** 갱신일시기준 오름차순 정렬 */
  UpdatedDatetimeAsc = 'UPDATED_DATETIME_ASC',
  /** 결제일시기준 내림차순(최신순) 정렬 */
  VisitDatetimeDesc = 'VISIT_DATETIME_DESC'
}

/** 결제내역 목록 조회 성공 */
export type Payments_Succeed = {
  __typename?: 'Payments_Succeed';
  /** 결제내역 목록의 페이지 정보 */
  pageInfo: Maybe<PaymentsPageInfo>;
  /** 결제내역 목록 */
  payments: Array<Payment>;
};

/** 개인화 맞춤 추천 장소 */
export type PersonalRecommendedLocation = Location & {
  __typename?: 'PersonalRecommendedLocation';
  /** 화면 표기 지역 이름 */
  displayName: Scalars['String']['output'];
  /** 지역 추천 이유 */
  displayReason: DisplayRecommendedReason;
  /** 지역 추천 여부 */
  isRecommendation: Scalars['Boolean']['output'];
  /** 추천 순위 */
  ranking: Scalars['Float']['output'];
  /** 지역 코드 */
  regionCode: Scalars['String']['output'];
  /** 지역 타입 */
  type: LocationType;
};

export type Place = {
  __typename?: 'Place';
  /** 방송 정보 */
  broadcast: Maybe<Broadcast>;
  /** 카테고리 - ex. "한식" */
  category: Maybe<Scalars['String']['output']>;
  /** 카테고리 IdPath - ex. "220036>220046>220165>221028" */
  categoryIdPath: Maybe<Scalars['String']['output']>;
  /** 카테고리 path - ex. "쇼핑,유통>반찬가게" */
  categoryNamePath: Maybe<Scalars['String']['output']>;
  /** 위경도 좌표 */
  coordinate: Maybe<Coordinate>;
  /** 검색 위치 기준 거리 */
  distance: Maybe<Scalars['Float']['output']>;
  /** 사업자 번호 존재 여부 */
  hasPermitNumber: Scalars['Boolean']['output'];
  /** 장소 아이디 */
  id: Scalars['ID']['output'];
  /** 해당 장소에 대한 총 이미지수 */
  imageCount: Scalars['Int']['output'];
  /**
   * ibu 기준 장소 승인여부 (상태가 approved 인 경우 true, 폐업/일시 정지 업체인 경우 false)
   * @deprecated `isAvailable` 필드로 통일 [참고](https://oss.navercorp.com/place/local/discussions/16014)
   */
  isApproved: Scalars['Boolean']['output'];
  /** 노출 여부 e.g. cocoa/sas 의 경우 응답이 있을 경우 유효하다고 삼을 수 [있음](https://oss.navercorp.com/place/local/discussions/16014#discussion-4064), maps 의 경우 availabe 필드로 판단 */
  isAvailable: Scalars['Boolean']['output'];
  /** 장소 북마크 여부 */
  isBookmarked: Scalars['Boolean']['output'];
  /**
   * ibu 기준 장소 미노출 처리 여부 ([ibu 조회 안되는 경우 ex. 공연, 전시, 휴게소 등](https://oss.navercorp.com/place/local/issues/6522#issuecomment-5680560))
   * @deprecated `isAvailable` 필드로 통일 [참고](https://oss.navercorp.com/place/local/discussions/16014)
   */
  isHidden: Scalars['Boolean']['output'];
  /** 노출 리뷰 작성 가능 여부(방문 생성을 위함) */
  isQualifiedForReview: Scalars['Boolean']['output'];
  /**
   * SAS, Maps 기준 장소 폐업 여부, 저장탭 및 지도에서 사용
   * @deprecated `isAvailable` 필드로 통일 [참고](https://oss.navercorp.com/place/local/discussions/16014)
   */
  isRemoved: Scalars['Boolean']['output'];
  /** 혜택 알림 받기 가능한 장소인지 여부 */
  isSubscribable: Scalars['Boolean']['output'];
  /** 혜택 알림 받기 했는지 여부 */
  isSubscribed: Scalars['Boolean']['output'];
  /** 지번 주소 */
  jibunAddress: Maybe<Scalars['String']['output']>;
  /** 미쉐린 가이드 정보 */
  michelinGuide: Maybe<MichelinGuide>;
  /** 장소 이름 */
  name: Maybe<Scalars['String']['output']>;
  /** 혜택 알림 받기 프로모션 정보 */
  notificationPromotions: Array<CouponPromotion>;
  /** 해당 장소의 파노라마뷰 URL */
  panorama: Maybe<Panorama>;
  /** 해당 장소의 전화번호 */
  phone: Maybe<Scalars['String']['output']>;
  /** 업체 프로모션 해택 정보 */
  promotion: Maybe<Scalars['String']['output']>;
  /** 지역 코드 ex. 성남시 -> "0213" */
  regionCode: Maybe<Scalars['String']['output']>;
  /** 지역 이름 객체 */
  regionNameInfo: Maybe<RegionName>;
  /** 해당 장소에 대한 총 리뷰수 */
  reviewCount: Scalars['Int']['output'];
  /** 도로명 주소 */
  roadAddress: Maybe<Scalars['String']['output']>;
  /** 썸네일 URL 리스트 */
  thumbnails: Array<Scalars['String']['output']>;
  /** 해당 장소의 방문 키워드 카테고리 목록 */
  visitCategories: Array<VisitCategory>;
  /** 해당 장소에 리뷰시 선택할 수 있는 키워드 */
  votingKeywords: Array<KeywordCategory>;
};


export type PlaceIsQualifiedForReviewArgs = {
  proofType: ProofType;
};


export type PlaceVotingKeywordsArgs = {
  sort?: InputMaybe<VotableKeywordsOrder>;
};

export type PlaceBookmark = Bookmark & {
  __typename?: 'PlaceBookmark';
  /** 즐겨찾기 별명 / API에서는 displayName 필드 / 지도에서 보일 이름 */
  alias: Scalars['String']['output'];
  /** 최근 매칭된 혹은 요청한 폴더에 대한 정보 / 일전 버그로 2000개 이상 저장된 북마크의 경우 null */
  bestMatchingMappingFolder: Maybe<BestMatchingMappingFolderInfo>;
  /** 북마크 아이디 */
  id: Scalars['Int']['output'];
  /** 매핑된 폴더 id 리스트 */
  mappingFolderIds: Array<Scalars['Int']['output']>;
  /** 북마크 메모 */
  memo: Maybe<Scalars['String']['output']>;
  /** 즐겨찾기에 추가된 이름 / 장소 이름 / Folder Detail 페이지에서 확인되는 이름 */
  name: Scalars['String']['output'];
  /** 북마크한 장소 */
  place: Place;
  /** 즐겨찾기 타입 / place */
  type: BookmarkType;
  /** 외부 링크 */
  url: Maybe<Scalars['String']['output']>;
};

/** 프로모션 참여 조건 타입 */
export enum PlaceJoinConditionType {
  /** 혜택 알림 받기 쿠폰 */
  PlaceBenefitNotificationSubscribed = 'PLACE_BENEFIT_NOTIFICATION_SUBSCRIBED',
  /** 업체 홈 쿠폰 */
  PlaceHome = 'PLACE_HOME'
}

/** 컨텐트(미디어 또는 텍스트) 기준으로 리뷰그룹 필터 */
export enum PlaceOtherReviewGroupsContentFilter {
  /** 필터링 적용하지 않음 */
  All = 'ALL',
  /** 컨텐트 없는 리뷰그룹만 필터링 */
  WithoutContent = 'WITHOUT_CONTENT',
  /** 컨텐트 있는 리뷰그룹만 필터링 */
  WithContent = 'WITH_CONTENT'
}

/** 이 장소의 다른 리뷰 pagination input */
export type PlaceOtherReviewGroupsInput = {
  /** after cursor, 이 다음부터 가져옵니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** 컨텐트(미디어 또는 텍스트) 기준으로 리뷰그룹 필터 */
  contentFilter?: InputMaybe<PlaceOtherReviewGroupsContentFilter>;
  /** 포함하지 않을 reviewGroup id */
  excludeReviewGroupId?: InputMaybe<Scalars['String']['input']>;
  /** 미디어 기준으로 리뷰그룹 필터 */
  mediaFilter?: InputMaybe<ReviewGroupsMediaFilter>;
  /** 장소 id */
  placeId: Scalars['ID']['input'];
  /** 가져올 size */
  size?: InputMaybe<Scalars['Int']['input']>;
  /** 정렬 방법, ex. 조회수 / 추천 / 평점 */
  sort?: InputMaybe<PlaceOtherReviewGroupsSort>;
};

export type PlaceOtherReviewGroupsOutput = ReviewGroupConnection | UnknownError;

/** 이 장소의 다른 리뷰 정렬 */
export enum PlaceOtherReviewGroupsSort {
  /** 생성일 오름차순 정렬 */
  CreateDateTimeAsc = 'CREATE_DATE_TIME_ASC',
  /** 생성일 내림차순 정렬 */
  CreateDateTimeDesc = 'CREATE_DATE_TIME_DESC',
  /** 평점 오름차순 정렬 */
  RatingAsc = 'RATING_ASC',
  /** 평점 내림차순 정렬 */
  RatingDesc = 'RATING_DESC',
  /** 추천 오름차순 정렬 */
  RecommendScoreAsc = 'RECOMMEND_SCORE_ASC',
  /** 추천 내림차순 정렬 */
  RecommendScoreDesc = 'RECOMMEND_SCORE_DESC',
  /** 조회수 오름차순 정렬 */
  ViewCountAsc = 'VIEW_COUNT_ASC',
  /** 조회수 내림차순 정렬 */
  ViewCountDesc = 'VIEW_COUNT_DESC',
  /** 방문일 오름차순 정렬 */
  VisitDateTimeAsc = 'VISIT_DATE_TIME_ASC',
  /** 방문일 내림차순 정렬 */
  VisitDateTimeDesc = 'VISIT_DATE_TIME_DESC'
}

export type PlaceSearchInput = {
  /** 중심 좌표 */
  coordinate?: InputMaybe<CoordinateInput>;
  /** 반환할 문서 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 정렬 */
  sort?: InputMaybe<SasSort>;
};

/**
 * 동영상 재생 정보입니다.
 * ⚠️ 만료 시간은 1시간입니다.
 */
export type Playback = {
  __typename?: 'Playback';
  /** VodCloud Video Key 유효 시간입니다. (ms) */
  availableTime: Scalars['Int']['output'];
  /** VodCloud Service Id 입니다. */
  serviceId: Scalars['Int']['output'];
  /**
   * PrismPlayer를 재생하기 위한 url 입니다.
   * 포맷은 `${provider}://${serviceId}:${videoKey}@${videoId}`입니다.
   */
  url: Scalars['URLString']['output'];
  /** VodCloud Video Id 입니다. */
  videoId: Scalars['String']['output'];
  /**
   * VodCloud Video Key 입니다.
   * ⚠️ 만료 시간은 1시간입니다.
   */
  videoKey: Scalars['String']['output'];
};

/** 동영상 재생정보 조회 실패시 리턴합니다. */
export type PlaybackFailed = BaseError & {
  __typename?: 'PlaybackFailed';
  message: Scalars['String']['output'];
};

export type PlaybackOutput = IllegalVideo | PlaybackFailed | PlaybackSucceed;

export type PlaybackSucceed = {
  __typename?: 'PlaybackSucceed';
  /** 조회한 동영상 재생 정보입니다. */
  playback: Playback;
};

export type PopularLocationFeedsInput = {
  /** 가져올 피드 개수 */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** 피드를 가져올 regionCode */
  regionCode: Scalars['String']['input'];
};

/** 영수증 인증 실패 */
export type PostFaultReceipt = {
  __typename?: 'PostFaultReceipt';
  /** 영수증 인증 불가 케이스 [link](https://oss.navercorp.com/place/local/blob/master/packages/api/libs/receipt/post-receipt/post-receipt.md) */
  fault: ReceiptFault;
};

export type PostReceiptVisitDateTime = {
  __typename?: 'PostReceiptVisitDateTime';
  /** ocr 방문날짜값(`YYYY-MM-DD`) - 유효한 과거날짜값인 경우에만 반환합니다 */
  date: Maybe<Scalars['Date']['output']>;
  /** ocr 방문일시(`YYYY-MM-DDTHH:mm:ss+0900`) - 유효한 과거일시인 경우에만 반환합니다 */
  dateTime: Maybe<Scalars['DateTime']['output']>;
  /** ocr 방문시간값(`HH:mm:ss+0900`) - 유효한 과거날짜가 존재하고, 유효한 과거시간값인 경우에만 반환합니다 */
  time: Maybe<Scalars['Time']['output']>;
};

export type PrivateVisitInfo = {
  __typename?: 'PrivateVisitInfo';
  /** 방문 생성일 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 방문 상세 페이지 URL입니다. */
  detailURL: Scalars['URLString']['output'];
  /**
   * 대표 POV 메뉴들
   * 정해진 우선순위(주문(포장/매장/배달) > 예약 > 영수증 > 카드 순)에 따라 대표 POV의 메뉴를 `PupVisit.items` 에서 가져온 것
   */
  displayMenus: Array<Menu>;
  /** 첫번째 방문 시간 */
  firstVisitDateTime: Maybe<Scalars['DateTime']['output']>;
  /** 방문 아이디 */
  id: Scalars['ID']['output'];
  /** 방문한 장소 */
  place: Maybe<Place>;
  /** 방문 증거 리스트 - POV 우선순위에 따라 정렬된 상태 */
  proofs: Array<Proof>;
  /** 방문에 대한 리뷰 */
  reviewGroup: Maybe<ReviewGroup>;
  /** 재방문 간격(일) */
  revisitInterval: Maybe<Scalars['Int']['output']>;
  /** 대표 POV의 총 금액 */
  totalPrice: Maybe<Scalars['Float']['output']>;
  /** 방문한 사용자 */
  user: User;
};


export type PrivateVisitInfoProofsArgs = {
  sort?: InputMaybe<ProofOrder>;
};

export type Profile = {
  __typename?: 'Profile';
  /** 프로필 테두리 데코레이션 */
  border: Maybe<Decoration>;
  imageUrl: Maybe<Scalars['String']['output']>;
  introduction: Maybe<Scalars['String']['output']>;
  nickname: Scalars['String']['output'];
  originImageUrl: Maybe<Scalars['String']['output']>;
  /** 프로필 초기화 알림 */
  shouldNoticeReset: Maybe<Scalars['Boolean']['output']>;
  updated: Maybe<Scalars['DateTime']['output']>;
};

/** 프로필 테두리 리워드 */
export type ProfileBorderMissionReward = MissionReward & {
  __typename?: 'ProfileBorderMissionReward';
  /** 프로필 테두리 아이템 */
  decoration: Decoration;
  /** 보상 지급 시기 ex. 즉시 / 추후 */
  rewardingTime: MissionRewardingTime;
  /** 당첨자 선정 방식 ex. 랜덤 / 직접 선정 */
  selectMethod: MissionRewardSelectMethodType;
  /** 미션 보상 타입 */
  type: MissionRewardType;
};

/** 프로모션 상태 */
export enum PromotionStatus {
  /** 프로모션 진행 전 */
  Before = 'BEFORE',
  /** 프로모션 종료 */
  End = 'END',
  /** 프로모션 중 */
  Ongoing = 'ONGOING'
}

export type Proof = {
  /** proof에 대한 상세 페이지 */
  detailURL: Maybe<Scalars['URLString']['output']>;
  /** 방문 증거의 아이디 ex) 방문 증거가 영수증이라면 영수증의 ID */
  id: Scalars['ID']['output'];
  /** 결제 메뉴 배열 - 카드는 미제공 */
  menus: Array<Menu>;
  /** 총 결제 금액 - 해당 방문증거의 결제 합산 */
  totalPayment: Maybe<Scalars['SafeInt']['output']>;
  /** 방문 증거의 종류 */
  type: ProofType;
  /** proof 발생 시간 */
  visitedDateTime: Scalars['DateTime']['output'];
};

/** 방문 증거 정렬 방식 */
export enum ProofOrder {
  /** 최신 시간순으로 먼저 그룹핑 이후 POV 타입 우선순위에 따라 정렬합니다. */
  TimeFirst = 'TIME_FIRST',
  /** POV 타입 우선순위 순으로 먼저 그룹핑 이후 최신 순서로 정렬합니다. */
  TypeFirst = 'TYPE_FIRST'
}

/** 업체 오매칭신고 검수 상태 */
export enum ProofReportStatus {
  /** 운영자가 오매칭으로 판단하여 오매칭신고 승인 */
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW',
  InReviewAgain = 'IN_REVIEW_AGAIN',
  /** 운영자가 정상매칭으로 판단하여 오매칭신고 반려 */
  Rejected = 'REJECTED',
  /** 오매칭신고 접수 후 운영자가 검수 전 대기 상태. 리뷰 Showable 가능 */
  WaitingForReview = 'WAITING_FOR_REVIEW',
  /** 재검수 대기 상태 */
  WaitingForReviewAgain = 'WAITING_FOR_REVIEW_AGAIN',
  WaitingForValidation = 'WAITING_FOR_VALIDATION'
}

/** 방문 증거 */
export enum ProofType {
  /** 주문 */
  Delivery = 'DELIVERY',
  /** 드라이브 스루 주문 */
  DriveThru = 'DRIVE_THRU',
  /** 내 주변 장소 체크인 */
  Gps = 'GPS',
  /** 사진/영상으로 체크인 */
  Media = 'MEDIA',
  /** 카드결제 */
  Payment = 'PAYMENT',
  /** 포장 주문 */
  Pickup = 'PICKUP',
  /** 영수증 */
  Receipt = 'RECEIPT',
  /** 예약 */
  Reservation = 'RESERVATION',
  /** 장소 직접 검색 체크인 */
  Search = 'SEARCH',
  /** 테이블 주문 */
  TableOrder = 'TABLE_ORDER'
}

/** 금칙어 발견시 해당 단어와 함께 에러를 리턴합니다. */
export type PwordError = BaseError & {
  __typename?: 'PwordError';
  message: Scalars['String']['output'];
  pwords: Array<Scalars['String']['output']>;
  type: PwordType;
};

/** Pword Type */
export enum PwordType {
  /** 소개글에 금칙어가 포함되어 있습니다. */
  Introduction = 'INTRODUCTION',
  /** 닉네임에 금칙어가 포함되어 있습니다. */
  Nickname = 'NICKNAME'
}

export type Query = {
  __typename?: 'Query';
  address: Address;
  addressByRegionCode: AddressFromMapsSearch;
  /** 내 모든 폴더의 북마크 조회 / 구독 폴더 제외 */
  allMyBookmarks: AllMyBookmarksOutput;
  allMyFoldersCategories: FolderCategoriesOutput;
  autoCompletedPlaces: Array<Scalars['String']['output']>;
  /** 예약 배너 가져오기 */
  bookingBanners: Array<BookingBanner>;
  cardJobAvailableTime: CardJobAvailableTime;
  /** 세션유저의 결제내역 갱신상태를 조회합니다. */
  cardPaymentsJob: CardJobOutput;
  /** 지역별 카테고리 가져오기 */
  categoriesByLocation: CategoriesByLocationOutput;
  /** 프로필 페이지용 */
  checkNicknameDuplicate: CheckNickNameDuplicateOutput;
  /** 프로필 페이지용 */
  checkNicknameHasPword: CheckNickNameHasPwordOutput;
  /** AB-test 실험 정보 */
  experimentVariant: VariantOutput;
  /** 내 모든 폴더의 북마크 조회 / 구독 폴더 제외 */
  feeds: FeedsOutput;
  /** 팔로잉 리뷰어가 간 다른 지역 피드 가져오기 */
  followingUsersFeedsOnOtherLocations: FollowingUsersFeedsOnOtherLocationsOutput;
  /** 페이 점검시간 확인용 */
  isPayMaintenanceTime: Scalars['Boolean']['output'];
  /** 요청 시점에서 지난 달 선정/추첨 방식 미션중 당첨된 미션 목록을 리턴합니다. */
  lastMonthWinMission: Array<Mission>;
  lineAppNotifications: LineAppNotificationsOutput;
  locationByCoordinate: Maybe<NormalLocation>;
  /** 프로필 페이지용 */
  me: MeOutput;
  /** 해당 월의 미션그룹 리스트를 리턴합니다. */
  missionGroups: MissionGroupsOutput;
  /** 사용자의 카드 목록 조회 */
  myCardAsset: CardOutput;
  myFolders: MyFoldersOutput;
  myVisits: MyVisitsOutput;
  nearbyPlaces: Array<Place>;
  /** 사용자에게 알림이 필요한 미션그룹 리스트를 리턴합니다. ex. 리뷰작성완료시 스탬프생성된 미션알림 */
  notificationMissionGroups: MissionGroupsOutput;
  /** 다른 리뷰어가 간 특정 지역 피드 가져오기 */
  otherUsersFeedsOnLocation: OtherUsersFeedsOnLocationOutput;
  /** 결제내역 페이지 접근권한검사 */
  paymentAccess: CardPaymentAccessOutput;
  /** 방문 생성을 위한 정보 조회 (matchedPalces, faults) */
  paymentForVisit: PaymentOutput;
  payments: PaymentsOutput;
  place: Maybe<Place>;
  placeOtherReviewGroups: PlaceOtherReviewGroupsOutput;
  /** 동영상 재생 정보를 조회합니다. */
  playback: PlaybackOutput;
  /**
   * 홈탭 > 인기 지역 리뷰 모듈을 위한 쿼리
   * 지역코드기반 응답을 캐싱하여 제공합니다. 한 지역당 최대 20개를 리턴합니다.
   */
  popularLocationFeeds: FeedsOutput;
  /** to generate EnrichedPostReceipt type */
  postReceipt: Maybe<CreateReceiptOutput>;
  receipt: ReceiptOutput;
  receiptAuthentication: ReceiptAuthenticationOutput;
  recentVisitsWithoutReview: RecentVisitsWithoutReviewOutput;
  /** 구독 가능한 개인화 맞춤 추천 지역들을 조회합니다. */
  recommendationForSubscriptableRegions: RecommendationForSubscriptableRegionsOutput;
  regionName: Scalars['String']['output'];
  reviewGroup: ReviewGroupOutput;
  /** 리뷰그룹에 추가된 리액션 목록 */
  reviewGroupReactions: ReviewGruopReactionsOutput;
  reviewGroupReplyAccess: AccessorAuthOutput;
  /**
   * 리뷰 작성/수정 이후 해당 리뷰에 관한 통계
   *  ⚠️리뷰 작성/수정 이후 5분이내 까지 조회 가능
   */
  reviewGroupWriteStat: ReviewGroupWriteStatOutput;
  /** 지역 주변 추천 리뷰어 */
  reviewersAroundRegion: ReviewersAroundRegionOutput;
  /** 카테고리에 해당하는 추천 리뷰어 */
  reviewersOnCategory: ReviewersOnCategoryOutput;
  /** 맛집 취향 비슷한 추천 리뷰어 */
  reviewersWithSimilarTaste: ReviewersWithSimilarTasteOutput;
  /** 내 모든 폴더의 북마크 조회 / 구독 폴더 제외 */
  savedPlaceBookmarks: SavedPlaceBookmarksOutput;
  /** 구독 가능한 지역들을 검색합니다. */
  searchLocations: SearchLocationsOutput;
  searchedPlaces: Array<Place>;
  sharedFolder: SharedFolderOutput;
  sharedFolderCategories: FolderCategoriesOutput;
  /** 스태틱 맵에 대한 정보를 조회합니다. */
  staticMap: StaticMapOutput;
  /** 유저의 위치 정보 동의 여부에 맞게 정렬된 스태틱 맵 북마크 리스트 조회 */
  staticMapBookmarks: StaticMapBookmarksOutput;
  /** 구독한 지역들을 조회합니다. */
  subscribedLocations: SubscribedLocationsOutput;
  /** 구독한 태그 갯수를 조회합니다. */
  tagCount: TagCountOutput;
  /** 구독한 태그를 조회합니다. */
  tags: TagsOutput;
  themelist: ThemelistOutput;
  /** 입력받은 지역의 테마리스트를 제공합니다. */
  themelistsByRegionCodes: ThemelistsByRegionCodesOutput;
  /** 유저를 조회합니다 */
  user: UserOutput;
  /**
   * [타인뷰] 유저가 작성한 리뷰의 카테고리 정보
   * @deprecated pup source로 변경되며 userReviewGroupCategories 로 대체
   */
  userCategories: Array<FeverPlaceCategory>;
  /** 로그인 유저의 리액션 통계 조회 */
  userReactionStat: UserReactionStatOutput;
  /** 유저가 남긴 리액션 목록 */
  userReactions: UserReactionsOutput;
  userRelationships: UserRelationshipsOutput;
  /** 유저가 쓴 리뷰들의 카테고리 통계 배열 */
  userReviewGroupCategories: Array<ReviewGroupCategory>;
  /** 유저가 작성한 리뷰그룹 조회 */
  userReviewGroups: UserReviewGroupsOutput;
  /** 유저가 작성한 리뷰그룹 개수 조회 */
  userReviewGroupsCount: Scalars['Int']['output'];
  /** 유저의 테마리스트 조회 */
  userThemelists: ThemelistsConnection;
  /** 유저의 테마리스트 개수 */
  userThemelistsCount: Scalars['Int']['output'];
  /** idNo 배열로 사용자 프로필을 조회합니다. */
  usersByIdNos: UsersOutput;
  /** 비디오 아이디로 다운로드 URL을 조회합니다. */
  videoDownload: VideoDownloadOutput;
  visit: VisitOutput;
  /** 예약 아이디로 방문을 조회합니다 */
  visitByBookingId: VisitByBookingIdOutput;
  visitHistories: Array<Visit>;
  visits: Array<Visit>;
  visitsByYearMonth: VisitsByYearMonthOutput;
  worthPlaces: WorthPlacesOutput;
};


export type QueryAddressArgs = {
  address: Scalars['String']['input'];
};


export type QueryAddressByRegionCodeArgs = {
  regionCode: Scalars['String']['input'];
};


export type QueryAllMyBookmarksArgs = {
  input: AllMyBookmarksInput;
};


export type QueryAutoCompletedPlacesArgs = {
  input: AutoCompletedPlacesInput;
};


export type QueryCategoriesByLocationArgs = {
  input: CategoriesByLocationInput;
};


export type QueryCheckNicknameDuplicateArgs = {
  nickname: Scalars['String']['input'];
};


export type QueryCheckNicknameHasPwordArgs = {
  nickname: Scalars['String']['input'];
};


export type QueryExperimentVariantArgs = {
  expId: Scalars['String']['input'];
};


export type QueryFeedsArgs = {
  input: FeedsInput;
};


export type QueryLocationByCoordinateArgs = {
  input: LocationByCoordinateInput;
};


export type QueryMissionGroupsArgs = {
  sort?: InputMaybe<MissionGroupSortOrder>;
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryMyFoldersArgs = {
  listType: FolderList;
  range: FolderRange;
};


export type QueryMyVisitsArgs = {
  input: MyVisitsInput;
};


export type QueryNearbyPlacesArgs = {
  input: NearbyPlacesInput;
};


export type QueryNotificationMissionGroupsArgs = {
  reviewGroupId: Scalars['ID']['input'];
};


export type QueryOtherUsersFeedsOnLocationArgs = {
  input: OtherUsersFeedsOnLocationInput;
};


export type QueryPaymentForVisitArgs = {
  paymentId: Scalars['String']['input'];
};


export type QueryPaymentsArgs = {
  input: PaymentsInput;
};


export type QueryPlaceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPlaceOtherReviewGroupsArgs = {
  input: PlaceOtherReviewGroupsInput;
};


export type QueryPlaybackArgs = {
  videoId: Scalars['String']['input'];
};


export type QueryPopularLocationFeedsArgs = {
  input: PopularLocationFeedsInput;
};


export type QueryReceiptArgs = {
  id: Scalars['ID']['input'];
};


export type QueryRecentVisitsWithoutReviewArgs = {
  input?: InputMaybe<RecentVisitsWithoutReviewInput>;
};


export type QueryRegionNameArgs = {
  input: AddressFromCoordInput;
};


export type QueryReviewGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewGroupReactionsArgs = {
  input: ReviewGroupReactionsConnectionInput;
};


export type QueryReviewGroupReplyAccessArgs = {
  reviewGroupId: Scalars['String']['input'];
};


export type QueryReviewGroupWriteStatArgs = {
  debugMode?: Scalars['Boolean']['input'];
  reviewGroupdId: Scalars['ID']['input'];
};


export type QueryReviewersAroundRegionArgs = {
  input: ReviewersAroundRegionInput;
};


export type QueryReviewersOnCategoryArgs = {
  input: ReviewersOnCategoryInput;
};


export type QuerySearchLocationsArgs = {
  searchString: Scalars['String']['input'];
};


export type QuerySearchedPlacesArgs = {
  input?: InputMaybe<PlaceSearchInput>;
  query: Scalars['String']['input'];
};


export type QuerySharedFolderArgs = {
  input: SharedFolderInput;
};


export type QuerySharedFolderCategoriesArgs = {
  shareId: Scalars['ID']['input'];
};


export type QueryStaticMapBookmarksArgs = {
  coordinate?: InputMaybe<CoordinateInput>;
};


export type QuerySubscribedLocationsArgs = {
  input?: InputMaybe<SubscribedLocationsInput>;
};


export type QueryTagsArgs = {
  input: TagsInput;
};


export type QueryThemelistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryThemelistsByRegionCodesArgs = {
  input: ThemelistsByRegionCodesInput;
};


export type QueryUserArgs = {
  id: Scalars['ObjectID']['input'];
};


export type QueryUserCategoriesArgs = {
  input: UserReviewGroupsInput;
};


export type QueryUserReactionsArgs = {
  input: UserReactionsInput;
};


export type QueryUserRelationshipsArgs = {
  input: UserRelationshipsInput;
};


export type QueryUserReviewGroupCategoriesArgs = {
  input: UserReviewGroupCategoriesInput;
};


export type QueryUserReviewGroupsArgs = {
  connection: UserReviewGroupsConnectionInput;
  input: UserReviewGroupsInput;
};


export type QueryUserReviewGroupsCountArgs = {
  input: UserReviewGroupsInput;
};


export type QueryUserThemelistsArgs = {
  connection: ThemelistsConnectionInput;
  input: UserThemelistsInput;
};


export type QueryUserThemelistsCountArgs = {
  input: UserThemelistsInput;
};


export type QueryUsersByIdNosArgs = {
  idNos: Array<Scalars['ID']['input']>;
};


export type QueryVideoDownloadArgs = {
  input: VideoDownloadInput;
};


export type QueryVisitArgs = {
  id: Scalars['ID']['input'];
};


export type QueryVisitByBookingIdArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryVisitHistoriesArgs = {
  visitHistoriesInput: VisitHistoriesInput;
};


export type QueryVisitsArgs = {
  visitIds: Array<Scalars['ID']['input']>;
};


export type QueryVisitsByYearMonthArgs = {
  yearMonth: Scalars['YearMonth']['input'];
};


export type QueryWorthPlacesArgs = {
  input: WorthPlacesInput;
};

/** CSS rgb type ex. {r:255, g:255, b:255} - 흰색 */
export type Rgb = {
  __typename?: 'RGB';
  /** 0-255 색상 값 */
  b: Scalars['Int']['output'];
  /** 0-255 색상 값 */
  g: Scalars['Int']['output'];
  /** 0-255 색상 값 */
  r: Scalars['Int']['output'];
};

/** 리뷰그룹에 리액션 설정하기 */
export type ReactReviewGroupInput = {
  actionType: ReactionAction;
  reactionType: Scalars['String']['input'];
  reviewGroupId: Scalars['ID']['input'];
};

export type ReactReviewGroupOutput = AuthenticationError | ReactReviewGroupSucceed | UnknownError;

/** 리뷰그룹에 리액션하기 성공 */
export type ReactReviewGroupSucceed = {
  __typename?: 'ReactReviewGroupSucceed';
  reactedReviewGroup: ReviewGroup;
};

/** 리액션 - 리액션 타입과 유저정보 */
export type Reaction = {
  __typename?: 'Reaction';
  /** 리액션 남긴 일시 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 리액션 타입 */
  id: Scalars['String']['output'];
  /** 리액션 타입 이름 */
  reactionType: Scalars['String']['output'];
  /** 리액션 대상 ReviewGroup 아이디 */
  reviewGroupId: Scalars['String']['output'];
  /** 리액션 남긴 유저 */
  user: User;
};

export enum ReactionAction {
  /** 리액션 취소하기 */
  Cancel = 'CANCEL',
  /** 리액션 추가 및 업데이트 하기 */
  Update = 'UPDATE'
}

export type ReactionCount = {
  __typename?: 'ReactionCount';
  /** 총 리액션 개수 */
  count: Scalars['Int']['output'];
  /** 해당 리액션 타입이름 */
  reactionType: Scalars['String']['output'];
};

/** 리액션 edge */
export type ReactionEdge = {
  __typename?: 'ReactionEdge';
  reaction: Reaction;
};

export type ReactionStat = {
  __typename?: 'ReactionStat';
  /** 리액션 스탯 ID */
  id: Scalars['ID']['output'];
  /** 리액션 타입별 개수 */
  reactionCounts: Array<ReactionCount>;
  /** 총 리액션 개수 */
  totalCount: Scalars['Int']['output'];
};

/** 리액션 통계 조회 성공 */
export type ReactionStatSucceed = {
  __typename?: 'ReactionStatSucceed';
  /** 리액션 통계 */
  reactionStat: ReactionStat;
};

export type Receipt = {
  __typename?: 'Receipt';
  /** 영수증 인증 시각 */
  createdDateTime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** 영수증 이미지 */
  imageUrl: Maybe<Scalars['URL']['output']>;
  /**
   * 방문 장소를 직접 검색하여 매칭했는지 여부 - 직접 장소를 매칭한 리뷰는 검토 후 노출
   * @deprecated 필드로 내려주지 않고 리뷰생성 로직 내부에서 처리
   */
  isPlaceSearched: Scalars['Boolean']['output'];
  /** ocr 인식 업체 정보 */
  ocrPlace: Maybe<ReceiptOcrPlace>;
  /** ocr 인식 방문시각 (결제시각) */
  ocrVisitedDateTime: Maybe<Scalars['DateTime']['output']>;
  /**
   * 영수증 오매칭 신고에 의한 검수 상태
   * @deprecated ReceiptProof 스키마 필드 사용
   */
  reportStatus: Maybe<ProofReportStatus>;
};

/** 영수증 이미지 접근시 필요한 인증 */
export type ReceiptAuthentication = {
  __typename?: 'ReceiptAuthentication';
  /** 인증 토큰 */
  accessToken: Scalars['String']['output'];
  /** 토큰 만료 시각 */
  expirationDateTime: Scalars['DateTime']['output'];
  /** 토큰 타입 */
  tokenType: Scalars['String']['output'];
};

/** 영수증 이미지 조회 인증 실패 */
export type ReceiptAuthenticationError = BaseError & {
  __typename?: 'ReceiptAuthenticationError';
  code: ReceiptAuthenticationErrorCode;
  message: Scalars['String']['output'];
};

/** 영수증 이미지 인증 토큰 오류 */
export enum ReceiptAuthenticationErrorCode {
  /** API 호출 중 에러가 발생했습니다. */
  ApiError = 'API_ERROR',
  /** 로그인이 필요합니다. */
  NotLogin = 'NOT_LOGIN'
}

export type ReceiptAuthenticationOutput = ReceiptAuthentication | ReceiptAuthenticationError;

export type ReceiptFault = {
  __typename?: 'ReceiptFault';
  reason: ReceiptFaultReason;
  /** 해당 영수증으로 본인이 방문인증 후 작성한 리뷰그룹 아이디 */
  reviewGroupId: Maybe<Scalars['String']['output']>;
  /** 해당 영수증으로 본인이 방문인증한 방문 아이디 */
  visitId: Maybe<Scalars['String']['output']>;
};

/** 영수증 인증 불가능 이유 */
export enum ReceiptFaultReason {
  /** 내가 이미 방문인증하고 삭제한 경우 */
  DuplicatedOfMyDeletedVisit = 'DUPLICATED_OF_MY_DELETED_VISIT',
  /** 내가 이미 방문인증한 경우 */
  DuplicatedOfMyVisit = 'DUPLICATED_OF_MY_VISIT',
  /** 타인이 같은 이미지의 영수증으로 방문인증한 경우 */
  DuplicatedOfOthersVisit = 'DUPLICATED_OF_OTHERS_VISIT',
  /** 스캔 실패 - 인식불가, 정보부족, 영수증 아닌 경우 등 */
  ScanFailed = 'SCAN_FAILED'
}

/** 영수증 조회에 실패했습니다. */
export type ReceiptNotFound = BaseError & {
  __typename?: 'ReceiptNotFound';
  message: Scalars['String']['output'];
  notFoundReceiptId: Scalars['String']['output'];
};

export type ReceiptOcrPlace = {
  __typename?: 'ReceiptOcrPlace';
  /** ocr 인식 업체 주소 */
  address: Maybe<Scalars['String']['output']>;
  /** ocr 인식 업체 사업자번호 */
  businessNumber: Maybe<Scalars['String']['output']>;
  /** ocr 인식 업체 이름 */
  name: Maybe<Scalars['String']['output']>;
  /** ocr 인식 업체 전화번호 */
  phoneNumber: Maybe<Scalars['String']['output']>;
};

export type ReceiptOutput = Receipt | ReceiptNotFound;

export type ReceiptProof = Proof & {
  __typename?: 'ReceiptProof';
  /** 영수증 이미지 조회 페이지 */
  detailURL: Maybe<Scalars['URLString']['output']>;
  /** 영수증 아이디 */
  id: Scalars['ID']['output'];
  /** 영수증 POV의 menus 조회 순서 1) 영수증 ocr 데이터 2) Visit Proof 데이터 [issue](https://oss.navercorp.com/place/local/issues/10037#issuecomment-8333395) */
  menus: Array<Menu>;
  receipt: ReceiptOutput;
  /** 영수증 오매칭 신고에 의한 검수 상태 */
  reportStatus: Maybe<ProofReportStatus>;
  /** 총 결제 금액 - 해당 영수증의 결제내역 합산 */
  totalPayment: Maybe<Scalars['SafeInt']['output']>;
  /** 방문 증거 = 영수증 */
  type: ProofType;
  /** 영수증 발행 시간 */
  visitedDateTime: Scalars['DateTime']['output'];
};

export type RecentVisitsWithoutReviewInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** 가져올 최대 개수 */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** 최근 일수 기준 e.g. 30 -> 최근 30일 동안 리뷰없는 방문 가져오기 */
  recentDays?: InputMaybe<Scalars['Int']['input']>;
};

/** 예약 아이디로 방문 조회시 리턴하는 결과입니다. */
export type RecentVisitsWithoutReviewOutput = RecentVisitsWithoutReview_Succeed | UnknownError;

/** 리뷰 없는 방문 페이지 정보 */
export type RecentVisitsWithoutReviewPageInfo = {
  __typename?: 'RecentVisitsWithoutReviewPageInfo';
  /** 주의! - 숨김 제외하기 전 PUP 에서 받아온 방문 배열의 마지막 커서 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** 다음 페이지 유무 */
  hasNextPage: Scalars['Boolean']['output'];
};

/** 리뷰 없는 방문 조회 성공 응답 */
export type RecentVisitsWithoutReview_Succeed = {
  __typename?: 'RecentVisitsWithoutReview_Succeed';
  /** 리뷰 없는 방문 페이지 정보 */
  pageInfo: RecentVisitsWithoutReviewPageInfo;
  /** 리뷰 없는 방문 배열 */
  visits: Array<Visit>;
};

export type RecommendationForSubscriptableRegionsOutput = AuthenticationError | RecommendationForSubscriptableRegionsSucceed | UnknownError;

export type RecommendationForSubscriptableRegionsSucceed = {
  __typename?: 'RecommendationForSubscriptableRegionsSucceed';
  /** 공통 추전 지역 리스트 */
  commonRecommendedLocations: Array<CommonRecommendedLocation>;
  /** 개인화 추전 지역 리스트 */
  personalRecommendedLocations: Array<PersonalRecommendedLocation>;
};

export type RegionName = {
  __typename?: 'RegionName';
  /** 도 - ex. 경기도 */
  do: Scalars['String']['output'];
  /** 동 - ex. 정자동 */
  dong: Scalars['String']['output'];
  /** 리 - 리가 있는 경우, 보통 빈 스트링 */
  ri: Scalars['String']['output'];
  /** 시 - ex. 성남시 분당구 */
  si: Scalars['String']['output'];
};

/** 내게 들어온 팔로우 요청 거절시 필요한 입력값 */
export type RejectFollowRequestInput = {
  /** 내게 팔로우 요청했던 유저의 idno */
  followerIdno: Scalars['String']['input'];
};

export type RejectFollowRequestOutput = AuthenticationError | FollowCommonRequestFailed | NotFoundOpponentUser | RejectFollowRequestSuccess | UnknownError;

/** 내게 들어온 팔로우 요청 거절 성공시 응답 */
export type RejectFollowRequestSuccess = {
  __typename?: 'RejectFollowRequestSuccess';
  me: User;
  /** 상대방 유저 */
  other: User;
};

export type RemoveBookmarksFromAllFoldersInput = {
  /** 삭제할 북마크 아이디들 */
  bookmarkIds: Array<Scalars['Int']['input']>;
};

export type RemoveBookmarksFromAllFoldersOutput = AuthenticationError | RemoveBookmarksFromAllFolders_Succeed | UnknownError;

export type RemoveBookmarksFromAllFolders_Succeed = {
  __typename?: 'RemoveBookmarksFromAllFolders_Succeed';
  /** 삭제한 북마크 아이디들 */
  removedBookmarkIds: Array<Scalars['Int']['output']>;
};

export type RemoveBookmarksInFolderInput = {
  /** 폐업하거나 장소 정보가 없는 장소들에 대한 삭제 여부로 폴더 내 모든 북마크 삭제에서만 사용되는 인자 */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** 삭제할 북마크들의 bookmark id */
  bookmarkIds: Array<Scalars['Int']['input']>;
  /** 삭제할 북마크들이 속한 folderId */
  folderId: Scalars['Int']['input'];
  /** 폴더 내의 전체 북마크를 삭제시킬지 여부, 서비스에서는 폐업 장소들 전체 삭제에만 사용 */
  isAllSelected: Scalars['Boolean']['input'];
  /** 다른 폴더에 있는 해당 북마크들을 모두 삭제할 것인지 여부 */
  removeEveryMapping: Scalars['Boolean']['input'];
};

export type RemoveBookmarksInFolderOutput = Authentication_Failed | RemoveBookmarksInFolder_Failed | RemoveBookmarksInFolder_Succeed;

/** 폴더 내의 북마크 삭제를 실패했습니다. */
export type RemoveBookmarksInFolder_Failed = BaseError & {
  __typename?: 'RemoveBookmarksInFolder_Failed';
  message: Scalars['String']['output'];
};

/** 폴더 팔로우 취소 성공시 리턴합니다 */
export type RemoveBookmarksInFolder_Succeed = {
  __typename?: 'RemoveBookmarksInFolder_Succeed';
  /** 삭제한 북마크들의 bookmark id */
  removedBookmarkIds: Array<Scalars['Int']['output']>;
};

export type ReportProofInput = {
  /** 오매칭 신고 증거 ID */
  proofId: Scalars['ID']['input'];
  /** 오매칭 신고 증거 타입 */
  proofType: ProofType;
};

export type ReportProofOutput = AuthenticationError | ReportProofSucceed | UnknownError;

/** 오매칭 신고 성공 */
export type ReportProofSucceed = {
  __typename?: 'ReportProofSucceed';
  /** 오매칭 신고 된 Proof id */
  proofId: Scalars['ID']['output'];
  /** 오매칭 신고 된 Proof 타입 */
  proofType: ProofType;
  /** 오매칭 신고 상태 */
  reportStatus: ProofReportStatus;
};

/** 리뷰그룹 생성/수정시 필요한 리뷰 내용입니다. */
export type ReviewContentInput = {
  /** 리뷰에 등록된 영상 및 사진 */
  mediaItems?: InputMaybe<Array<MediaItemInput>>;
  /** 리뷰 내용 */
  text?: InputMaybe<Scalars['String']['input']>;
  /** 리뷰에 선택된 방문 상세 정보 키워드 */
  visitKeywords?: InputMaybe<Array<VotedKeywordInput>>;
  /** 리뷰에 선택된 키워드 */
  votedKeywords?: InputMaybe<Array<VotedKeywordInput>>;
};

export type ReviewGroup = {
  __typename?: 'ReviewGroup';
  /** 리뷰 작성자, 비회원일 경우 null */
  author: Maybe<User>;
  /** 리뷰(그룹)이 생성된 시간 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 리뷰(그룹)의 아이디 */
  id: Scalars['ID']['output'];
  /** 검색 등 서비스 외부 공개 여부 [wiki](https://wiki.navercorp.com/pages/viewpage.action?pageId=883534334) */
  isQualified: Scalars['Boolean']['output'];
  /** 다른 사용자의 게시 중단 요청 여부 */
  isReportedByOthers: Scalars['Boolean']['output'];
  /** 리뷰에 등록된 영상 및 사진 */
  mediaItems: Array<MediaItem>;
  /** 로그인한 유저가 해당 리뷰에 남긴 리액션 타입이름 */
  myReactionType: Maybe<Scalars['String']['output']>;
  /** 리뷰 대상 장소, 폐업하면 null */
  place: Maybe<Place>;
  /** 리뷰에게 평가한 별점 */
  rating: Maybe<Scalars['Float']['output']>;
  /** 해당 리뷰에 달린 리액션 스탯 */
  reactionStat: Maybe<ReactionStat>;
  /** 해당 리뷰에 사장님이 남긴 답글 */
  reply: Maybe<ReviewGroupReply>;
  /**
   * 리뷰 작성 대상으로 선택된 Proof - 대표POV
   * 리뷰그룹 조회시 방문 정보가 없다면, 일부 필드(id, type, visitedDateTime)만 조회됩니다.
   */
  selectedProof: SelectedProof;
  /** 리뷰그룹 상태 */
  status: ReviewGroupStatus;
  /** 리뷰 내용 */
  text: Maybe<Scalars['String']['output']>;
  /** 리뷰 조회 수 */
  viewCount: Scalars['Int']['output'];
  /**
   * 리뷰그룹의 근거가 되는 방문 정보
   * ⚠️ 극히 일부 리뷰그룹에 방문이 없는 경우가 있어서 nullable로 처리합니다.
   */
  visit: Maybe<Visit>;
  /** 리뷰에 선택된 방문 상세 정보 키워드 목록 */
  visitKeywords: Array<Keyword>;
  /** 방문한 날짜 */
  visitedDateTime: Scalars['DateTime']['output'];
  /** 리뷰에 선택된 키워드배열 */
  votedKeywords: Array<Keyword>;
};

/** 유저가 쓴 리뷰들의 전체 분류 정보 */
export type ReviewGroupAllCategory = {
  __typename?: 'ReviewGroupAllCategory';
  /** 전체탭 코드(all) */
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reviewGroupsCount: Scalars['Int']['output'];
  /** 전체 타입 */
  type: UserReviewGroupCategoryType;
};

export type ReviewGroupCategory = ReviewGroupAllCategory | ReviewGroupPlaceCategory | ReviewGroupRegionCategory;

/** 리뷰그룹 커넥션 */
export type ReviewGroupConnection = {
  __typename?: 'ReviewGroupConnection';
  /** 리뷰그룹과 커서가 담긴 edge */
  edges: Array<ReviewGroupEdge>;
  /** 리뷰그룹 페이지네이션의 정보 */
  pageInfo: ReviewGroupPageInfo;
};

export type ReviewGroupEdge = Edge & {
  __typename?: 'ReviewGroupEdge';
  /** 리뷰그룹의 cursor */
  cursor: Scalars['String']['output'];
  /** 리뷰그룹 */
  reviewGroup: ReviewGroup;
};

/** 키워드가 올바르지 않습니다. */
export type ReviewGroupKeywordNotValid = BaseError & {
  __typename?: 'ReviewGroupKeywordNotValid';
  message: Scalars['String']['output'];
};

/** 리뷰그룹 조회에 실패했습니다. */
export type ReviewGroupNotFound = BaseError & {
  __typename?: 'ReviewGroupNotFound';
  message: Scalars['String']['output'];
  /** 조회한 리뷰그룹 아이디 */
  notFoundReviewGroupId: Scalars['String']['output'];
};

export type ReviewGroupOutput = ReviewGroupNotFound | ReviewGroupSucceed;

/** 키워드는 최대 5개까지 선택할 수 있습니다. */
export type ReviewGroupOverflowMaxKeywordCount = BaseError & {
  __typename?: 'ReviewGroupOverflowMaxKeywordCount';
  /** 선택 가능한 최대 키워드 수 */
  maxKeywordCount: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/** 본문은 최대 1600자까지 쓸 수 있습니다. */
export type ReviewGroupOverflowMaxTextLength = BaseError & {
  __typename?: 'ReviewGroupOverflowMaxTextLength';
  /** 본문에 입력 가능한 최대 길이 */
  maxTextLength: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/** 리뷰그룹 커넥션의 페이지 정보 */
export type ReviewGroupPageInfo = {
  __typename?: 'ReviewGroupPageInfo';
  /** 응답의 마지막 커서 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** 해당 조건의 총 리뷰 그룹 */
  totalCount: Scalars['Int']['output'];
};

/** 유저가 쓴 리뷰들의 업체별 분류 정보 */
export type ReviewGroupPlaceCategory = {
  __typename?: 'ReviewGroupPlaceCategory';
  /** 업종 코드 */
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reviewGroupsCount: Scalars['Int']['output'];
  /** 업체 분류 타입 (`메인` or `메뉴`) */
  type: UserReviewGroupCategoryType;
};

/** ⚠️ 장소 통계는 준실시간이므로, 실시간 리뷰집계를 보장하지 않음 */
export type ReviewGroupPlaceStat = {
  __typename?: 'ReviewGroupPlaceStat';
  /** 이 리뷰가 해당 장소에 처음으로 등록한 키워드 목록 */
  firstVotedKeywords: Array<Keyword>;
  /** 리뷰 아이디 */
  id: Scalars['ID']['output'];
  /** 장소에 작성된 사진 리뷰 수 */
  imageReviewCount: Scalars['Int']['output'];
  /** 해당 리뷰를 통해 장소의 키워드 통계가 오픈되었는지(유니크 키워드 리뷰어가 10 이상이면 키워드 통계 오픈) */
  isOpenKeywordStat: Scalars['Boolean']['output'];
  /** 현재 리뷰 제외, 가장 최근에 장소에 작성된 리뷰 */
  latestReviewGroup: Maybe<ReviewGroup>;
  /** 장소에 작성된 모든 리뷰 수 */
  reviewCount: Scalars['Int']['output'];
  /** 장소에 작성된 영상 리뷰 수 */
  videoReviewCount: Scalars['Int']['output'];
};

/** 리뷰그룹 증거 */
export type ReviewGroupProof = MissionStampProof & {
  __typename?: 'ReviewGroupProof';
  /** 미션 스탬프 증거의 고유 아이디 ex. 리뷰 그룹일 경우 리뷰그룹 아이디 */
  id: Scalars['String']['output'];
  /** 증거인 리뷰 그룹 */
  reviewGroup: Maybe<ReviewGroup>;
  /** 미션 스탬프 증거 유형 ex. 리뷰그룹 => "REVIEW_GROUP" */
  type: MisisonStampProofType;
};

export enum ReviewGroupReactionSort {
  /** 리액션 생성 시간 오래된순 */
  CreatedDateTimeAsc = 'CREATED_DATE_TIME_ASC',
  /** 리액션 생성 시간 최신순 */
  CreatedDateTimeDesc = 'CREATED_DATE_TIME_DESC'
}

/** 리뷰그룹의 리액션 조회 connection */
export type ReviewGroupReactionsConnection = {
  __typename?: 'ReviewGroupReactionsConnection';
  /** 리뷰그룹에 추가된 리액션 목록 */
  edges: Array<ReactionEdge>;
  /** 리뷰그룹의 리액션 목록 페이지 정보 */
  pageInfo: ReviewGroupReactionsPageInfo;
};

/** 리뷰그룹의 리액션 조회 input */
export type ReviewGroupReactionsConnectionInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** 앞에서부터 최대 `first` 갯수만큼 가져옵니다. */
  first?: InputMaybe<Scalars['Int']['input']>;
  reactionType: Scalars['String']['input'];
  reviewGroupId: Scalars['ID']['input'];
  sort: ReviewGroupReactionSort;
};

/** 리뷰그룹의 리액션 목록 페이지 정보 */
export type ReviewGroupReactionsPageInfo = {
  __typename?: 'ReviewGroupReactionsPageInfo';
  /** edges들의 마지막 커서 정보 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** 다음 페이지 유무 */
  hasNextPage: Scalars['Boolean']['output'];
};

/** 유저가 쓴 리뷰들의 지역별 분류 정보 */
export type ReviewGroupRegionCategory = {
  __typename?: 'ReviewGroupRegionCategory';
  /** 지역 코드 */
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
  reviewGroupsCount: Scalars['Int']['output'];
  /** 지역 분류 타입 (`읍면동` or `시군구`) */
  type: UserReviewGroupCategoryType;
};

/** 사장님이 리뷰에 남긴 답글 */
export type ReviewGroupReply = {
  __typename?: 'ReviewGroupReply';
  /** 표시될 작성자 이름 */
  author: Scalars['String']['output'];
  /** 답글이 생성된 시간 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 답글의 공개 여부 */
  isQualified: Scalars['Boolean']['output'];
  /** 답글의 게시 중단 여부 */
  isSuspended: Scalars['Boolean']['output'];
  /** 답글 내용 */
  text: Scalars['String']['output'];
  /** 답글이 수정된 시간 */
  updatedDateTime: Maybe<Scalars['DateTime']['output']>;
};

/** 리뷰그룹의 대표 pov를 설정합니다. */
export type ReviewGroupSelectedProofInput = {
  /** 선택된 pov의 아이디 입니다. ex. 영수증 아이디, 예약 아이디 */
  id: Scalars['ID']['input'];
};

/** 리뷰 그룹 상태 [MY플레이스 리뷰 미노출&게시중단 스펙 Wiki](https://oss.navercorp.com/place/local/wiki/MY%ED%94%8C%EB%A0%88%EC%9D%B4%EC%8A%A4-%EB%A6%AC%EB%B7%B0-%EB%AF%B8%EB%85%B8%EC%B6%9C-&-%EA%B2%8C%EC%8B%9C%EC%A4%91%EB%8B%A8-%EC%8A%A4%ED%8E%99-%EC%A0%95%EB%A6%AC) */
export enum ReviewGroupStatus {
  /** 리뷰가 삭제된 상태 */
  Deleted = 'DELETED',
  /** 시스템이 검수하기 전단계 */
  Hide = 'HIDE',
  /** 운영자 검수로 인한 게시 중단 */
  InspectReject = 'INSPECT_REJECT',
  /** 사용자가 비공개로 등록한 경우 */
  Private = 'PRIVATE',
  /** 다른사람이 볼 수 있는 공개 상태 */
  Showable = 'SHOWABLE'
}

/** 리뷰 그룹 조회 성공시 리턴 */
export type ReviewGroupSucceed = {
  __typename?: 'ReviewGroupSucceed';
  /** 조회한 리뷰그룹 */
  reviewGroup: ReviewGroup;
};

export type ReviewGroupUserStat = {
  __typename?: 'ReviewGroupUserStat';
  /** 로그인한 유저가 일단위 연속 리뷰 작성한 수 */
  dailyReviewStreakCount: Scalars['Int']['output'];
  /** 리뷰 아이디 */
  id: Scalars['ID']['output'];
  /** 로그인한 유저가 오늘 작성한 리뷰 수 */
  todayReviewCount: Scalars['Int']['output'];
  /** 로그인한 유저가 작성한 전체 리뷰 수 */
  totalReviewCount: Scalars['Int']['output'];
  /** 로그인한 유저가 주단위 연속 리뷰 작성한 수 */
  weeklyReviewStreakCount: Scalars['Int']['output'];
};

/** 리뷰그룹 생성시 필요한 방문 정보입니다. */
export type ReviewGroupVisitInput = {
  /** 방문한 날짜 */
  dateTime?: InputMaybe<Scalars['DateTime']['input']>;
  /** 영수증 방문의 아이디 */
  id: Scalars['ID']['input'];
};

export type ReviewGroupWriteStatOutput = AuthenticationError | ForbiddenError | ReviewGroupWriteStat_ReviewGroupNotFound | ReviewGroupWriteStat_Succeed | ReviewGroupWriteStat_TimeOver | UnknownError;

/** 리뷰그룹을 찾지 못했습니다. */
export type ReviewGroupWriteStat_ReviewGroupNotFound = BaseError & {
  __typename?: 'ReviewGroupWriteStat_ReviewGroupNotFound';
  message: Scalars['String']['output'];
};

/** 리뷰 작성 완료후 해당 리뷰 통계 조회 */
export type ReviewGroupWriteStat_Succeed = {
  __typename?: 'ReviewGroupWriteStat_Succeed';
  /** 리뷰에 대한 장소 통계 */
  reviewGroupPlaceStat: ReviewGroupPlaceStat;
  /** 리뷰에 대한 유저 통계 */
  reviewGroupUserStat: ReviewGroupUserStat;
};

/** 리뷰 작성/수정 이후 5분 초과 */
export type ReviewGroupWriteStat_TimeOver = BaseError & {
  __typename?: 'ReviewGroupWriteStat_TimeOver';
  message: Scalars['String']['output'];
};

/** 날짜 범위 기준으로 리뷰그룹 필터 / 시간이 있을때 타임존을 명시해주지 않으면 로컬 시간으로 계산됨 */
export enum ReviewGroupsDateTimeFilter {
  /** 생성일 */
  CreatedDateTime = 'CREATED_DATE_TIME',
  /** 최초공개일 */
  PublishedDateTime = 'PUBLISHED_DATE_TIME',
  /** 방문일 */
  VisitedDateTime = 'VISITED_DATE_TIME'
}

/** 날짜 범위 기준으로 리뷰그룹 필터 */
export type ReviewGroupsDateTimeFilterInput = {
  end?: InputMaybe<Scalars['DateTime']['input']>;
  filter: ReviewGroupsDateTimeFilter;
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** 미디어 기준으로 리뷰그룹 필터 */
export enum ReviewGroupsMediaFilter {
  /** 필터링 적용하지 않음 */
  All = 'ALL',
  /** 미디어 없는 리뷰그룹만 필터링 */
  WithoutMedia = 'WITHOUT_MEDIA',
  /** 미디어 있는 리뷰그룹만 필터링 */
  WithMedia = 'WITH_MEDIA'
}

/** 텍스트 기준으로 리뷰그룹 필터 */
export enum ReviewGroupsTextFilter {
  /** 필터링 적용하지 않음 */
  All = 'ALL',
  /** 텍스트 없는 리뷰그룹만 필터링 */
  WithoutText = 'WITHOUT_TEXT',
  /** 텍스트 있는 리뷰그룹만 필터링 */
  WithText = 'WITH_TEXT'
}

export type ReviewGruopReactionsOutput = ReviewGroupReactionsConnection | UnknownError;

/** 지역 주변 리뷰어 인풋 */
export type ReviewersAroundRegionInput = {
  /** 리뷰어들을 가지고 올 지역 코드 */
  regionCode: Scalars['String']['input'];
  /** location type은 제공하는 regionCode에 대하여, following type은 구독하고 있는 지역에 대하여 리뷰어를 추천 */
  type: Scalars['String']['input'];
};

export type ReviewersAroundRegionOutput = ReviewersAroundRegionSucceed | UnknownError;

/** 팔로잉 리뷰어가 간 다른 지역 피드 */
export type ReviewersAroundRegionSucceed = {
  __typename?: 'ReviewersAroundRegionSucceed';
  /** 콜렉션 리뷰어 */
  reviewers: Array<CollectionReviewer>;
};

/** 지역 주변 리뷰어 인풋 */
export type ReviewersOnCategoryInput = {
  /** 리뷰어들을 가지고 올 카테고리 ID */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** 리뷰어들을 가지고 올 지역 코드 */
  regionCode: Scalars['String']['input'];
  /** location type은 제공하는 regionCode에 대하여, following type은 구독하고 있는 지역에 대하여 리뷰어를 추천 */
  type: Scalars['String']['input'];
};

export type ReviewersOnCategoryOutput = ReviewersOnCategorySucceed | UnknownError;

/** 팔로잉 리뷰어가 간 다른 지역 피드 */
export type ReviewersOnCategorySucceed = {
  __typename?: 'ReviewersOnCategorySucceed';
  /** 카테고리 이름 */
  categoryName: Scalars['String']['output'];
  /** 콜렉션 리뷰어 */
  reviewers: Array<CategoryCollectionReviewer>;
};

export type ReviewersWithSimilarTasteOutput = ReviewersWithSimilarTasteSucceed | UnknownError;

/** 팔로잉 리뷰어가 간 다른 지역 피드 */
export type ReviewersWithSimilarTasteSucceed = {
  __typename?: 'ReviewersWithSimilarTasteSucceed';
  /** 콜렉션 리뷰어 */
  reviewers: Array<CollectionReviewer>;
};

/** 지도 검색 정렬 */
export enum SasSort {
  /** 거리순 */
  Distance = 'DISTANCE',
  /** 관련도순 */
  Relevance = 'RELEVANCE'
}

export type SavedPlaceBookmarksOutput = SavedPlaceBookmarks_Failed | SavedPlaceBookmarks_Succeed;

/** 내 모든 북마크 리스트 조회를 실패했습니다. */
export type SavedPlaceBookmarks_Failed = BaseError & {
  __typename?: 'SavedPlaceBookmarks_Failed';
  /** 내 모든 북마크 리스트 조회를 실패했습니다. */
  message: Scalars['String']['output'];
};

/** 내 모든 북마크 조회 성공시 리턴합니다 */
export type SavedPlaceBookmarks_Succeed = {
  __typename?: 'SavedPlaceBookmarks_Succeed';
  /** 조회한 북마크 리스트 */
  bookmarkList: Array<PlaceBookmark>;
  /** 10개 초과의 저장된 북마크가 있는지 여부 */
  hasMore: Scalars['Boolean']['output'];
};

export type SearchCheckIn = CheckIn & {
  __typename?: 'SearchCheckIn';
  /** 체크인 ID */
  id: Scalars['ID']['output'];
  /** 검색어 */
  keyword: Scalars['String']['output'];
  /** 체크인한 장소 */
  place: Maybe<Place>;
  /** 검색된 업체 ID 목록 */
  searchedPlaces: Array<Scalars['String']['output']>;
  /** 장소 직접 검색 체크인 */
  type: CheckInType;
};

/** 장소 직접 검색 체크인 생성 input */
export type SearchCheckInInput = {
  /** 질의어 */
  keyword: Scalars['String']['input'];
  /** 방문한 장소 id */
  placeId: Scalars['String']['input'];
  /** 검색 된 장소 id 리스트 */
  searchedPlaceIds: Array<Scalars['String']['input']>;
};

export type SearchLocationsOutput = AuthenticationError | SearchLocationsSucceed | UnknownError;

export type SearchLocationsSucceed = {
  __typename?: 'SearchLocationsSucceed';
  /** 검색된 구독 가능한 관심 장소 리스트 */
  searchedLocations: Array<InterestingLocation>;
};

export type SelectedProof = {
  __typename?: 'SelectedProof';
  /** 예약일 경우 예약상품 */
  bizItem: Maybe<BizItem>;
  /** 방문 증거의 아이디 ex) 방문 증거가 영수증이라면 영수증의 ID */
  id: Scalars['ID']['output'];
  /** 리뷰 작성자 혹은 장소의 사업주에게만 제공되는 Proof 정보 */
  private: Maybe<Proof>;
  /** 리뷰(그룹)의 아이디 */
  reviewGroupId: Scalars['ID']['output'];
  /** 방문 증거의 종류 */
  type: ProofType;
};

export type SharedFolderInput = {
  /** 영업 정보 존재 여부로 분류한 리스트, undefined면 모두, true면 영업정보 존재 북마크 리스트만, false면 영업정보 존재 하지 않는 북마크 리스트만 */
  available?: InputMaybe<Scalars['Boolean']['input']>;
  /** 조회할 bbox 영역 */
  bbox?: InputMaybe<Array<Scalars['Float']['input']>>;
  /** 북마크 카테고리 */
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** sort가 distance 일 때만 사용되는 값 */
  coordinate?: InputMaybe<CoordinateInput>;
  /** 장소정보 포함 여부 */
  placeInfo?: InputMaybe<Scalars['Boolean']['input']>;
  /** 북마크 범위 */
  range?: InputMaybe<FolderRange>;
  /** 폴더 share id */
  shareId: Scalars['ID']['input'];
  /** 폴더 내 북마크 정렬 순서 */
  sort?: InputMaybe<BookmarkSortType>;
};

export type SharedFolderOutput = SharedFolder_Failed | SharedFolder_Succeed;

/** 공유 폴더 조회에 실패했습니다. */
export type SharedFolder_Failed = BaseError & {
  __typename?: 'SharedFolder_Failed';
  /** 공유 폴더 조회에 실패했습니다. */
  message: Scalars['String']['output'];
  /** 조회한 공유 폴더 공유 아이디 */
  notFoundsharedFolderShareId: Scalars['String']['output'];
};

/** 공유 폴더 조회 성공시 리턴합니다 */
export type SharedFolder_Succeed = {
  __typename?: 'SharedFolder_Succeed';
  /** 조회한 공유 폴더 */
  folder: FolderDeletedOrNot;
};

export type SignUpOutput = AuthenticationError | ForbiddenError | NotFoundError | SignUp_Succeed | UnknownError;

/** 리뷰어 참여 성공시에 리턴합니다. */
export type SignUp_Succeed = {
  __typename?: 'SignUp_Succeed';
  user: User;
};

/** 단일 미션 그룹 */
export type SingleMissionGroup = MissionGroup & {
  __typename?: 'SingleMissionGroup';
  /** 미션 종료일 */
  endDateTime: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  /** 미션 */
  mission: Mission;
  /** 요청한 유저의 미션 활동, 비로그인 시 null */
  missionActivity: Maybe<MissionActivity>;
  /**
   * 미션 이름
   * @deprecated 미션별로 이름을 가지게 변경되었습니다. `mission.name` 을 써주세요.
   */
  name: Scalars['String']['output'];
  /** 스탬프가 찍히는 조건 */
  stampCondition: StampCondition;
  /** 미션 시작일 */
  startDateTime: Scalars['DateTime']['output'];
  /** 미션 그룹 타입 */
  type: MissionGroupType;
  /** 미션 페이지에서 노출 우선 순위를 위한 weight, 기본 내림차순으로 정렬 */
  weight: Scalars['Int']['output'];
};

/** 스탬프가 찍히는 조건 */
export enum StampCondition {
  /** 음식점 업종중 특정 업종 리뷰 작성 [업종 리스트](https://wiki.navercorp.com/pages/viewpage.action?pageId=1056728043) */
  FoodCategoryReview = 'FOOD_CATEGORY_REVIEW',
  /** [자연 관련 cid](https://wiki.navercorp.com/pages/viewpage.action?pageId=1471710982) 를 가진 장소 리뷰 작성시 */
  NatureCategoryReview = 'NATURE_CATEGORY_REVIEW',
  /** 사진 리뷰 작성시 */
  PhotoReview = 'PHOTO_REVIEW',
  /** Proof에 영수증이 있는 리뷰 작성시 */
  ReceiptReview = 'RECEIPT_REVIEW',
  /** 지역별(시단위, 서울만 시군구) 리뷰 작성시 */
  RegionReview = 'REGION_REVIEW',
  /** 모든 리뷰 */
  Review = 'REVIEW',
  /** 리뷰 조회수 달성시 */
  ReviewViews = 'REVIEW_VIEWS',
  /** 동영상 리뷰 작성시 */
  VideoReview = 'VIDEO_REVIEW'
}

/** 스탬프 그룹 배열을 가지는 미션 활동 내역 */
export type StampGroupMissionActivity = MissionActivity & {
  __typename?: 'StampGroupMissionActivity';
  id: Scalars['ObjectID']['output'];
  /** 미션 별 메타 정보(마지막 미션 완료 일시)를 담고 있는 배열 */
  missionStates: Array<MissionState>;
  /** 미션 스탬프 그룹의 배열 */
  stampGroups: Array<MissionStampGroup>;
};


/** 스탬프 그룹 배열을 가지는 미션 활동 내역 */
export type StampGroupMissionActivityStampGroupsArgs = {
  sort?: InputMaybe<MissionStampGroupOrder>;
};

/** 스탬프 배열을 가지는 미션 활동 내역 */
export type StampMissionActivity = MissionActivity & {
  __typename?: 'StampMissionActivity';
  id: Scalars['ObjectID']['output'];
  /** 미션 별 메타 정보(마지막 미션 완료 일시)를 담고 있는 배열 */
  missionStates: Array<MissionState>;
  /** 미션 스탬프 배열 */
  stamps: Array<MissionStamp>;
};

/** 마이플레이스에서 사용하는 [스태틱 맵](https://yobi.navercorp.com/Maps_maps-api/posts/278#1569374013029) 정보입니다. */
export type StaticMap = {
  __typename?: 'StaticMap';
  /** 마이플레이스에서 사용하는 caller 정보입니다. */
  caller: Scalars['String']['output'];
  /** 호스트 정보입니다. */
  host: Scalars['String']['output'];
  /** [방문 생성 과정에서 장소가 매칭](https://wiki.navercorp.com/pages/viewpage.action?pageId=1562086392)되었을 때, 노출하는 스태틱 맵에 필요한 정보입니다. */
  matchedPlace: MatchedPlaceStaticMap;
};

export type StaticMapBookmarksOutput = StaticMapBookmarks_Succeed | UnknownError;

/** 스태틱 맵 북마크 조회 성공시 리턴합니다 */
export type StaticMapBookmarks_Succeed = {
  __typename?: 'StaticMapBookmarks_Succeed';
  /** 유저의 위치 정보 동의 여부에 맞게 정렬된 스태틱 맵 북마크 리스트 */
  bookmarkList: Array<Bookmark>;
};

/** 스태틱 맵에 대한 정보 조회에 대한 응답입니다. */
export type StaticMapOutput = StaticMapSucceed | UnknownError;

/** 스태틱 맵 조회 성공시 리턴합니다. */
export type StaticMapSucceed = {
  __typename?: 'StaticMapSucceed';
  /** 스태틱 맵 정보를 리턴합니다. */
  staticMap: StaticMap;
};

/** 스텝형 미션 그룹, 하위 n개의 미션을 가지고 있음 */
export type StepMissionGroup = MissionGroup & {
  __typename?: 'StepMissionGroup';
  /** 미션 종료일 */
  endDateTime: Scalars['DateTime']['output'];
  id: Scalars['ObjectID']['output'];
  /** 요청한 유저의 미션 활동, 비로그인 시 null */
  missionActivity: Maybe<MissionActivity>;
  /** 스텝별 미션 */
  missions: Array<Mission>;
  /**
   * 미션 이름
   * @deprecated 미션별로 이름을 가지게 변경되었습니다. `mission.name` 을 써주세요.
   */
  name: Scalars['String']['output'];
  /** 스탬프가 찍히는 조건 */
  stampCondition: StampCondition;
  /** 미션 시작일 */
  startDateTime: Scalars['DateTime']['output'];
  /** 미션 그룹 타입 */
  type: MissionGroupType;
  /** 미션 페이지에서 노출 우선 순위를 위한 weight, 기본 내림차순으로 정렬 */
  weight: Scalars['Int']['output'];
};

/** 장소의 아이디와 이름 중 한 개는 있어야 합니다. */
export type SubPlaceInput = {
  /** 장소 아이디 */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** 장소 이름 */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** 구독지역 쿼리 input */
export type SubscribedLocationsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SubscribedLocationsSort>;
};

export type SubscribedLocationsOutput = AuthenticationError | SubscribedLocationsSucceed | UnknownError;

/** 구독지역 정렬 */
export enum SubscribedLocationsSort {
  /** 유저가 설정한 순서 */
  Default = 'DEFAULT',
  /** 리뷰수 내림차순 */
  ReviewCountDesc = 'REVIEW_COUNT_DESC'
}

export type SubscribedLocationsSucceed = {
  __typename?: 'SubscribedLocationsSucceed';
  /** 개인이 구독중인 장소들 */
  subscribedLocations: Array<InterestingLocation>;
};

/** 유저가 구독한 태그 connection */
export type SubscriptionTagsConnection = {
  __typename?: 'SubscriptionTagsConnection';
  /** 유저가 구독한 태그 엣지 목록 */
  edges: Array<SubscriptionTagsEdge>;
  /** 태그 구독 페이지의 메타데이터 */
  pageInfo: SubscriptionTagsPageInfo;
};

/** 유저가 구독한 태그 edge */
export type SubscriptionTagsEdge = {
  __typename?: 'SubscriptionTagsEdge';
  /** 구독한 태그 */
  tag: Tag;
};

/** 이전, 다음 페이지 유무를 알 수 없어 시작과 끝의 커서만 가진 페이지 메타데이터 타입입니다. */
export type SubscriptionTagsPageInfo = {
  __typename?: 'SubscriptionTagsPageInfo';
  /** edges들의 마지막 커서 정보 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** edges들의 시작 커서 정보 */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** 태그 정보입니다. */
export type Tag = {
  __typename?: 'Tag';
  /** 태그 구독 일시 */
  followDate: Maybe<Scalars['DateTime']['output']>;
  /** 태그의 그룹 정보 */
  group: TagGroup;
  /** 태그의 아이디 */
  id: Scalars['String']['output'];
  /** 태그의 메타데이터 */
  metadata: Maybe<TagMetadata>;
};

/** 태그 주변 정보 */
export enum TagAround {
  /** 회사 주변 */
  Company = 'COMPANY',
  /** 집 주변 */
  Home = 'HOME',
  /** 학교 주변 */
  School = 'SCHOOL'
}

export type TagCountOutput = AuthenticationError | TagCountSucceed | UnknownError;

/** 구독한 태그 갯수 조회 성공시 리턴합니다. */
export type TagCountSucceed = {
  __typename?: 'TagCountSucceed';
  /** 구독한 태그 갯수 */
  count: Scalars['Int']['output'];
};

/** 태그 그룹 정보 */
export enum TagGroup {
  /** 내 주변 태그 */
  Around = 'AROUND',
  /** 지역 x 태그 ID 조합 그룹 */
  LocTag = 'LOC_TAG',
  /** 태그 ID */
  Tag = 'TAG'
}

export type TagInput = {
  /** 태그 구독 일시 */
  followDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** 태그의 그룹 정보 */
  group: TagGroup;
  /** 태그의 아이디 */
  id: Scalars['String']['input'];
  /** 태그의 메타데이터 */
  metadata?: InputMaybe<TagMetadataInput>;
};

/** 태그 메타데이터 정보입니다. 메타 데이터는 태그 구독시 전달 받은 데이터로 전체 필드가 nullable로 관리됩니다. */
export type TagMetadata = {
  __typename?: 'TagMetadata';
  /** 주변 값 ex) 집, 회사, 학교 */
  around: Maybe<TagAround>;
  /** 태그 설명 문구 ex) `인생샷 찍고 프사 교체 지금 고?` */
  description: Maybe<Scalars['String']['output']>;
  /** 태그 아이디 */
  id: Maybe<Scalars['String']['output']>;
  /** 구독 여부 무시, true 면 구독 여부와 상관 없이 노출합니다. */
  ignoreSubscription: Maybe<Scalars['Boolean']['output']>;
  /** 성인 관련 태그 여부 */
  isAdult: Maybe<Scalars['Boolean']['output']>;
  /** 태그에서 사용하는 지역 정보입니다. */
  region: Maybe<TagRegion>;
  /** 노출할 지역 정보, 2/5/8 로 `useRegionName` 필드가 true이면서 치환이 필요한 태그면 지역 레벨에 따라 지역명 노출을 결정합니다. */
  regionLevel: Maybe<Scalars['Int']['output']>;
  /** 할인 혜택 정보 유무 */
  showPromotion: Maybe<Scalars['Boolean']['output']>;
  /** 태그에서 사용하는 스팟 정보입니다. */
  spot: Maybe<TagSpot>;
  /** 특정 연령대 목록 ex) ["20", "none"] */
  targetAge: Maybe<Array<Scalars['String']['output']>>;
  /** 태그명 ex) `20대 핫한 감성스팟` */
  title: Maybe<Scalars['String']['output']>;
  /** 치환명에 지역명 사용 여부 */
  useRegionName: Maybe<Scalars['Boolean']['output']>;
};

export type TagMetadataInput = {
  /** 주변 값 ex) 집, 회사, 학교 */
  around?: InputMaybe<TagAround>;
  /** 태그 설명 문구 ex) `인생샷 찍고 프사 교체 지금 고?` */
  description?: InputMaybe<Scalars['String']['input']>;
  /** 태그 아이디 */
  id?: InputMaybe<Scalars['String']['input']>;
  /** 구독 여부 무시, true 면 구독 여부와 상관 없이 노출합니다. */
  ignoreSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  /** 성인 관련 태그 여부 */
  isAdult?: InputMaybe<Scalars['Boolean']['input']>;
  /** 태그에서 사용하는 지역 정보입니다. */
  region?: InputMaybe<TagRegionInput>;
  /** 노출할 지역 정보, 2/5/8 로 `useRegionName` 필드가 true이면서 치환이 필요한 태그면 지역 레벨에 따라 지역명 노출을 결정합니다. */
  regionLevel?: InputMaybe<Scalars['Int']['input']>;
  /** 할인 혜택 정보 유무 */
  showPromotion?: InputMaybe<Scalars['Boolean']['input']>;
  /** 태그에서 사용하는 스팟 정보입니다. */
  spot?: InputMaybe<TagSpotInput>;
  /** 특정 연령대 목록 ex) ["20", "none"] */
  targetAge?: InputMaybe<Array<Scalars['String']['input']>>;
  /** 태그명 ex) `20대 핫한 감성스팟` */
  title?: InputMaybe<Scalars['String']['input']>;
  /** 치환명에 지역명 사용 여부 */
  useRegionName?: InputMaybe<Scalars['Boolean']['input']>;
};

/** 태그에서 사용하는 지역 정보입니다. [Region & Spot 사전](https://wiki.navercorp.com/pages/viewpage.action?pageId=565319015) */
export type TagRegion = {
  __typename?: 'TagRegion';
  /** 중심 좌표, 구분자 ^ ex) 127.729750^37.885399 */
  centerCoordinate: Maybe<Scalars['String']['output']>;
  /** 노출명 (관심지역 리스트) */
  locationName: Maybe<Scalars['String']['output']>;
  /** 노출명 (리뷰어 카드) */
  name: Maybe<Scalars['String']['output']>;
  /** 지역 코드, 시/구/동 단위 모두 포함 ex) 01 */
  rcode: Maybe<Scalars['String']['output']>;
  /** 검색 반경, 구분자 ^ ex) 127.094992^37.027832^129.365665^38.622034 */
  searchRadius: Maybe<Scalars['String']['output']>;
};

export type TagRegionInput = {
  /** 중심 좌표, 구분자 ^ ex) 127.729750^37.885399 */
  centerCoordinate?: InputMaybe<Scalars['String']['input']>;
  /** 노출명 (관심지역 리스트) */
  locationName?: InputMaybe<Scalars['String']['input']>;
  /** 노출명 (리뷰어 카드) */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 지역 코드, 시/구/동 단위 모두 포함 ex) 01 */
  rcode?: InputMaybe<Scalars['String']['input']>;
  /** 검색 반경, 구분자 ^ ex) 127.094992^37.027832^129.365665^38.622034 */
  searchRadius?: InputMaybe<Scalars['String']['input']>;
};

/** 태그에서 사용하는 스팟 정보입니다. [Region & Spot 사전](https://wiki.navercorp.com/pages/viewpage.action?pageId=565319015) */
export type TagSpot = {
  __typename?: 'TagSpot';
  /** 중심 좌표, 구분자 ^ ex) 127.0230886^37.5196922	 */
  centerCoordinate: Maybe<Scalars['String']['output']>;
  /** 노출명 (리뷰어 카드) ex) 가로수길 */
  name: Maybe<Scalars['String']['output']>;
  /** 지역 코드 ex) 09680105 */
  rcode: Maybe<Scalars['String']['output']>;
  /** 검색 반경, 구분자 ^ ex) 127.0209189^37.5171914^127.0260158^37.5248801 */
  searchRadius: Maybe<Scalars['String']['output']>;
  /** 스팟 카테고리, 기획 스팟 선정시 참고용 ex) Travel, Attraction/Street;여행,명소>거리,골목	 */
  spotCategory: Maybe<Scalars['String']['output']>;
  /** 스팟 코드 ex) 13491811 */
  spotCode: Maybe<Scalars['String']['output']>;
};

export type TagSpotInput = {
  /** 중심 좌표, 구분자 ^ ex) 127.0230886^37.5196922	 */
  centerCoordinate?: InputMaybe<Scalars['String']['input']>;
  /** 노출명 (리뷰어 카드) ex) 가로수길 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 지역 코드 ex) 09680105 */
  rcode?: InputMaybe<Scalars['String']['input']>;
  /** 검색 반경, 구분자 ^ ex) 127.0209189^37.5171914^127.0260158^37.5248801 */
  searchRadius?: InputMaybe<Scalars['String']['input']>;
  /** 스팟 카테고리, 기획 스팟 선정시 참고용 ex) Travel, Attraction/Street;여행,명소>거리,골목	 */
  spotCategory?: InputMaybe<Scalars['String']['input']>;
  /** 스팟 코드 ex) 13491811 */
  spotCode?: InputMaybe<Scalars['String']['input']>;
};

/** 구독한 태그를 조회할 때 전달할 정보입니다. `first`와 `last`는 같이 사용할 수 없습니다. */
export type TagsInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** before cursor, 이 이전까지 조회합니다. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** 앞에서부터 최대 `first` 갯수만큼 가져옵니다. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** 뒤에서부터 최대 `last` 갯수만큼 가져옵니다 */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type TagsOutput = AuthenticationError | ConnectionArgsError | TagsSucceed | UnknownError;

/** 구독 태그 목록 조회 성공시 connection 정보를 리턴합니다. */
export type TagsSucceed = {
  __typename?: 'TagsSucceed';
  /** 구독 태그 connection */
  connection: SubscriptionTagsConnection;
};

export type Themelist = {
  __typename?: 'Themelist';
  /** 테마리스트 고유 색상 번호 */
  colorNumber: Scalars['Float']['output'];
  /** 테마리스트 커버용 영상 및 이미지 */
  coverMediaItem: Maybe<MediaItem>;
  /** 테마리스트 설명 */
  description: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 로그인한 유저의 테마리스트인지 여부 */
  isMine: Scalars['Boolean']['output'];
  /** 테마리스트 공개 여부 */
  isPublic: Scalars['Boolean']['output'];
  /** 테마리스트에 추가된 리뷰 - 타인뷰에서 미노출 리뷰 제외 */
  reviewGroups: Array<ReviewGroup>;
  statistic: ThemelistStatistic;
  /** 테마리스트 제목 */
  title: Scalars['String']['output'];
  user: User;
};

/** 테마리스트 edge */
export type ThemelistEdge = {
  __typename?: 'ThemelistEdge';
  themelist: Themelist;
};

export type ThemelistOutput = NotFoundError | ThemelistSucceed | UnknownError;

export type ThemelistStatistic = {
  __typename?: 'ThemelistStatistic';
  /** 테마리스트에 포함된 장소 중 ibu 기준 승인된 장소 갯수(폐업, 일시정지 제외), 타인뷰에서 미노출 리뷰의 장소 카운트 제외 */
  placesCount: Scalars['Int']['output'];
  /** 테마리스트에 포함된 리뷰 갯수 - 타인뷰에서 미노출 리뷰 카운트 제외 */
  reviewGroupsCount: Scalars['Int']['output'];
  /** 테마리스트 조회수 */
  viewCount: Scalars['Int']['output'];
};

export type ThemelistSucceed = {
  __typename?: 'ThemelistSucceed';
  /** 조회된 테마리스트 */
  themelist: Themelist;
};

/** 지역별 테마리스트 가져오기 input */
export type ThemelistsByRegionCodesInput = {
  regionCodes: Array<Scalars['String']['input']>;
};

export type ThemelistsByRegionCodesOutput = ThemelistsByRegionCodesSucceed | UnknownError;

/** 주변 테마리스트 성공시 응답 */
export type ThemelistsByRegionCodesSucceed = {
  __typename?: 'ThemelistsByRegionCodesSucceed';
  /** 주변 테마리스트 */
  themelists: Array<Themelist>;
};

/** 테마리스트 connection */
export type ThemelistsConnection = {
  __typename?: 'ThemelistsConnection';
  /** 테마리스트 목록 */
  edges: Array<ThemelistEdge>;
  /** 테마리스트 목록 페이지 정보 */
  pageInfo: ThemelistsPageInfo;
};

/** 테마리스트 커서 정보 */
export type ThemelistsConnectionInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** 앞에서부터 최대 `first` 갯수만큼 가져옵니다. */
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** 테마리스트 목록 페이지 정보 */
export type ThemelistsPageInfo = {
  __typename?: 'ThemelistsPageInfo';
  /** edges들의 마지막 커서 정보 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** 다음 페이지 유무 */
  hasNextPage: Scalars['Boolean']['output'];
};

/** 실험 이벤트 전송 입력 */
export type TrackEventInput = {
  /** 이벤트 클릭코드 */
  clickCode: Scalars['String']['input'];
  /** 실험 키 */
  expId: Scalars['String']['input'];
  /** 실험 세션 아이디 */
  sessionId: Scalars['String']['input'];
  /** 실험 명 */
  variantName: Scalars['String']['input'];
};

export type TrackEventOutput = AuthenticationError | TrackEvent_Succeed | UnknownError;

/** 실험 이벤트 전송 성공 */
export type TrackEvent_Succeed = {
  __typename?: 'TrackEvent_Succeed';
  success: Scalars['Boolean']['output'];
};

/**
 * 트레일러 정보입니다.
 * ⚠️ 만료 시간은 9시간입니다.
 */
export type Trailer = {
  __typename?: 'Trailer';
  /** 트레일러 URL입니다. */
  url: Scalars['URLString']['output'];
  /** VodCloud Video Id 입니다. */
  videoId: Scalars['String']['output'];
};

/** 트레일러 조회 실패시 리턴합니다. */
export type TrailerFailed = BaseError & {
  __typename?: 'TrailerFailed';
  message: Scalars['String']['output'];
};

export type TrailerOutput = TrailerFailed | TrailerSucceed;

/** 트레일러 URL 조회 성공시 리턴합니다. */
export type TrailerSucceed = {
  __typename?: 'TrailerSucceed';
  /** 조회한 트레일러 정보입니다. */
  trailer: Trailer;
};

/** 사용자를 차단해제하기 위해 필요한 값 */
export type UnblockUserInput = {
  /** 차단해제할 사용자의 idno */
  userIdno: Scalars['String']['input'];
};

export type UnblockUserOutput = UnblockUser_NotFound | UnblockUser_Succeed | UnknownError;

/** 차단된적 없는 사용자를 차단해제 할경우 */
export type UnblockUser_NotFound = BaseError & {
  __typename?: 'UnblockUser_NotFound';
  message: Scalars['String']['output'];
};

/** 사용자 차단 해제 성공 응답 */
export type UnblockUser_Succeed = {
  __typename?: 'UnblockUser_Succeed';
  success: Scalars['Boolean']['output'];
};

export type UnfollowFolderInput = {
  /** 폴더에 대한 팔로잉 아이디 */
  followId: Scalars['Int']['input'];
};

export type UnfollowFolderOutput = Authentication_Failed | UnfollowFolder_Failed | UnfollowFolder_Succeed;

/** 폴더 팔로잉 취소를 실패했습니다. */
export type UnfollowFolder_Failed = BaseError & {
  __typename?: 'UnfollowFolder_Failed';
  message: Scalars['String']['output'];
};

/** 폴더 팔로우 취소 성공시 리턴합니다 */
export type UnfollowFolder_Succeed = {
  __typename?: 'UnfollowFolder_Succeed';
  /** 삭제한 팔로잉 아이디 */
  followId: Scalars['Int']['output'];
};

/** 알 수 없는 오류가 발생했습니다 */
export type UnknownError = BaseError & {
  __typename?: 'UnknownError';
  /** 알 수 없는 오류 발생시 전달할 메세지 */
  message: Scalars['String']['output'];
};

export type UpdateAutoAcceptFollowOutput = AuthenticationError | UnknownError | UpdateAutoAcceptFollowSuccess;

/** 팔로우 자동 수락 여부 성공시 응답 */
export type UpdateAutoAcceptFollowSuccess = {
  __typename?: 'UpdateAutoAcceptFollowSuccess';
  user: User;
};

export type UpdateBookmarkFolderMappingInput = {
  /** 즐겨찾기를 추가할 폴더 ID들 */
  addFolderIds: Array<Scalars['Int']['input']>;
  /** 즐겨찾기를 삭제할 폴더 ID들 */
  removeFolderIds: Array<Scalars['Int']['input']>;
};

export type UpdateBookmarkInput = {
  /** 변경할 즐겨찾기 별명 / displayName */
  alias?: InputMaybe<Scalars['String']['input']>;
  /** 업데이트 할 즐겨찾기(북마크) 아이디 */
  bookmarkId: Scalars['Int']['input'];
  /** 즐겨찾기를 추가 / 삭제할 폴더 아이디 리스트 */
  mappingFolders: UpdateBookmarkFolderMappingInput;
  /** 변경할 즐겨찾기 메모 */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** 변경할 사용자가 입력한 URL / 즐겨찾기 관한 URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateBookmarkOutput = AuthenticationError | UnknownError | UpdateBookmark_Succeed;

export type UpdateBookmark_Succeed = {
  __typename?: 'UpdateBookmark_Succeed';
  /** 해당 북마크가 추가된 폴더 아이디 리스트 */
  addedFolderIds: Array<Scalars['Int']['output']>;
  /** 업데이트 작업 이후 최종적으로 해당 북마크가 즐겨찾기에서 제거되었는지 여부 */
  bookmarkRemoved: Scalars['Boolean']['output'];
  /** 추가 / 삭제를 신청했으나 존재하지 않는 폴더 아이디 */
  nonExistentFolderIds: Array<Scalars['Int']['output']>;
  /** 해당 북마크가 삭제된 폴더 아이디 리스트 */
  removedFolderIds: Array<Scalars['Int']['output']>;
  /** 추가 / 삭제를 신청했으나 이미 해당 작업이 이미 되어있는 폴더 아이디 */
  skippedFolderIds: Array<Scalars['Int']['output']>;
  /** 변경된 북마크 필드 정보들 / null로 return된 값은 변화하지 않은 필드 */
  updatedFields: UpdatedBookmark_Fields;
};

export type UpdateFolderInput = {
  /** 색코드 */
  colorCode?: InputMaybe<Scalars['String']['input']>;
  /** 외부 링크 */
  externalLink?: InputMaybe<Scalars['String']['input']>;
  /** 폴더 아이디 */
  folderId?: InputMaybe<Scalars['Int']['input']>;
  /** 공개범위 */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** 폴더 메모 */
  memo?: InputMaybe<Scalars['String']['input']>;
  /** 폴더 이름 */
  name?: InputMaybe<Scalars['String']['input']>;
  /** 오버레이 여부 */
  shouldOverlay?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateFolderOutput = Authentication_Failed | UpdateFolder_Failed | UpdateFolder_Succeed;

/** 폴더 업데이트를 실패했습니다. */
export type UpdateFolder_Failed = BaseError & {
  __typename?: 'UpdateFolder_Failed';
  message: Scalars['String']['output'];
};

/** 폴더 생성 성공시 리턴합니다 */
export type UpdateFolder_Succeed = {
  __typename?: 'UpdateFolder_Succeed';
  /** 폴더 */
  folder: Folder;
};

/** 유저 이용제한 기간 업데이트 중 오류가 발생했습니다. */
export type UpdateGreyUserUnavailableFailed = BaseError & {
  __typename?: 'UpdateGreyUserUnavailableFailed';
  /** 유저 이용제한 기간 업데이트 중 오류 */
  message: Scalars['String']['output'];
};

export type UpdateGreyUserUnavailableOutput = AuthenticationError | UpdateGreyUserUnavailableFailed | UpdateGreyUserUnavailableSucceed;

export type UpdateGreyUserUnavailableSucceed = {
  __typename?: 'UpdateGreyUserUnavailableSucceed';
  user: User;
};

export type UpdateMyProfileInput = {
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  introduction?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  originImageUrl?: InputMaybe<Scalars['String']['input']>;
  /** 프로필 초기화 알림 */
  shouldNoticeReset?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UpdateMyProfileOutput = DuplicateNicknameError | InspectedImageError | InvalidIntroductionError | InvalidNicknameError | PwordError | UpdateMyProfileSucceed;

/** 업데이트 된 유저 정보를 리턴합니다. */
export type UpdateMyProfileSucceed = {
  __typename?: 'UpdateMyProfileSucceed';
  user: User;
};

/** 리뷰그룹 업데이트 시 전달할 input 타입입니다. */
export type UpdateReviewGroupInput = {
  /** 작성한 리뷰 그룹 내용, 필드 중 하나는 있어야 함 */
  content: ReviewContentInput;
  /** 업데이트할 리뷰그룹 아이디 */
  id: Scalars['String']['input'];
  /** 클린봇(텍스트 검열) 무시 여부 */
  ignoreCleanBot?: InputMaybe<Scalars['Boolean']['input']>;
  /** 리뷰에게 평가한 별점 (예약 리뷰의 경우 DL05, DL19일 때만 사용), 있을 경우에만 업데이트합니다. */
  rating?: InputMaybe<Scalars['Float']['input']>;
  /** 리뷰그룹의 대표 pov 정보 */
  selectedProof: ReviewGroupSelectedProofInput;
};

/** 리뷰그룹 업데이트시 리턴하는 타입입니다. */
export type UpdateReviewGroupOutput = AuthenticationError | CleanBotError | ForbiddenError | MobileAppOnlyError | ReviewGroupKeywordNotValid | ReviewGroupOverflowMaxKeywordCount | ReviewGroupOverflowMaxTextLength | UnknownError | UpdateReviewGroup_NoContent | UpdateReviewGroup_ReviewGroupNotFound | UpdateReviewGroup_SelectedProofNotFound | UpdateReviewGroup_Succeed;

/** 리뷰 내용이 존재하지 않습니다. */
export type UpdateReviewGroup_NoContent = BaseError & {
  __typename?: 'UpdateReviewGroup_NoContent';
  message: Scalars['String']['output'];
};

/** 리뷰그룹을 찾지 못했습니다. */
export type UpdateReviewGroup_ReviewGroupNotFound = BaseError & {
  __typename?: 'UpdateReviewGroup_ReviewGroupNotFound';
  message: Scalars['String']['output'];
};

/** 선택한 pov를 찾지 못했습니다. */
export type UpdateReviewGroup_SelectedProofNotFound = BaseError & {
  __typename?: 'UpdateReviewGroup_SelectedProofNotFound';
  message: Scalars['String']['output'];
};

/** 리뷰그룹 업데이트 성공시 리턴합니다. */
export type UpdateReviewGroup_Succeed = {
  __typename?: 'UpdateReviewGroup_Succeed';
  /** 리뷰그룹 수정 이후 이동할 URL */
  redirectUrl: Scalars['String']['output'];
  /**
   * 스탬프가 취소된 미션그룹 배열
   * @deprecated 클라이언트에서 사용하지 않는 필드
   */
  revertedMissionGroups: Array<MissionGroup>;
  /** 업데이트된 리뷰그룹 */
  reviewGroup: ReviewGroup;
  /**
   * 스탬프가 찍힌 미션그룹 배열
   * @deprecated 클라이언트에서 사용하지 않는 필드
   */
  stampedMissionGroups: Array<MissionGroup>;
};

export type UpdateSubscribedLocationsInput = {
  /** 업데이트할 구독 장소들 */
  locations: Array<UpdatedSubscribedLocationInput>;
};

export type UpdateSubscribedLocationsOutput = AuthenticationError | UpdateSubscribedLocations_Failed | UpdateSubscribedLocations_Succeed;

/** 구독 장소들 업데이트에 실패했습니다. */
export type UpdateSubscribedLocations_Failed = BaseError & {
  __typename?: 'UpdateSubscribedLocations_Failed';
  message: Scalars['String']['output'];
};

/** 폴더 생성 성공시 리턴합니다 */
export type UpdateSubscribedLocations_Succeed = {
  __typename?: 'UpdateSubscribedLocations_Succeed';
  /** 구독 장소들 업데이트 성공 여부 */
  success: Scalars['Boolean']['output'];
};

/** 새로운 구독 태그 목록 설정시 전달하는 정보입니다. (기존 태그 목록에서 변경합니다.) */
export type UpdateTagsInput = {
  /** 구독을 유지할 태그 아이디 목록입니다. */
  ids: Array<Scalars['String']['input']>;
};

/** 구독 태그 목록 업데이트 성공시 리턴합니다. */
export type UpdateTagsSucceed = {
  __typename?: 'UpdateTagsSucceed';
  /** 변경된 구독 태그 목록입니다. `metadata`와 `followDate`는 null로 채워집니다. [API 참고](https://wiki.navercorp.com/pages/viewpage.action?pageId=1119525050) */
  tags: Array<Tag>;
};

export type UpdateThemelistInput = {
  /** 테마리스트 커버용 미디어 */
  coverMediaItem?: InputMaybe<MediaItemInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** 전체 공개 여부 */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  reviewGroupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatedBookmark_Fields = {
  __typename?: 'UpdatedBookmark_Fields';
  /** 변경된 즐겨찾기 별명 / displayName */
  alias: Maybe<Scalars['String']['output']>;
  /** 변경된 즐겨찾기 메모 */
  memo: Maybe<Scalars['String']['output']>;
  /** 변경된 사용자가 입력한 URL / 즐겨찾기 관한 URL */
  url: Maybe<Scalars['String']['output']>;
};

export type UpdatedSubscribedLocationInput = {
  /** 장소 표기 이름 */
  displayName: Scalars['String']['input'];
  /** 장소 아이디 / rcode or spot_rcode */
  regionCode: Scalars['String']['input'];
};

export type User = {
  __typename?: 'User';
  blockCount: Scalars['Int']['output'];
  /** 유저의 예약 관련 통계 정보 (비로그인 시 null) */
  bookingStat: Maybe<BookingStat>;
  created: Maybe<Scalars['DateTime']['output']>;
  /** 사용자 등급 - 로그인한 유저 본인에게만 제공되는 필드입니다. 타인의 경우 `null`로 고정됩니다 */
  currentGrade: Maybe<UserGrade>;
  /** 로그인한 유저가 이 유저에게 팔로우 신청했는지 여부 */
  didIRequestFollow: Scalars['Boolean']['output'];
  /** 최초로 방문한 리뷰(=유저가 작성한 리뷰중에 방문 일자가 가장 오래된경우) */
  firstVisitReviewGroup: Maybe<ReviewGroup>;
  id: Scalars['ObjectID']['output'];
  idno: Scalars['String']['output'];
  /** 팔로우 자동 수락 여부 */
  isAutoAcceptingFollow: Scalars['Boolean']['output'];
  /** 로그인한 유저가 차단한 유저인지 여부 */
  isBlocked: Scalars['Boolean']['output'];
  /** 로그인한 유저에게 팔로우 신청한 유저인지 여부 */
  isFollowRequester: Scalars['Boolean']['output'];
  /** 로그인한 유저가 팔로잉한 유저인지 여부 */
  isFriend: Scalars['Boolean']['output'];
  /** MY플레이스 DB에 존재하는 유저 여부 */
  isInDatabase: Scalars['Boolean']['output'];
  /** 네이버 위치정보제공동의 여부 - isLocationAgreement은 로그인한 유저 본인에게만 제공되는 필드입니다. 타인의 경우 `false`로 고정됩니다. */
  isLocationAgreement: Scalars['Boolean']['output'];
  /** isNPaySigned은 로그인한 유저 본인에게만 제공되는 필드입니다. 타인의 경우 `false`로 고정됩니다. */
  isNPaySigned: Scalars['Boolean']['output'];
  /** 영수증 리뷰참여 권한 여부 - 영수증약관 미동의일경우 `false` / 타인뷰 `false` */
  isParticipant: Scalars['Boolean']['output'];
  /** isRealName은 로그인한 유저 본인에게만 제공하는 필드입니다. 타인의 경우 `false`로 고정됩니다. */
  isRealName: Scalars['Boolean']['output'];
  /** 마지막 등급변경 이력 - 로그인한 유저 본인에게만 제공되는 필드입니다. 타인뷰거나 등급이 없는 경우(마플지면에서 방문인증을 하지 않은 경우 - ex 예약 방문만 한 경우) `null`로 반환합니다. */
  lastGradeHistory: Maybe<GradeHistory>;
  /** 로그인 유저의 `m-loc` 쿠키에 기반한 마지막 접속 장소, 타인일 경우 null */
  lastLocation: Maybe<Location>;
  /** 네이버 위치정보제공동의 여부 페이지로 이동을 위한 세션키 - 로그인 유저 본인에게만 제공, 타인일 경우 `null` */
  locationAgreementSessionKey: Maybe<Scalars['String']['output']>;
  /** 마스킹 처리된 네이버 아이디 ex) nv_**** - 닉네임이 없을경우 대신 제공 */
  maskedNaverId: Maybe<Scalars['String']['output']>;
  /** 마이플레이스 전용 프로필 */
  profile: Profile;
  /** 유저의 통계 정보 */
  stat: UserStat;
  updated: Maybe<Scalars['DateTime']['output']>;
};

/** 유저 edge */
export type UserEdge = {
  __typename?: 'UserEdge';
  user: User;
};

/** Me query error */
export enum UserError {
  /** 접근 권한이 없습니다. (헤더의 로그인 유저 정보와 애플리케이션의 유저 정보가 다릅니다.) */
  NotAuthorization = 'NOT_AUTHORIZATION',
  /** 로그인이 필요합니다. */
  NotLogin = 'NOT_LOGIN',
  /** 사용자를 찾을 수 없습니다. */
  UserNotFound = 'USER_NOT_FOUND'
}

/** 사용자 등급 */
export enum UserGrade {
  /** 영구 사용 중지 */
  Black = 'BLACK',
  /** 사용자가 마플 정보수집에 동의하면 자동으로 `일반` 등급이됨 */
  Common = 'COMMON',
  /** 회사 내부 계정들 구분 용도로 현재 사용 중. 추후에는 모범 유저들 분류하는데 사용할 수도 있음 */
  Green = 'GREEN',
  /** 마플 사용 일시중지 (제한날짜에 따라 grey, grey_second, grey_third) */
  Grey = 'GREY',
  /** 마플 사용 일시중지 (제한날짜에 따라 grey, grey_second, grey_third) */
  GreySecond = 'GREY_SECOND',
  /** 마플 사용 일시중지 (제한날짜에 따라 grey, grey_second, grey_third) */
  GreyThird = 'GREY_THIRD',
  /**
   * 3.40.0 이후로 common 등급과 동일하게 간주
   * [link](https://oss.navercorp.com/place/local/issues/12900#issuecomment-9847115)
   */
  Orange = 'ORANGE',
  /** 어뷰저 의심 계정들. 현재 거의 사용하고 있지 않음 */
  Yellow = 'YELLOW'
}

export type UserOutput = User_Failed | User_Succeed;

/** 유저가 남긴 리액션 edge */
export type UserReactionEdge = {
  __typename?: 'UserReactionEdge';
  /** 리액션 cursor */
  cursor: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** 유저의 리액션 */
  reaction: Reaction;
  /** 리액션 대상 리뷰 */
  reviewGroup: ReviewGroup;
};

export type UserReactionStatOutput = AuthenticationError | ReactionStatSucceed | UnknownError;

/** 유저가 남긴 리액션 커넥션 */
export type UserReactionsConnection = {
  __typename?: 'UserReactionsConnection';
  edges: Array<UserReactionEdge>;
  pageInfo: UserReactionsPageInfo;
};

/** 유저가 남긴 리액션 조회 input */
export type UserReactionsInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  /** 리액션 종류 - 입력하지 않을 경우 전체 조회 */
  reactionType?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<ReviewGroupReactionSort>;
};

export type UserReactionsOutput = AuthenticationError | UnknownError | UserReactionsConnection;

/** 유저가 남긴 리액션목록 페이지 정보 */
export type UserReactionsPageInfo = {
  __typename?: 'UserReactionsPageInfo';
  /** edges들의 마지막 커서 정보 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** 다음 페이지 유무 */
  hasNextPage: Scalars['Boolean']['output'];
};

/** 한 유저와 타인이 갖는 관계 타입 */
export enum UserRelationshipType {
  /** 유저가 차단한 관계 */
  Block = 'BLOCK',
  /** 유저의 팔로워 관계 */
  Follower = 'FOLLOWER',
  /** 유저가 팔로잉 하는 관계 */
  Following = 'FOLLOWING',
  /** 유저가 팔로잉 요청을 보낸 관계 */
  FollowRequest = 'FOLLOW_REQUEST',
  /** 유저가 팔로우 요청을 받은 관계 */
  FollowRequester = 'FOLLOW_REQUESTER'
}

/** 관련된 유저 리스트의 커넥션 */
export type UserRelationshipsConnection = {
  __typename?: 'UserRelationshipsConnection';
  /** 관련된 유저 리스트 */
  edges: Array<UserEdge>;
  /** 관련된 유저 리스트의 pagination 정보 */
  pageInfo: UserRelationshipsPageInfo;
};

/** 한 유저로부터 관련된 유저들을 불러오는 입력 타입 */
export type UserRelationshipsInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** 앞에서부터 최대 `first` 갯수만큼 가져옵니다. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** 관련된 유저들을 불러올 유저의 idno */
  idno: Scalars['String']['input'];
  /** 관계 타입 */
  type: UserRelationshipType;
};

export type UserRelationshipsOutput = ForbiddenError | UnknownError | UserRelationshipsSucceed;

/** 관련된 유저 리스트의 마지막 커서정보를 담고 있습니다. */
export type UserRelationshipsPageInfo = {
  __typename?: 'UserRelationshipsPageInfo';
  /** edges들의 마지막 커서 정보 */
  endCursor: Maybe<Scalars['String']['output']>;
};

/** 관련된 유저 리스트 조회 성공시 리턴 타입 */
export type UserRelationshipsSucceed = {
  __typename?: 'UserRelationshipsSucceed';
  /** 관련된 유저 리스트 커넥션 */
  connection: UserRelationshipsConnection;
};

/** 유저가 쓴 리뷰들의 카테고리 통계 input */
export type UserReviewGroupCategoriesInput = {
  /** 미디어 기준으로 리뷰그룹 필터 */
  mediaFilter?: InputMaybe<ReviewGroupsMediaFilter>;
  userIdno: Scalars['String']['input'];
};

/** 유저가 쓴 리뷰들의 카테고리 분류 타입 - 업종/지역 */
export enum UserReviewGroupCategoryType {
  /** 전체 분류 */
  All = 'ALL',
  /** 업종 메인 분류 (음식점 2depth+그외 업종) */
  PlaceCategoryMain = 'PLACE_CATEGORY_MAIN',
  /** 업종 메뉴 분류 (음식점 3-4depth) */
  PlaceCategoryMenu = 'PLACE_CATEGORY_MENU',
  /** 지역 읍면동 분류 */
  RegionDongmyun = 'REGION_DONGMYUN',
  /** 지역 시군구 분류 */
  RegionSigungu = 'REGION_SIGUNGU'
}

/** 유저가 작성한 리뷰그룹 connection */
export type UserReviewGroupsConnection = {
  __typename?: 'UserReviewGroupsConnection';
  /** 유저가 작성한 리뷰그룹 목록 */
  edges: Array<ReviewGroup>;
  /** 유저가 작성한 리뷰그룹 목록 페이지 정보 */
  pageInfo: UserReviewGroupsPageInfo;
};

/** 리뷰그룹 커서 정보 */
export type UserReviewGroupsConnectionInput = {
  /** after cursor, 이 다음부터 조회합니다. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** before cursor, 이 이전까지 조회합니다. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** 앞에서부터 최대 `first` 갯수만큼 가져옵니다. */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** 뒤에서부터 최대 `last` 갯수만큼 가져옵니다 */
  last?: InputMaybe<Scalars['Int']['input']>;
  /** 해당 id의 리뷰를 포함하여 이전과 이후의 항목들을 조회합니다. */
  reviewGroupId?: InputMaybe<Scalars['String']['input']>;
};

/** 유저가 작성한 리뷰그룹 input */
export type UserReviewGroupsInput = {
  categoryId?: InputMaybe<Scalars['String']['input']>;
  /** 날짜 및 시간 기준으로 리뷰그룹 필터 / 내 아이디 리뷰 그룹 조회시에만 적용 가능(pup users API) */
  dateTimeFilter?: InputMaybe<ReviewGroupsDateTimeFilterInput>;
  /** 미디어 기준으로 리뷰그룹 필터 */
  mediaFilter?: InputMaybe<ReviewGroupsMediaFilter>;
  /** 유저리뷰 필터링용 업종코드 */
  placeCategoryId?: InputMaybe<Scalars['String']['input']>;
  /** 유저리뷰 필터링용 지역코드 */
  regionCode?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<UserReviewGroupsSort>;
  /** 텍스트가 있는 리뷰그룹 필터링여부 */
  textFilter?: InputMaybe<ReviewGroupsTextFilter>;
  userIdno: Scalars['String']['input'];
};

export type UserReviewGroupsOutput = EntityError | UnknownError | UserReviewGroupsConnection;

/** 유저가 작성한 리뷰그룹 목록 페이지 정보 */
export type UserReviewGroupsPageInfo = {
  __typename?: 'UserReviewGroupsPageInfo';
  /** edges들의 마지막 커서 정보 */
  endCursor: Maybe<Scalars['String']['output']>;
  /** 다음 페이지 유무 */
  hasNextPage: Scalars['Boolean']['output'];
  /** 이전 페이지 유무 */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** edges들의 시작 커서 정보 */
  startCursor: Maybe<Scalars['String']['output']>;
};

/** 유저가 작성한 리뷰그룹 정렬 */
export enum UserReviewGroupsSort {
  /** 조회수 내림차순 정렬 */
  ViewCountDesc = 'VIEW_COUNT_DESC',
  /** 방문일 최신순 정렬 */
  VisitDateTimeDesc = 'VISIT_DATE_TIME_DESC'
}

export type UserStat = {
  __typename?: 'UserStat';
  /** 유저가 차단한 유저 수 */
  blockCount: Scalars['Int']['output'];
  /** 내가 팔로우 요청한 수 (본인이 아닌 경우 null) */
  followRequestCount: Maybe<Scalars['Int']['output']>;
  /** 나에게 들어온 팔로우 요청 수 (본인이 아닌 경우 null) */
  followRequesterCount: Maybe<Scalars['Int']['output']>;
  /** 유저의 팔로워 수 */
  followerCount: Scalars['Int']['output'];
  /** 유저의 팔로잉 수 */
  followingCount: Scalars['Int']['output'];
  /** 유저의 리뷰에 포함된 사진 수 (본인일 경우 비공개 포함) */
  imageCount: Scalars['Int']['output'];
  /** 유저의 총 사진 리뷰 수 (본인일 경우 비공개 포함) */
  imageReviewCount: Scalars['Int']['output'];
  /** 최근 30일간 리뷰 조회수 */
  last30DaysViewCount: Scalars['Int']['output'];
  /** 유저의 총 리뷰 갯수 (본인일 경우 비공개 포함) */
  reviewCount: Scalars['Int']['output'];
  /** 유저의 총 공개 테마리스트 갯수 */
  themelistCount: Scalars['Int']['output'];
  /** 전체 리뷰 조회수 */
  totalViewCount: Scalars['Int']['output'];
  /** 유저가 가진 스탬프 쿠폰 수 */
  usableCouponCount: Scalars['Int']['output'];
};

/** 유저의 테마리스트 input */
export type UserThemelistsInput = {
  userIdno: Scalars['String']['input'];
};

/** 유저 조회 실패시 리턴합니다. */
export type User_Failed = BaseError & {
  __typename?: 'User_Failed';
  /** 유저 조회시 실패 에러 코드 */
  code: UserError;
  message: Scalars['String']['output'];
};

/** 유저 조회 성공시 리턴합니다 */
export type User_Succeed = {
  __typename?: 'User_Succeed';
  user: User;
};

export type UsersOutput = UnknownError | Users_Succeed;

/** 유저 조회 성공시 리턴합니다 */
export type Users_Succeed = {
  __typename?: 'Users_Succeed';
  users: Array<Maybe<User>>;
};

/** 실험 변형 정보 */
export type Variant = {
  __typename?: 'Variant';
  /** 변형에서 다르게 설정하려는 속성 */
  feature: Scalars['String']['output'];
  /** 실험 변형명 */
  name: Scalars['String']['output'];
  /** 실험 세션 아이디 */
  sessionId: Maybe<Scalars['String']['output']>;
};

export type VariantOutput = AuthenticationError | UnknownError | Variant;

/** 동영상 다운로드 URL 입니다. */
export type VideoDownload = {
  __typename?: 'VideoDownload';
  /** 다운로드 URL 유효 시간입니다. (ms) */
  availableTime: Scalars['Int']['output'];
  /**
   * 동영상을 다운로드할 수 있는 URL 입니다. 해상도는 720P로 고정됩니다.
   * ⚠️ 만료 시간은 2시간입니다.
   */
  url: Scalars['URLString']['output'];
};

/** 동영상 다운로드 URL 조회 실패시 리턴합니다. */
export type VideoDownloadFailed = BaseError & {
  __typename?: 'VideoDownloadFailed';
  message: Scalars['String']['output'];
};

/** 동영상 다운로드 URL을 조회하기 위해 필요한 정보 */
export type VideoDownloadInput = {
  /**
   * 지원하는 동영상 해상도
   * ⚠️ 해상도는 720P로 고정합니다. 다른 값이 와도 무시됩니다.
   * [pup/api #2703](https://oss.navercorp.com/pup/api/pull/2703) 참고하세요.
   */
  resolution?: InputMaybe<VideoResolution>;
  /** pup에서 제공받은 동영상 아이디 (media id) */
  videoId: Scalars['String']['input'];
};

/** 비디오 다운로드 URL 관련 응답입니다. */
export type VideoDownloadOutput = VideoDownloadFailed | VideoDownloadSucceed;

/** 동영상 다운로드 URL 조회 성공시 리턴합니다. */
export type VideoDownloadSucceed = {
  __typename?: 'VideoDownloadSucceed';
  /** 동영상 다운로드 정보입니다. */
  download: VideoDownload;
};

/** 동영상 아이템입니다. */
export type VideoItem = MediaItem & {
  __typename?: 'VideoItem';
  /**
   * 동영상을 다운로드할 수 있는 URL 입니다. 해상도를 인자로 전달받습니다. (기본 720P)
   * ⚠️ 만료 시간은 2시간입니다.
   */
  download: Maybe<VideoDownload>;
  /** 동영상 재생시간(millisecond) */
  duration: Maybe<Scalars['Int']['output']>;
  /** 미디어 파일 형식 */
  format: Maybe<Scalars['String']['output']>;
  /** 미디어 이미지 세로 길이 */
  height: Maybe<Scalars['Int']['output']>;
  /** 동영상 아이디 */
  id: Scalars['ID']['output'];
  /** 대표 이미지 여부 */
  isCover: Maybe<Scalars['Boolean']['output']>;
  /** 불법 촬영물 여부 */
  isIllegalVideo: Maybe<Scalars['Boolean']['output']>;
  /**
   * 동영상 재생 정보입니다.
   * ⚠️ 만료 시간은 1시간입니다.
   */
  playback: Maybe<Playback>;
  /** 미디어 파일크기 */
  size: Maybe<Scalars['Int']['output']>;
  /** 동영상의 썸네일 URL */
  thumbnail: Scalars['URLString']['output'];
  /**
   * 트레일러 정보입니다.
   * ⚠️ 만료 시간은 9시간입니다.
   */
  trailer: TrailerOutput;
  /** 미디어의 타입 (`VIDEO`) */
  type: MediaType;
  /** 미디어 이미지 가로 길이 */
  width: Maybe<Scalars['Int']['output']>;
};


/** 동영상 아이템입니다. */
export type VideoItemDownloadArgs = {
  resolution?: InputMaybe<VideoResolution>;
};

/** 지원하는 동영상 해상도 */
export enum VideoResolution {
  /** 144P */
  Resolution_144 = 'RESOLUTION_144',
  /** 270P */
  Resolution_270 = 'RESOLUTION_270',
  /** 360P */
  Resolution_360 = 'RESOLUTION_360',
  /** 480P */
  Resolution_480 = 'RESOLUTION_480',
  /** 720P */
  Resolution_720 = 'RESOLUTION_720',
  /** 1080P */
  Resolution_1080 = 'RESOLUTION_1080'
}

export type Visit = {
  __typename?: 'Visit';
  /** 방문한 주문예약 서비스/업체 */
  business: Maybe<Business>;
  /** 방문 생성일 */
  createdDateTime: Scalars['DateTime']['output'];
  /** 페이징을 위한 커서 */
  cursor: Scalars['String']['output'];
  /** 방문카드에서 사용될 방문명 - 장소명 우선, 예약 방문의 경우 예약명이 될 수 있음 */
  displayName: Maybe<Scalars['String']['output']>;
  /** 해당 방문일의 공휴일 정보, 공휴일이 아닐 경우 null */
  holiday: Maybe<Holiday>;
  /** 방문 아이디 */
  id: Scalars['ID']['output'];
  /** @deprecated 사용하지 않는 필드 [comment](https://oss.navercorp.com/place/local/pull/13562#discussion_r2848752) */
  isPayProof: Scalars['Boolean']['output'];
  /** 리뷰에서 노출가능한 place CID인지 POV별로 판단 [wiki](https://wiki.navercorp.com/pages/viewpage.action?pageId=559503232) */
  isQualifiedPlaceCategory: Scalars['Boolean']['output'];
  /** 방문한 장소 */
  place: Maybe<Place>;
  /** 방문 소유주에게만 제공되는 정보 */
  private: Maybe<PrivateVisitInfo>;
  /** 방문에 대한 리뷰 */
  reviewGroup: Maybe<ReviewGroup>;
  /** 해당 장소/업체에 대한 방문 횟수 - 몇번째 방문인지 나타냄 */
  visitCount: Scalars['Int']['output'];
  /** 방문한 날짜 */
  visitedDateTime: Scalars['DateTime']['output'];
};

/** 예약 아이디로 방문 조회시 리턴하는 결과입니다. */
export type VisitByBookingIdOutput = AuthenticationError | UnknownError | VisitByBookingId_NotFound | VisitByBookingId_Succeed;

/** 예약 아이디를 가진 방문이 존재하지 않습니다 */
export type VisitByBookingId_NotFound = BaseError & {
  __typename?: 'VisitByBookingId_NotFound';
  /** 조회시 방문이 없을 경우 리턴하는 메세지 */
  message: Scalars['String']['output'];
};

/** 예약 아이디로 방문 조회 성공시 리턴합니다 */
export type VisitByBookingId_Succeed = {
  __typename?: 'VisitByBookingId_Succeed';
  /** 예약 아이디로 조회한 방문 정보 */
  visit: Visit;
};

/** 방문 키워드에 대한 카테고리 정보입니다. */
export type VisitCategory = {
  __typename?: 'VisitCategory';
  /** 방문 키워드에 대한 카테고리 코드입니다. */
  code: Scalars['String']['output'];
  /** 복수 선택 허용 여부입니다. */
  isMultiSelectAllowed: Scalars['Boolean']['output'];
  /** 방문 키워드에 대한 키워드 목록입니다. */
  keywords: Array<Keyword>;
  /** 방문 키워드에 대한 문항 정보입니다. */
  question: LocaleText;
  /** 방문 키워드에 대한 서브 타이틀입니다. */
  subTitle: LocaleText;
};

/** 방문 edge */
export type VisitEdge = {
  __typename?: 'VisitEdge';
  visit: Visit;
};

export type VisitHistoriesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  placeId: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  visitId?: InputMaybe<Scalars['String']['input']>;
};

export type VisitOutput = AuthenticationError | ForbiddenError | UnknownError | Visit_NotFound | Visit_Succeed;

export type VisitSubPlaceInput = {
  /** 장소 아이디 */
  id: Scalars['ID']['input'];
  /** 장소 이름 */
  name: Scalars['String']['input'];
};

export type VisitSubProofInput = {
  /** 선택된 pov의 아이디 입니다. ex. 영수증 아이디, 예약 아이디 */
  id: Scalars['ID']['input'];
  /** pov의 타입 */
  type: ProofType;
};

/** 방문이 존재하지 않을 때 리턴합니다. */
export type Visit_NotFound = BaseError & {
  __typename?: 'Visit_NotFound';
  /** 방문이 존재하지 않을 때 리턴하는 메세지 */
  message: Scalars['String']['output'];
};

/** 방문 조회 성공시 리턴합니다. */
export type Visit_Succeed = {
  __typename?: 'Visit_Succeed';
  /** 조회한 방문 정보 */
  visit: Visit;
};

/** 해당 년월에 해당하는 방문 리턴 타입 */
export type VisitsByYearMonthOutput = {
  __typename?: 'VisitsByYearMonthOutput';
  /** 해당 년월의 방문들 (최대 100개) */
  visits: Array<Visit>;
};

/** 선택할 수 있는 키워드 정렬 방식 */
export enum VotableKeywordsOrder {
  /** 랜덤으로 정렬합니다. */
  Random = 'RANDOM'
}

export type VotedKeywordInput = {
  /** 키워드의 카테고리 정보 ex) `food-price` */
  category: Scalars['String']['input'];
  /** 선택한 키워드의 코드 정보 */
  codes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** 가볼만한 곳 */
export type WorthPlace = {
  __typename?: 'WorthPlace';
  /** 블로그 리뷰 */
  blogReview: BlogReview;
  /** 장소 */
  place: Place;
  /** 관련 태그 */
  tags: Array<Scalars['String']['output']>;
};

/** 가볼만한 곳 조회시 입력값 */
export type WorthPlacesInput = {
  /** 지역코드 배열 */
  regionCodes: Array<Scalars['String']['input']>;
};

/** 가볼만한 곳 조회 응답 */
export type WorthPlacesOutput = UnknownError | WorthPlacesSucceed;

/** 가볼만한 곳 조회 성공시 응답 */
export type WorthPlacesSucceed = {
  __typename?: 'WorthPlacesSucceed';
  /** 가볼만한 곳 리스트 */
  worthPlaces: Array<WorthPlace>;
};
